/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mbc-core"] = factory();
	else
		root["mbc-core"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 117);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Base = __webpack_require__(6);
var Classes = __webpack_require__(8);
var Config = __webpack_require__(49);

/**
 * Canvas is in charge of create and calculate dimensions of the svg container where the chart is going to be rendered.
 * Also creates layers that holds chart's parts (axis, chart area, etc.)
 * @constructor
 * @param {D3.selection} container
 * @param {Object} margin
 */
var Canvas = Base.extend(
/**
 *  @lends Canvas.prototype
 **/
{
    /** @type {D3 selection} */
    selection: null,
    /** @type {Object} */
    margin: Config.canvasDefaults.margin,
    /** @type {Number} */
    axesSpacing: Config.canvasDefaults.axesSpacing,
    /** @type {Number} */
    axesPadding: 0,
    /** @type {DOM element} */
    container: null,
    /** @type {DOM element} */
    svg: null,
    /** @type {Number} */
    yAxesLabelWidth: 10,

    /**
     * Sets up the canvas object
     */
    initializer: function initializer() {
        var template = this.get("template");

        if (template && (typeof template === "string" || typeof template === "function")) {
            this.get("selection").html(template);
            this.set("container", this.get("selection").select("." + Classes.INNER)[0][0]);
            this.set("inner", true);
        } else {
            this.set("container", this.get("selection")[0][0]);
        }

        this.calculate();
        this.buildSVG();
    },

    /**
     * Update the canvas.
     * @return {Canvas} this Canvas object.
     */
    update: function update() {
        this.calculate();
        this.buildSVG();
        return this;
    },

    /**
     * Returns the width of chart inner container.
     * @return {Number} Inner container width.
     */
    width: function width() {
        return this.get("width");
    },

    /**
     * Returns the inner container height.
     * @return {Number} Inner container height.
     */
    height: function height() {
        return this.get("height");
    },

    /**
     * Returns the outer container width.
     * @return {Number} Outer container width.
     */
    outerWidth: function outerWidth() {
        return this.get("outerWidth");
    },

    /**
     * Returns the outer container height.
     * @return {Number} Outer container height.
     */
    outerHeight: function outerHeight() {
        return this.get("outerHeight");
    },

    /**
     * Calculates width and height of chart's area.
     */
    calculate: function calculate() {
        var selection = this.get("selection")[0][0];
        var container = this.get("container");
        var margin = this.get("margin");

        this.set("width", container.offsetWidth - margin.left - margin.right);
        this.set("height", container.offsetHeight - margin.top - margin.bottom);
        this.set("outerWidth", selection.offsetWidth);
        this.set("outerHeight", selection.offsetHeight);
    },

    /**
     * Appends the SVG Elements and set its dimensions.
     * @private
     */
    buildSVG: function buildSVG() {
        var svg = this.get("svg");
        var margin = this.get("margin");

        if (!svg) {
            svg = d3.select(this.get("container")).append("svg").attr("role", "chart").classed(Classes.CANVAS, true);
            this.set("svg", svg);
        }

        this.buildContainerGroups();
        svg.attrs({
            width: this.get("width") + margin.left + margin.right,
            height: this.get("height") + margin.top + margin.bottom
        });
    },

    /**
     * Build layered contaiers for each charts components in this order:.
     *
     * <li> Axes layer. </li>
     * <li> Behind chart layer. </li>
     * <li> Chart layer. </li>
     * <li> Front Chart layer. </li>
     * @private
     */
    buildContainerGroups: function buildContainerGroups() {
        var margin = this.get("margin");
        var svg = this.get("svg");
        var groups = svg.select("." + Classes.LAYERS);

        if (groups.empty()) {
            groups = svg.append("g").classed(Classes.LAYERS, true);

            this.set("axesGroup", groups.append("g").classed(Classes.AXES, true));
            this.set("backGroup", groups.append("g").classed(Classes.BACK, true));
            this.set("chartGroup", groups.append("g").classed(Classes.CHART_GROUP, true));
            this.set("frontGroup", groups.append("g").classed(Classes.FRONT, true));
        }

        groups.attrs({
            transform: "translate(" + margin.left + "," + margin.top + ")"
        });
    },

    /**
     * Returns a layer inside the chart area, if it does not exist creates it unless avoidCreate is true.
     *
     * @param {String} layerName
     * @param {String} groupName axes, back, front, chart.
     * @param {Boolean} avoidCreate
     * @returns {D3.Selection}
     */
    layer: function layer(layerName, groupName, avoidCreate) {
        groupName = (groupName || "chart") + "Group";
        var group = this.get(groupName);
        var layer = group.select("." + layerName);

        if (!avoidCreate && layer.empty()) {
            layer = group.append("g").classed(layerName, true);
        }

        return layer;
    },

    /**
     * Removes a layer inside the given group.
     *
     * @param {String} layerName
     * @param {String} groupName axes, back, front, chart.
     * @returns {D3.Selection}
     */
    removeLayer: function removeLayer(layerName, groupName) {
        groupName = (groupName || "chart") + "Group";
        var group = this.get(groupName);
        group.select("." + layerName).remove();
    },

    /**
     * Remove the old axes (if they exist) and add the new axes into the axes layer.
     *
     * @param {AxesManager} axesManager AxesManager containing updated axes.
     */
    drawAxes: function drawAxes(axesManager) {
        var axes = axesManager.axes();
        var axesCount = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
        var axesGroup = this.get("axesGroup");
        var yAxesLabelWidth = this.get("yAxesLabelWidth");
        var axesSpacing = this.get("axesSpacing") + yAxesLabelWidth;
        var axesPadding = this.get("axesPadding");
        var key, axis, translate, orient, count, tickSize, calc;

        axesGroup.selectAll("." + Classes.AXIS).remove();
        for (key in axes) {
            var _axesGroup$append$cla;

            axis = axes[key];
            orient = axis.orient();
            count = axesCount[orient];
            tickSize = axis.tickSize();

            switch (orient) {
                case "bottom":
                    translate = "translate(0, " + this.get("height") + ")";
                    break;
                case "right":
                    calc = axesPadding + (this.get("width") + count * (axesSpacing + tickSize));
                    translate = "translate(" + calc + ", 0)";
                    break;
                case "top":
                    translate = "translate(0, 0)";
                    break;
                case "left":
                    calc = 0 - axesPadding - count * (axesSpacing + tickSize);
                    translate = "translate(" + calc + ", 0)";
                    break;
                default:
                    break;
            }
            axesCount[orient]++;
            axesGroup.append("g").classed((_axesGroup$append$cla = {}, _defineProperty(_axesGroup$append$cla, Classes.AXIS, true), _defineProperty(_axesGroup$append$cla, Classes.AXIS + "-" + key, true), _defineProperty(_axesGroup$append$cla, Classes.AXIS + "-" + orient, true), _axesGroup$append$cla)).attr("transform", translate).call(axis);
        }
    },
    /**
     * Removes the canvas from the container and reset the watchers object.
     */
    remove: function remove() {
        this.unwatchAll();
        this.get("selection").selectAll("*").remove();
    }
});

module.exports = Canvas;

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var Utils = __webpack_require__(3);

/**
 * Creates a new DataManager instance.
 * @example
 * var dataManager = new DataManager();
 * @constructor
 */
function DataManager() {
    /**
     * @type {Array}
     * @private
     */
    this._data = [];
    /**
     * @type {Object}
     * @private
     */
    this._parsers = {};
    /**
     * @type {Number} Integer that holds the next index to assign
     * @private
     */
    this._nextIndex = 0;
}

/**
 * Gets all series attributes as parameters and returns a series object. This is intended to mantain legacy with previos versions.
 *
 * @param {String} seriesName Identifier for the series. Required.
 * @param {Array} series Array containing the series values. Required.
 * @param {String} groupName Identifier used to group series.
 * @param {Boolean} notIndexable If it is true the series is not indexed into the data manager.
 * @param {String} displayName String to be displayed.
 * @returns {Object} Series object
 */
function getSetAttributes(args) {
    var seriesName, series, groupName, notIndexable, displayName;
    seriesName = args[0];
    series = args[1];
    groupName = args[2];
    notIndexable = args[3];
    displayName = args[4];

    if (!seriesName || !series) {
        return;
    }

    return {
        name: seriesName,
        series: series,
        group: groupName,
        notIndexable: notIndexable,
        display: displayName
    };
}

/**
 * Recalculate indexed series indexes.
 *
 * @param {Array} data Array of series object.
 */
function recalcIndexes(data) {
    data.forEach(function (dataItem, i) {
        if (dataItem.index !== -1) {
            dataItem.index = i;
        }
    });
}

/**
 * Recalculate in-group indexes.
 *
 * @param {any} groupArray
 */
function recalcGroupIndexes(groupArray) {
    groupArray.forEach(function (item, i) {
        item.groupIndex = i;
    });
}

/**
 * Adds a series to the data manager. Receives an <i>Options Object</i> this way:
 * <br><br>
 * <code>
 * {
 *   name: "green_apples" // String
 *   series: [10, 20, 30, 40], // Array
 *   group: "Fruits",
 *   display: "Green Apples",
 *   notIndexable: false
 * }
 * </code>
 * <br>The <b>name</b> is the identifier for each series.
 * <br>The <b>series</b> Array is not necessary an array of number, it can be an array of objects with data.
 * <br><b>group</b> identifier is for data aggrupation if is not passed then <i>name</i> is used as group.
 * <br><b>display</b> is the text to show. If not passed then <i>name</i> is used as display name.
 * <br>If <b>notIndexable</b> is false, then the series is being indexed, non indexed series has index equals to -1.
 * <br><br>
 * For each series the datamanager creates a <i>Series Object</i> like:
 * <code>
 * {
 *   name: "green_apples",
 *   series: [10, 20, 30, 40],
 *   groupName: "Fruits",
 *   displayName: "Green Apples",
 *   index: 0,
 *   groupIndex: 0
 * }
 * </code>
 * @example
 * var dataManager = new DataManager();
 * // Minimal
 * dataManager.set({
 *   name: "Bar Chart Data",
 *   series: [40, 50, 60, 25]
 * });
 *
 * // If you need grouped data for a grouped bar chart for example.
 *
 * dataManager.set(
 *   name: "apples",
 *   display: "Apples",
 *   series: [25, 45, 43, 20],
 *   group: "grouped-bar-chart-data"
 * });
 *
 * dataManager.set({
 *   name: "oranges",
 *   display: "Oranges",
 *   series: [5, 20, 16, 27],
 *   group: "grouped-bar-chart-data"
 * });
 *
 * @param {Object} options Set of options.
 */
DataManager.prototype.set = function (options) {
    var groupName, groupIndex;
    if (!options) {
        return;
    }

    // For legacy purposes.
    if (typeof options === "string") {
        options = getSetAttributes(arguments);
        if (typeof options === "undefined") {
            return;
        }
    }

    groupName = options.group || options.name;
    groupIndex = this.queryGroup(groupName).length;

    this._data.push({
        name: options.name,
        series: options.series,
        groupName: groupName,
        displayName: options.display || options.name,
        index: !options.notIndexable ? this._nextIndex++ : -1,
        groupIndex: groupIndex,
        color: options.color
    });
};

/**
 * Unindexed Set, Same of set method but without set index to data, assing index = -1
 * Adds an unindexed series to the data manager. Receives an <i>Options Object</i> this way:
 * <br><br>
 * <code>
 * {
 *   name: "green_apples" // String
 *   series: [10, 20, 30, 40], // Array
 *   group: "Fruits",
 *   display: "Green Apples",
 * }
 * </code>
 * <br>The <b>name</b> is the identifier for each series.
 * <br>The <b>series</b> Array is not necessary an array of number, it can be an array of objects with data.
 * <br><b>group</b> identifier is for data aggrupation if is not passed then <i>name</i> is used as group.
 * <br><b>display</b> is the text to show. If not passed then <i>name</i> is used as display name.
 * @see set
 * @param {Object} options Set of options.
 */
DataManager.prototype.uset = function (options) {
    if (typeof options === "string") {
        options = getSetAttributes(arguments);
        if (typeof options === "undefined") {
            return;
        }
    }

    options.notIndexable = true;
    this.set(options);
};

/**
 * Update the series data specified by <i>seriesName</i>.
 * @example
 * dataManager.update("Apples", [2, 4, 6, 8]);
 * @param {String} seriesName Name of the series to update.
 * @param {Array} series Array of data to update.
 */
DataManager.prototype.update = function (seriesName, series) {
    var query = this._data.filter(function (series) {
        return series.name === seriesName;
    });

    var item;

    if (query.length) {
        item = query[0];
        item.series = series;
    }
};

/**
 * Removes a series from the data manager based on the series name.
 *
 * @param {String} seriesName Identifier of the series to remove.
 *
 * @return {Object} Removed Series Object.
 */
DataManager.prototype.remove = function (seriesName) {
    var index = Utils.array.indexOf(this._data, "name", seriesName);
    this._nextIndex = 0;
    var removed;
    if (index !== -1) {
        removed = this._data.splice(index, 1);

        // Recalculate general indexes
        recalcIndexes(this._data);

        // Recalculate group indexes
        recalcGroupIndexes(this.queryGroup(removed[0].groupName));
    }

    return removed;
};

/**
 * Resets the Datamanager.
 */
DataManager.prototype.clean = function () {
    this._data = [];
    this._parsers = {};
    this._nextIndex = 0;
};

/**
 * Search for the series in a determined group.
 *
 * @param {String} groupName Name of the group to search.
 * @returns {Array<Object>} Series in the group
 */
DataManager.prototype.queryGroup = function (groupName) {
    return this._data.filter(function (series) {
        return series.groupName === groupName;
    });
};

/**
 * If no parser is setted for the group then returns the raw data array from the store.
 * <br><br>
 * If parser is setted, then returns the data parsed by the function.
 *
 * @example
 * function parser(data, domain) {
 *   // data contains an array of series objects {}
 *   // domain is an argument
 *   var map = domain.map(function (point, i) {
 *       var obj = { point: point };
 *
 *       obj.values = data.map(function (value) {
 *           return {
 *               series: value.name,
 *               value: value.series[i]
 *           };
 *       });
 *       return obj;
 *   });
 *   return map;
 * }
 *
 * dataManager.parser("grouped-bar-chart-data", parser, ["Mon", "Tue", "Wed", "Thu"]);
 * var data = dataManager.get("grouped-bar-chart-data";
 * //  Resultingdata:
 * //  [{
 * //      point: "Mon",
 * //      values: {[
 * //          series: "Apples",
 * //          value: 25
 * //      ],[
 * //          series: "Oranges",
 * //          value: 5
 * //      ]...}
 * //  } ...]
 *
 * @param {any} groupName
 * @returns {Array} Array that contains data.
 */
DataManager.prototype.get = function (groupName) {
    if (!groupName) {
        return;
    }

    var data = this.queryGroup(groupName);
    var parser = this._parsers[groupName];
    var args;

    if (!parser) {
        return data;
    } else {
        args = [data].concat(parser.arguments);
        return parser.fn.apply(this, args);
    }
};

/**
 * Calculates the domain for the groups in _groupArray_, if not _groupArray_ is specified calculates for all data in the store.
 * <br><br>
 * Also rounds the domains to the nearest tenth (by default) or by the value specified in _roundDomainTo_.
 * @example
 * // There are 3 data groups: datagroup-1, datagroup-2 and datagroup-3.
 *
 * // Calculates domain only for groups datagroup-1 and datagroup-3.
 * var domain = dataManager.calculateDomain({
 *    groups: ["datagroup-1", "datagroup-2"]
 * });
 *
 * // Calculates domain for all groups.
 * var domain = dataManager.calculateDomain();
 *
 * // Calculates domain for all groups and round it to hundreds.
 * var domain = dataManager.calculateDomain({
 *  roundTo: 100
 *});
 *
 * // Calculates domain only for datagroup-3 and round it to hundreds.
 * var domain = dataManager.calculateDomain({
 *   groups: ["datagroup-3"],
 *   roundTo: 1000
 * });
 * @param {Object}? options Options available:
 * <li><b>groups:</b> Optional. Array of names of the data groups to include in the domain calculation.
 * <li><b>roundTo:</b> Optional. roundTo 10, 100, 1000, etc.
 * <li><b>forceNegative:</b> Optional. Boolean value to force negative values on the domain
 * <li><b>symmetrical:</b> Optional.
 * <li><b>steps:</b> Optional. Intended ticks number.
 * <li><b>accessor:</b> Optional. To access data.
 * <li><b>raw:</b> Optional. Force the domain calculation using unrounded values.
 *
 * @returns {Array} An array of length 2 with the calculated domain
 */
DataManager.prototype.calculateDomain = function (options) {
    options = options || {};
    var _this = this;
    var values = [];
    var groupArray = options.groups;
    var domainOptions = {
        forceNegative: options.forceNegative,
        symmetrical: options.symmetrical,
        steps: options.steps,
        integers: options.integers,
        raw: options.raw
    };

    // If not defined get all groups
    if (!groupArray) {
        groupArray = Utils.array.removeDuplicates(this._data.map(function (data) {
            return data.groupName;
        }));
    }

    groupArray.forEach(function (group) {
        var query = _this.queryGroup(group);
        var series;

        var accessorMap = function accessorMap(item, accessor) {
            return item.series.map(function (d) {
                return Utils.object.extract(d, accessor);
            });
        };

        if (options.stacked) {
            series = query.map(function (item) {
                if (options.accessor) {
                    return accessorMap(item, options.accessor);
                } else {
                    return item.series;
                }
            });

            values = values.concat(Utils.array.getStackedValues(series));
        } else {
            query.forEach(function (item) {
                if (options.accessor) {
                    values = values.concat(accessorMap(item, options.accessor));
                } else {
                    values = values.concat(item.series);
                }
            });
        }
    });

    // check values
    values = values.map(function (value) {
        return typeof value !== "undefined" ? value : 0;
    });

    var min = d3.min(values);
    var max = d3.max(values);
    var highest;
    var forceNegative = options.forceNegative;

    if (min === 0 && max === 0) {
        return forceNegative ? [-1, 1] : [0, 1];
    }

    if (max % 10 === 0) {
        values.push(max + 10);
    }

    if (min < 0 && min % 10 === 0) {
        values.push(min - 10);
    }

    if (typeof options.roundTo === "number") {
        domainOptions.roundTo = options.roundTo;
    } else if (min > -1 && max < 1) {
        return min < 0 || forceNegative ? [-1, 1] : [0, 1];
    } else if (max < 10 && min > -10) {
        highest = Math.max(Math.abs(min), Math.abs(max));
        domainOptions.roundTo = highest % 2 === 0 ? highest % 6 === 0 ? 4 : 3 : 2;
    } else {
        domainOptions.roundTo = Utils.array.getRoundToUnits(values);
    }

    domainOptions.values = values;
    return Utils.chart.getDomain(domainOptions);
};

/**
 * Sets a parser (formatter) function for a determined group of data. If arguments are passed they are passed too to the parser function as parameters.
 *
 * @param {any} groupName
 * @param {any} parser
 * @returns {Function} If only one argument is passed
 */
DataManager.prototype.parser = function (groupName, parser) {
    var newParser;
    if (!groupName) {
        return;
    }

    if (!parser) {
        return this._parsers[groupName];
    }

    newParser = {};
    newParser.fn = parser;
    newParser.arguments = Array.prototype.slice.call(arguments, 2);

    this._parsers[groupName] = newParser;
    return parser;
};

/**
 * Returns all data combined
 * @example
 *  dataManager.set("Cars", [10, 20], "vehicles");
 *  dataManager.set("Planes", [30, 40], "vehicles");
 *  dataManager.set("Tricycle", [5, 15], "tricycle");
 *
 *  dataManager.combine("tricycle")
 *  dataManager.combine(["vehicles", "tricycle"])
 *
 * @param {Array|String} groupNames The name of a group name or an array containing all group names you want to get data combined.
 * @return {Array} Data combined.
 */
DataManager.prototype.combine = function (groupNames) {
    var metadataArray = [];
    var seriesArray = [];
    var combined = [];
    var i = 0;
    var j = 0;
    var len, pointObj, seriesLength, metadata, value;
    groupNames = typeof groupNames === "string" ? [groupNames] : groupNames;
    groupNames.forEach(function (seriesObject) {
        this.queryGroup(seriesObject).forEach(function (point) {
            seriesArray.push(point.series);
            metadataArray.push({
                name: point.name,
                groupName: point.groupName,
                displayName: point.displayName,
                index: point.index,
                groupIndex: point.groupIndex
            });
        });
    }.bind(this));

    len = seriesArray[0].length;
    seriesLength = seriesArray.length;

    for (; i < len; i++) {
        pointObj = [];
        j = 0;
        for (; j < seriesLength; j++) {
            value = seriesArray[j][i];
            metadata = metadataArray[j];
            pointObj.push({
                name: metadata.name,
                groupName: metadata.groupName,
                displayName: metadata.displayName,
                index: metadata.index,
                value: value,
                groupIndex: metadata.groupIndex
            });
        }

        combined.push(pointObj);
    }

    return combined;
};

/**
 * Returns <b>true</b> if a series is contained in a give group.
 * @param {String} seriesName
 * @param {String} groupName
 * @returns {Boolean}
 */
DataManager.prototype.inGroup = function (seriesName, groupName) {
    var group = this.queryGroup(groupName);
    var len = group.length;
    var i;

    for (i = 0; i < len; i++) {
        if (group[i].name === seriesName) {
            return true;
        }
    }

    return false;
};

module.exports = DataManager;

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(16);


/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Creates a new ScaleManager instance.
 *
 * @constructor
 * @param {Object} scales
 */

function ScaleManager(scales) {
    this._scales = scales || {};
}

/**
 * Sets a new scale, if no <i>scale</i> is passed then returns the scale object.
 *
 * @param {String} scaleName Name for the scale.
 * @param {D3.scale} scale
 * @returns {D3.scale}
 */
ScaleManager.prototype.scale = function (scaleName, scale) {
    if (!scaleName) {
        return;
    }

    if (!scale) {
        return this._scales[scaleName];
    }

    this._scales[scaleName] = scale;
};

/**
 * Sets the scale's domain, if no <i>domain</i> is passed returns it.
 *
 * @param {String} scaleName
 * @param {Array} domain
 * @returns {Array} Domain for a specific scale.
 */
ScaleManager.prototype.domain = function (scaleName, domain) {
    if (!scaleName) {
        return;
    }

    if (!domain) {
        return this._scales[scaleName].domain();
    }

    this._scales[scaleName].domain(domain);
};

/**
 * Sets the scale's range, if no _range_ is passed returns it.
 *
 * @param {String} scaleName
 * @param {Array} range
 * @returns Range for a specific scale.
 */
ScaleManager.prototype.range = function (scaleName, range) {
    if (!scaleName) {
        return;
    }

    if (!range) {
        return this._scales[scaleName].range();
    }

    this._scales[scaleName].range(range);
};

/**
 * Remove a scale from the hashmap.
 * @param {String} scaleName Scale to remove.
 */
ScaleManager.prototype.remove = function (scaleName) {
    delete this._scales[scaleName];
};

module.exports = ScaleManager;

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @module Core */

var AxesManager = __webpack_require__(9);
var Canvas = __webpack_require__(10);
var Chart = __webpack_require__(38);
var DataManager = __webpack_require__(11);
var Base = __webpack_require__(6);
var ScalesManager = __webpack_require__(12);
var Utils = __webpack_require__(3);
var Classes = __webpack_require__(8);
var d3Overrides = __webpack_require__(50);
var Axes = __webpack_require__(40);

// D3 overrides
d3Overrides();

module.exports = {
  /**
   * @see AxesManager
   */
  AxesManager: AxesManager,
  /**
   * @see Canvas
   */
  Canvas: Canvas,
  /**
   * @see Chart
   */
  Chart: Chart,
  /**
   * @see Base
   */
  Base: Base,
  /**
   * @see ScalesManager
   */
  ScalesManager: ScalesManager,
  /**
   * @see DataManager
   */
  DataManager: DataManager,
  /**
  * @see Utils
  */
  Utils: Utils,
  /**
   * @see Classes
   */
  Classes: Classes,
  /**
  * @see Axes
  */
  Axes: Axes
};

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extract = __webpack_require__(2).extract;
/**
 * Returns true if an array contains just null values. If the parameter is a falsey value returns undefined.
 * @example
 * Util.array.hasNulls([null, null, null]) // returns true
 *  @param {Array} arr Array to inspect.
 * @return {Boolean} true means that the array contains null values.
 **/
var hasNulls = function hasNulls(arr) {
    if (!arr) return;
    var len = arr.length;
    var i = 0;
    for (; i < len; i++) {
        if (arr[i] !== null) {
            return false;
        }
    }

    return true;
};

/**
 * Returns false if the array passed contains negative values.
 *
 * @param {Array<Number>} allValues Numeric array.
 * @return {Boolean} Boolean indicating if the array contains at least one negative value.
 */
var hasNegative = function hasNegative(allValues) {
    if (!allValues) return;
    return d3.min(allValues) < 0;
};

/**
 * Return a new array with absolute numbers.
 * @param {Array<Number>} allValues Input array of numbers.
 */
var getAllPositives = function getAllPositives(allValues) {
    return allValues.map(function (val) {
        return Math.abs(val);
    });
};

/**
 * Rmoves duplicates from an array.
 *
 * @export
 * @param {Array} array Source array.
 * @returns {Array} Array without duplicates.
 */
var removeDuplicates = function removeDuplicates(array) {
    if (!array) return;
    return array.filter(function (elem, index, _this) {
        return index === _this.indexOf(elem);
    });
};

var indexOf = function indexOf(array, property, search) {
    var i, len;
    for (i = 0, len = array.length; i < len; i++) {
        if (array[i][property] === search) return i;
    }

    return -1;
};

/**
 * Returns and array with all values stacked by index, it includes negative and positive values
 * @param {Array} arrays Array of arrays containig series values.
 * @return {Array} Array with all values.
 */
var getStackedValues = function getStackedValues(arrays) {
    var i = 0;
    var j = 0;
    var arrLength = arrays.length;
    var length = -1;
    var positive = 0;
    var negative = 0;
    var stacked = [];
    var actualLength, value;

    // Check array lengths
    for (; i < arrLength; i++) {
        actualLength = arrays[i].length;
        if (length !== -1 && actualLength !== length) {
            throw new Error("Arrays must have the same length");
        }

        length = actualLength;
    }

    i = 0;
    for (; i < length; i++) {
        for (; j < arrLength; j++) {
            value = arrays[j][i];
            if (value >= 0) {
                positive += value;
            } else {
                negative += value;
            }
        }

        stacked.push(Math.round(positive));
        if (negative !== 0) stacked.push(Math.round(negative));
        positive = 0;
        negative = 0;
        j = 0;
    }

    return stacked;
};

/**
 * It searches for the min and max value inside an array.
 *
 * @param {any} array
 * @param {any} accesor
 * @returns Object
 */
function minmax(array, accesor) {
    var len = array.length;
    var i = 0;
    var obj, value, min, max, minValue, maxValue;
    for (; i < len; i++) {
        obj = array[i];
        value = extract(obj, accesor);

        if (typeof minValue === "undefined" || value < minValue) {
            minValue = value;
            min = array[i];
        }

        if (typeof maxValue === "undefined" || value > maxValue) {
            maxValue = value;
            max = array[i];
        }
    }

    return { min: min, max: max };
}

/**
 * It returns the thousandths, hundredths, tenths, hundred, thousands to round the domain.
 *
 * @param {Number[]} array Array of numbers.
 * @return {Number} 0.001, 0.01, 0.1, 1, 10, 100, 1000, ...
 */
function getRoundToUnits(array) {
    if (!array || !array.length) return 1;
    var absMean = d3.mean(array, function (d) {
        return Math.abs(d);
    });

    if (absMean === 0) return 1;
    if (absMean >= 1) {
        absMean = Math.ceil(absMean / 10);
        return Math.pow(10, ("" + absMean).length);
    } else {
        var decimals = ("" + absMean).split(".")[1];
        var match = decimals.match(/[^0]/);
        return 1 / Math.pow(10, match.index + 1);
    }
}

module.exports = {
    getAllPositives: getAllPositives,
    getRoundToUnits: getRoundToUnits,
    getStackedValues: getStackedValues,
    hasNegative: hasNegative,
    hasNulls: hasNulls,
    indexOf: indexOf,
    minmax: minmax,
    removeDuplicates: removeDuplicates
};

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



__webpack_require__(98);

var _core = __webpack_require__(13);

var _core2 = _interopRequireDefault(_core);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module Core */

module.exports = _core2.default;

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Given a path it extract a value from a complex deep object.
 *
 * @param {Object} obj
 * @param {String} path
 * @returns Object's value found in the given path.
 */

function getPath(obj, path) {
    var index, prefix, subpath;
    if (!obj || !path || typeof path !== "string" || path === "") {
        return;
    }

    index = path.indexOf(".");
    if (index === -1) {
        return obj[path];
    } else {
        prefix = path.substring(0, index);
        subpath = path.substring(index + 1);
        return getPath(obj[prefix], subpath);
    }
}

/**
 * Copy source object properties into a target one.
 *
 * @export
 * @param {Object} target Target object.
 * @param {Object} source Source Object
 */
var copy = function copy(target) {
    var key, source;

    if (!target) {
        return;
    }

    for (var i = 1; i < arguments.length; i++) {
        source = arguments[i];
        for (key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
};

/**
 * Extracts a value using an accessor or the same value if no accessor.
 * @param {Object} item Contains the value.
 * @param {Function|String}? accessor Accesor function or field that contains the value.
 * @param {Object} params Parameters to pass to the accesor function.
 * @return {Object} Value.
 */
var extract = function extract(item, accessor, params) {
    var value;
    if (typeof accessor === "undefined") {
        value = item;
    } else if (typeof accessor === "function") {
        value = accessor(item, params);
    } else if (typeof accessor === "string") {
        value = item[accessor];
    }

    return value;
};

/**
 * Clones and object.
 *
 * @export
 * @param {Object} target Object toclone.
 * @returns {Object} Cloned object.
 */
var clone = function clone(target) {
    if (target === undefined || target === null) {
        throw new TypeError("Cannot convert first argument to object");
    }

    var to = Object(target);
    for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) {
            continue;
        }

        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
                to[nextKey] = nextSource[nextKey];
            }
        }
    }

    return to;
};

/**
 * If just the value is passed return a boolean indicated is the value is undefined.
 * If the second parameter exists if value is undefined retunrs the second parameter, if not returns the value.
 * @param {Obect} value Object to evaluate.
 * @param {Object} defaultValue Object to return in case vale¡ue is undefined.
 */
var isUndefined = function isUndefined(value, defaultValue) {
    if (typeof defaultValue !== "undefined") return typeof value === "undefined" ? defaultValue : value;else return typeof value === "undefined";
};

/**
 * Check if the given value is not a number then return null, if it is a number return the number.
 * @param {Object} val Value to check.
 * @returns {undefined|Number}
 */
var NaNtoNull = function NaNtoNull(val) {
    if (typeof val !== "number" || isNaN(val) || val === Infinity) {
        return null;
    } else {
        return val;
    }
};

/**
 * Method to get the boolean value, if not it returnd a default value.
 * @param {Object} value Value to check if it is a boolean.
 * @param {Boolean} defaultValue Default value in case value is not a boolean.
 * @returns {Boolean}
 */
var getBoolean = function getBoolean(value, defaultValue) {
    return typeof value === "boolean" ? value : defaultValue;
};

var assign = function assign(target) {
    // .length of function is 2
    if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
            // Skip over if undefined or null
            for (var nextKey in nextSource) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                    to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
};

module.exports = {
    clone: clone,
    copy: copy,
    extract: extract,
    getBoolean: getBoolean,
    isUndefined: isUndefined,
    NaNtoNull: NaNtoNull,
    path: getPath,
    assign: assign
};

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var array = __webpack_require__(14);
var chart = __webpack_require__(41);
var fn = __webpack_require__(45);
var object = __webpack_require__(2);
var str = __webpack_require__(47);
var svg = __webpack_require__(48);
var colors = __webpack_require__(42);
var number = __webpack_require__(46);
var generators = __webpack_require__(44);

/** @module Core/Utils */

module.exports = {
    assign: object.assign,
    callFn: fn.call,
    clone: object.clone,
    convertDashToEnDash: str.convertDashToEnDash,
    copy: object.copy,
    dashify: str.dashify,
    extract: object.extract,
    getBoolean: object.getBoolean,
    getDomain: chart.getDomain,
    getGreaterSVGTextWidth: svg.getGreaterSVGTextWidth,
    getRoundToUnits: array.getRoundToUnits,
    getStackedValues: array.getStackedValues,
    getSVGTextWidth: svg.getSVGTextWidth,
    getTickValues: chart.getTickValues,
    hasNegative: array.hasNegative,
    indexOf: array.indexOf,
    isUndefined: object.isUndefined,
    minmax: array.minmax,
    NaNtoNull: object.NaNtoNull,
    removeDuplicates: array.removeDuplicates,
    template: str.template,
    UID: str.UID,

    array: array,
    chart: chart,
    fn: fn,
    object: object,
    string: str,
    svg: svg,
    colors: colors,
    number: number,
    generators: generators
};

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AxesManager = __webpack_require__(9);
var Base = __webpack_require__(6);
var Canvas = __webpack_require__(10);
var DataManager = __webpack_require__(11);
var ScalesManager = __webpack_require__(12);
var Utils = __webpack_require__(3);
var Classes = __webpack_require__(8);

/**
 * A foundation for all axed charts.
 * The renderng cycle is:
 * <em><br>0- setData() Data is initialized.
 * <br>1- beforeDraw() method is called. Event <i>beforeDraw</i> is triggered.
 * <br>2- draw() method is called.
 * <br>3- afterDraw() method called. Event <i>afterDraw</i> is triggered.</em>
 * <br><br><small>Methods setData() and draw() MUST be implemented</small>
 * @example
 * var BarChart = Chart.extend({
 *  ...
 * })
 * @param {Object} options
 * @class
 * @extends Base
 */
var Chart = Base.extend(
/**
 * A foundation for all axed charts.
 *  @lends Chart.prototype
 **/
{
    /** @type {String} */
    UID: null,
    /** @type {AxisManager} */
    axes: null,
    /** @type {Canvas} */
    canvas: null,
    /** @type {DataManager} */
    data: null,
    /** @type {Array} */
    colors: Utils.colors.combined,
    /** @type {D3.dispatch} */
    dispatch: null,
    /** @type {ScaleManager} */
    scales: null,
    /** @type {Object} */
    margins: { top: 20, right: 40, bottom: 30, left: 40 },
    /** @type {String} */
    canvasTemplate: null,
    /** @type {Number} */
    yAxesLabelWidth: 0,
    /** @type {String} */
    legendPopoverParentElement: 'body', // pass string selector id including # (e.g. '#line-chart-container') or class including . (e.g. '.mbc-line-chart') of element to append popover

    /**
     * Initializes the chart.
     */
    initializer: function initializer() {
        this.set("UID", "mbc" + Utils.string.UID());
        this.set("axes", new AxesManager());
        this.set("data", new DataManager());
        this.set("dispatch", d3.dispatch("hover", "click", "afterDraw", "beforeDraw", "mouseout"));
        this.set("scales", new ScalesManager());
        d3.rebind(this, this.get("dispatch"), "on");
    },

    /**
     * Returns the function D3 calls to set the data.
     * @example
     * container.datum(dataset).call(chart.init());
     *
     * @returns {Function}
     */
    init: function init() {
        return this._createChart.bind(this);
    },
    /**
     * Adds a new Canvas object and calls the _prepare function for each selection
     * @param {D3.Selection} name Selection where the charts are going to be created.
     * @private
     */
    _createChart: function _createChart(selection) {
        var _selection$classed;

        this.set("selection", selection);
        selection.classed((_selection$classed = {}, _defineProperty(_selection$classed, this.get("id") || "", true), _defineProperty(_selection$classed, this.get("UID"), true), _selection$classed));
        this._createCanvas();
        selection.each(this._prepare.bind(this));
    },

    /**
     * Create and set a new canvas instance.
     */
    _createCanvas: function _createCanvas() {
        var selection = this.get("selection");
        // beforeCanvas method is called if exists.
        Utils.fn.call(this, this.beforeCanvas, selection);
        this.set("canvas", new Canvas({
            selection: selection,
            margin: this.get("margins"),
            template: this.get("canvasTemplate"),
            yAxesLabelWidth: this.get("yAxesLabelWidth"),
            UID: this.get("UID")
        }));
    },

    /**
     * Calls the setData or/and setup function if they exist and calls the rendering cycle if the data is valid.
     * @private
     */
    _prepare: function _prepare(data) {
        var invalidData = false;
        invalidData = Utils.fn.call(this, this.setup, data);
        /* FIXME: remove setData call next major version */
        invalidData = invalidData || Utils.fn.call(this, this.setData, data);
        if (!invalidData) this.update();
    },

    /**
     * Executes the rendering cycle in this order
     * <li> beforeDraw
     * <li> draw
     * <li> afterDraw
     */
    update: function update(options) {
        this.get("dispatch").beforeDraw();
        var updateCanvas = Utils.fn.call(this, this.beforeDraw, options);
        if (typeof updateCanvas === "undefined" || updateCanvas) this.get("canvas").update();
        this.draw(options);
        Utils.fn.call(this, this.afterDraw, options);
        this.get("dispatch").afterDraw();
    },

    /**
     * Returns the index *n* color from the *colors* attribute array
     * @param {Number} index Index of color to return
     */
    color: function color(index) {
        var colors = this.get("colors");
        return colors[index % colors.length];
    },

    /**
     * Returns a closure function with a formatter within.
     * @param {Function|String} format If it is a string uses d3.format.
     */
    tickFormat: function tickFormat(format) {
        return function (d, i) {
            if (!format) {
                return d;
            }

            return typeof format === "function" ? format(d, i) : d3.format(format)(d);
        };
    },

    /**
     * @abstract
     * @deprecated Use setup method instead.
     * Prepare the data for the chart and all the initial values prior to start rendering. Legacy.
     */
    setData: function setData() {},

    /**
     * @abstract
     * Prepare the data for the chart and all the initial values prior to start rendering.
     */
    setup: function setup() {},

    /**
     * @abstract
     * This method is called before creating the canvas instance, is useful to change the template before.
     */
    beforeCanvas: function beforeCanvas() {},

    /**
     * @abstract
     * This method is called before drawing the chart. Useful to prepare data when the SVG element is already inserted into the dom.
     */
    beforeDraw: function beforeDraw() {},

    /**
     * @abstract
     * Used to draw the chart into the SVG element.
     */
    draw: function draw() {
        console.error(new Error("draw method is not defined"));
    },

    /**
     * @abstract
     * Called after the chart is rendered. Useful to make post-render modifications.
     */
    afterDraw: function afterDraw() {},

    /**
     * Returns an id based class.
     * @param {String} suffix Suffix to add to the id.
     * @return {String} The class name (id + suffix).
     */
    getId: function getId(suffix) {
        return this.get("id") + "-" + suffix;
    },

    /**
     * @adjustYLabels
     * Visual adjustments after the chart has been rendered
     * appendYAbbreviation and adjustYAxisLabel
     */
    adjustYLabels: function adjustYLabels() {
        var axes = this.get("canvas").get("axesGroup");

        axes.selectAll(".x-alternative-first, .x-alternative-last").remove();

        axes.selectAll("." + Classes.AXIS + "-left .tick text, ." + Classes.AXIS + "-right .tick text").attrs({ x: 0, y: 12 });

        var y1Ticks = axes.selectAll("." + Classes.AXIS + "-y1 .tick");
        y1Ticks.first().classed("dark", true).select("text").attr("y", -10);

        y1Ticks.last().classed("dark", true);

        var y2Ticks = axes.selectAll("." + Classes.AXIS + "-y2 .tick");
        y2Ticks.first().classed("dark", true).select("text").attr("y", -10);

        y2Ticks.last().classed("dark", true);

        var y1TicksAlign = this.get("y1TicksAlign");
        var y1AxisOrient = this.get("y1AxisOrient");
        var y1Texts = axes.selectAll("." + Classes.AXIS + "-y1 text");
        if (y1TicksAlign === "right" && y1AxisOrient === "right") {
            y1Texts.attr("x", this.get("yTickSize")).style("text-anchor", "end");
        }

        if (y1TicksAlign === "left" && y1AxisOrient === "left") {
            y1Texts.attr("x", this.get("yTickSize") * -1).style("text-anchor", "start");
        }

        if (this.get("y2TicksAlign") === "right" && this.get("y2AxisOrient") === "right") {
            axes.selectAll("." + Classes.AXIS + "-y2 text").attr("x", this.get("yTickSize")).style("text-anchor", "end");
        }

        this.appendYAbbreviation(axes);

        this.adjustYAxisLabel("y1");
        if (this.get("y2")) {
            this.adjustYAxisLabel("y2");
        }
    },

    /**
     * Appends Y axes abbreviations under the up most tick.
     * Checks for 'y1Abbreviation' and 'y2Abbreviation.
     */
    appendYAbbreviation: function appendYAbbreviation(axes) {
        var appendAbbrev = function appendAbbrev(tick, abbrev, align) {
            var lastText = tick.select("text");
            tick.append("text").attrs({
                "text-anchor": align === "right" ? "end" : "start",
                x: lastText.attr("x"),
                y: lastText.attr("y") * 2 + 4,
                dy: lastText.attr("dy")
            }).classed("mbc-tick-abbreviation", true).text(abbrev);
        };

        var lastTick, textAlign;
        var y1Abbrev = this.get("y1Abbreviation"),
            y2Abbrev = this.get("y2Abbreviation");
        if (y1Abbrev) {
            lastTick = axes.selectAll("." + Classes.AXIS + "-y1 .tick").last();
            textAlign = this.get("y1TicksAlign");
            appendAbbrev(lastTick, y1Abbrev, textAlign);
        }

        if (this.get("y2") && y2Abbrev) {
            lastTick = axes.selectAll("." + Classes.AXIS + "-y2 .tick").last();
            textAlign = this.get("y2TicksAlign");
            appendAbbrev(lastTick, y2Abbrev, textAlign);
        }
    },

    /**
     * @adjustYAxisLabel
     * dynamic hide Y labels to avoid overlap
     * @param {String} yAxisName: "y1" or "y2"
     */
    adjustYAxisLabel: function adjustYAxisLabel(yAxisName) {
        var axes = this.get("canvas").get("axesGroup"),
            tickValues = this.get("axes").axis(yAxisName).tickValues(),
            axesTicks = axes.selectAll("." + Classes.AXIS + "-" + yAxisName + " .tick"),
            textSpacing = 23; // the height of tick text(18 + 0.32em)

        var lastPosition = 0,
            beforeLastPosition = 0,
            beforeLastShowedTickIndex = 0,
            lastShowedTickIndex = 0,
            showLastShowedTick = true,
            showBeforeLastShowedTick = true;

        axesTicks.style({
            opacity: function opacity(d, i) {
                var opacity = 0;
                var tickPosition = d3.transform(this.getAttribute("transform")).translate[1];
                var textTotalDy = parseFloat(this.lastChild.attributes.dy.value) * (this.childNodes.length - 1) * 14;
                var textDistance = +this.lastChild.attributes.y.value + textTotalDy;
                var currentPosition = tickPosition + textDistance;
                var distance = Math.abs(currentPosition - lastPosition);
                if (distance > textSpacing) {
                    opacity = 1;
                    beforeLastShowedTickIndex = lastShowedTickIndex;
                    lastShowedTickIndex = i;
                    beforeLastPosition = lastPosition;
                    lastPosition = currentPosition;
                }

                if (i === tickValues.length - 1 && opacity === 0) {
                    opacity = 1;
                    showLastShowedTick = false;
                    if (Math.abs(currentPosition - beforeLastPosition) < textSpacing) {
                        showBeforeLastShowedTick = false;
                    }
                }
                return opacity;
            }
        });

        if (!showLastShowedTick && showLastShowedTick !== 0) {
            d3.select(axesTicks[0][lastShowedTickIndex]).style({ opacity: 0 });
        }

        if (!showBeforeLastShowedTick && beforeLastShowedTickIndex !== 0) {
            d3.select(axesTicks[0][beforeLastShowedTickIndex]).style({ opacity: 0 });
        }
    },

    /**
     * Appends a Y axis label.
     * @param {Object} layer: "y1" or "y2"
     * @param {String} axisName: "y1" or "y2"
     * @param {String} text: y1AxisLabel or y2AxisLabel
     */
    appendYLabel: function appendYLabel(layer, axisName, text) {
        var yTickSize = this.get("yTickSize");
        var canvas = this.get("canvas");
        var axis = this.get("axes").axis(axisName);
        var isLeft = axis.orient() === "left";
        var axisSelector = Classes.AXIS + "-" + axisName;
        var anchor = isLeft ? "start" : "end";
        var rotation = isLeft ? 270 : 90;
        var axisLayer, translate, x, y, yLabel, svgText;
        var yAxesLabelPadding = this.get("yAxesLabelPadding");

        // Calculating
        axisLayer = canvas.layer(axisSelector, "axes", true);
        translate = d3.transform(axisLayer.attr("transform")).translate;
        x = isLeft ? translate[0] - yAxesLabelPadding - yTickSize : translate[0] + yTickSize + yAxesLabelPadding;
        y = canvas.height();

        yLabel = layer.append("g").attr(axisSelector + "-label", "axes").attr("transform", "translate(" + x + ", " + y + ")");

        svgText = yLabel.append("text").text(text).classed(axisSelector + "-label-text", "true").classed("mbc-y-axis-text", "true").attrs({
            "text-anchor": anchor,
            transform: "rotate(" + rotation + ")"
        });

        // dynamic abbreviate yAxisLabel if it is higher than container
        var labelText = svgText[0][0];
        var textHeight = Math.abs(labelText.clientWidth);
        if (textHeight > y) {
            var maxNum = Math.floor(y / (textHeight / text.length));
            labelText.innerHTML = text.substr(0, maxNum - 2) + "...";
        }
    }
});

module.exports = Chart;

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Core = __webpack_require__(13);
var Utils = __webpack_require__(3);
var Base = __webpack_require__(6);

var DateAxis = Base.extend({
    /*axis data*/
    domain: [],
    range: [0, 0],
    subLabels: [],

    /*axis style*/
    orient: 'bottom',
    labelSpacing: 10,
    font: '14px helvetica neue',
    rangeBandsPadding: 0.00,
    rangeBandsOuterPadding: 0.00,

    /*label format*/
    labelFormat: '%b',
    subLabelFormat: '%Y',
    subLabelDx: '-0.75em',
    tickFormat: null,

    timeLevel: 'monthly',

    //======================= initialize ==========================

    initializer: function initializer() {
        this._initData();
        this._initScale();
        this._initAxis();
    },

    _initData: function _initData() {

        var opDomain = this.get('domain');
        var labelInterval = this._calcLabelInterval();
        var subLabels = this._calcSubLabels(opDomain, labelInterval);

        this.set('labelInterval', labelInterval);
        this.set('subLabels', subLabels);

        //temporary handle way, will set a map to contain yearly, quarterly, monthly
        var timeLevel = this.get('timeLevel').toLowerCase();
        switch (timeLevel) {
            case 'quarterly':
                this.set('tickFormat', this.quarterlyTickFormat);
                this.set('subLabelDx', '-0.5em');
                break;

            case 'yearly':
                this.set('tickFormat', d3.time.format('%Y'));
                this.set('subLabels', []);
                break;

            default:
                this.set('tickFormat', d3.time.format(this.get('labelFormat')));
                break;
        }
    },

    _initScale: function _initScale() {
        var domain = this.get('domain'),
            range = this.get('range');

        var scale = d3.scale.ordinal().domain(domain).rangeBands(range, this.get('rangeBandsPadding'), this.get('rangeBandsOuterPadding'));

        this.set('scale', scale);
    },

    _initAxis: function _initAxis() {
        var scale = this.getScale(),
            orient = this.get('orient'),
            formatFun = this.get('tickFormat'),
            labelInterval = this.get('labelInterval'),
            getDate = this.getDate;

        var axis = d3.svg.axis().scale(scale).orient(orient).tickFormat(function (d, i) {

            if (i % labelInterval !== 0) {
                return '';
            }

            if (typeof formatFun === 'function') {
                return formatFun(getDate(d));
            }

            return d;
        });

        this.set('axis', axis);
    },

    _calcLabelInterval: function _calcLabelInterval() {
        var opDomain = this.get('domain'),
            range = this.get('range'),
            axisWidth = range[1] - range[0],
            spacing = this.get('labelSpacing'),
            labelFormat = d3.time.format(this.get('labelFormat')),
            getDate = this.getDate,
            maxTextWidth,
            maxLabelCount,
            labelInterval;

        maxTextWidth = this.calcMaxTextWidth(opDomain.map(function (item) {
            return labelFormat(getDate(item));
        }));

        //maxText * n + spacing * (n-1) < width;
        maxLabelCount = Math.floor((axisWidth + spacing) / (maxTextWidth + spacing));

        labelInterval = Math.ceil(opDomain.length / maxLabelCount);

        return labelInterval;
    },

    _calcSubLabels: function _calcSubLabels(domain, labelInterval) {
        if (!Array.isArray(domain)) {
            return [];
        }

        var subLabels = [];
        var timeFormat = d3.time.format;
        var subLabelFormat = timeFormat(this.get('subLabelFormat'));
        var getDate = this.getDate;

        domain.forEach(function (item, index) {
            var date = getDate(item);
            var label = subLabelFormat(date);

            if (index % labelInterval === 0 && subLabels.indexOf(label) === -1) {
                subLabels.push(label);
            } else {
                subLabels.push(null);
            }
        });

        return subLabels;
    },

    //======================== public methods ======================

    draw: function draw(selection) {
        var axis = this.getAxis();
        selection.call(axis);
    },

    drawSubLabels: function drawSubLabels(canvas) {
        var xScale = this.get("scale");
        var xAxisOrient = this.get("orient");
        var subLabels = this.get("subLabels");
        var xlayer = canvas.layer("mbc-axes-xlabels", "axes");
        var xTexts;

        xTexts = xlayer.selectAll(".mbc-x-label").data(xScale.domain());
        xTexts.enter().append("g").classed("mbc-x-label", true).attr("transform", function (d) {
            var x = xScale(d) + xScale.rangeBand() / 2;
            var y = xAxisOrient === "bottom" ? canvas.height() + 35 : -25;
            return "translate(" + x + ", " + y + ")";
        }).append("text").text(function (d, i) {
            var label = "";
            if (i < subLabels.length) {
                label = subLabels[i] || "";
            }

            return label;
        }).attrs({
            "text-anchor": "start",
            "dx": this.get("subLabelDx")
        });
    },

    getScale: function getScale() {
        return this.get('scale');
    },

    getAxis: function getAxis() {
        return this.get('axis');
    },

    //=================== util methods ============================

    isInvalidDate: function isInvalidDate(date) {
        if (date instanceof Date && date.toString() !== 'Invalid Date') {
            return false;
        }

        return true;
    },

    checkLabelsWidth: function checkLabelsWidth(labelList, axisWidth, spacing, font) {
        var totalSpacing = spacing * (labelList.length - 1);
        var totalWidth = this.getTextWidth({
            font: font,
            text: labelList.join('')
        });

        //axis can show all labels well.
        if (axisWidth > totalWidth + totalSpacing) {
            return true;
        }

        return false;
    },

    getTextWidth: function getTextWidth(option) {

        var canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement('canvas'));
        var context = canvas.getContext('2d');

        context.font = option.font;

        var dimension = context.measureText(option.text);

        return dimension.width;
    },

    calcMaxTextWidth: function calcMaxTextWidth(texts) {
        var _this = this;
        var font = this.get('font');
        var maxTextWidth = d3.max(texts.map(function (text) {
            return _this.getTextWidth({
                font: font,
                text: text
            });
        }));

        return maxTextWidth;
    },

    getDate: function getDate(maskDate) {
        return new Date(Utils.string.unmask(maskDate));
    },

    quarterlyTickFormat: function quarterlyTickFormat(date) {
        var month = +d3.time.format('%m')(date);
        var quarterly = [3, 6, 9, 12];

        if (quarterly.indexOf(month) === -1) {
            return;
        }

        return "Q" + month / 3;
    },

    //========================= getter & setter ============================

    get: function get(key) {
        return this.__attributes[key];
    },

    set: function set(key, value) {
        this.__attributes[key] = value;
    }

});

module.exports = DateAxis;

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DateAxis = __webpack_require__(39);

module.exports = {
    DateAxis: DateAxis
};

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var array = __webpack_require__(14);
var object = __webpack_require__(2);

/**
 * Calculate tickvalues for a given dataset.
 *
 * @param {Array} domain Two values array.
 * @param {Number} ticksNumber Number of ticks to show.
 *
 * @return {Array} Containing the ticks to include in the chart's axis.
 */
var getTickValues = function getTickValues(domain, ticksNumber) {
    ticksNumber = ticksNumber || 4;
    var distance = Math.abs(domain[0] - domain[1]);
    var domainStep = distance / ticksNumber;
    var min = domain[0];
    var max = domain[1];
    var tickValues = [];

    while (min < max) {
        tickValues.push(min);
        min += domainStep;
    }

    tickValues.push(min);

    return tickValues;
};

function ensureGreaterThanOne(num) {
    var power = 0;
    while (num < 10) {
        num = num * 10;
        power++;
    }

    return { number: num, power: power };
}

/**
 * Returns a domain with positive numbers starting from 0 based on the chart values.
 *
 * @param {Array} allValues Array of numbers containing values used to caculate the domain.
 * @param {Number} roundTo Tenths, hundreds, thousands,...
 * @param {boolean} integers Show only integer numbers, without decimal.
 * @param {Number} steps Numbers of intended steps into the domain.
 * @returns {Array} Two values array with the domain.
 */
function getPositiveDomain(allValues, roundTo, integers, steps) {
    var max = Math.ceil(d3.max(allValues) / roundTo) * roundTo;
    if (max === 0) return [0, 1];
    var ensured = ensureGreaterThanOne(max);
    var mod, power;

    max = ensured.number;
    power = ensured.power;
    roundTo *= Math.pow(10, power);

    if (integers) {
        mod = max % steps;
        while (mod !== 0) {
            max += roundTo;
            mod = max % steps;
        }
    }

    max = max / Math.pow(10, power);

    return [0, max];
}

/**
 * Returns a Symmetrical domain based on the chart values.
 *
 * @param {Array} allValues Array of numbers containing values used to caculate the domain.
 * @param {Number} roundTo Tenths, hundreds, thousands,...
 * @returns
 */
function getSymmetricalDomain(allValues, roundTo, integers, steps) {
    var allPositive = array.getAllPositives(allValues);
    var max = Math.ceil(d3.max(allPositive) / roundTo) * roundTo;
    if (max === 0) return [-1, 1];
    var ensured = ensureGreaterThanOne(max);
    var min, mod, power;

    max = ensured.number;
    power = ensured.power;
    min = max * -1;
    roundTo *= Math.pow(10, power);

    if (integers) {
        mod = max * 2 % steps;
        while (mod !== 0) {
            max += roundTo;
            mod = max * 2 % steps;
        }

        min = max * -1;
    }

    min = min / Math.pow(10, power);
    max = max / Math.pow(10, power);

    return [min, max];
}

/**
 * Returns an Asymmetrical domain based on the chart values.
 *
 * @param {Array} allValues Array of numbers containing values used to caculate the domain.
 * @param {Number} roundTo Tenths, hundreds, thousands,...
 * @returns
 */
function getAsymmetricalDomain(allValues, roundTo) {
    var max = Math.ceil(d3.max(allValues) / roundTo) * roundTo;
    var min = Math.floor(d3.min(allValues) / roundTo) * roundTo;

    return [min, max];
}

/**
 * Calculates the domain for a certain dataset.
 *
 * @param {Object}? options Options available:
 * <li><b>values:</b> Required. Array of values.
 * <li><b>roundTo:</b> Optional. roundTo 10, 100, 1000, etc.
 * <li><b>forceNegative:</b> Optional. Boolean value to force negative values on the domain
 * <li><b>symmetrical:</b> Optional.
 * <li><b>steps:</b> Optional. Intended ticks number.
 *
 * @return {Array} Two values array indicating the domain.
 */
var getDomain = function getDomain(options) {
    options = options || {};
    var allValues = options.values;
    var roundTo = options.roundTo || 10;
    var integers = object.getBoolean(options.integers, false);
    var forceNegative = object.getBoolean(options.forceNegative, false);
    var symmetrical = object.getBoolean(options.symmetrical, true);
    var raw = object.getBoolean(options.raw, false);
    var steps = options.steps || 4;
    var negatives;

    if (!allValues || allValues.length === 0) {
        return [0, 1];
    }

    negatives = array.hasNegative(allValues);
    allValues = array.removeDuplicates(allValues);

    if (raw) {
        return [d3.min(allValues), d3.max(allValues)];
    }

    if (!negatives && !forceNegative) {
        return getPositiveDomain(allValues, roundTo, integers, steps);
    } else if (symmetrical) {
        return getSymmetricalDomain(allValues, roundTo, integers, steps);
    } else {
        return getAsymmetricalDomain(allValues, roundTo, integers, steps);
    }
};

/**
 * Returns the index of a given value into a range array.
 * @param {Number} val Value to find index into range array.
 * @param {Array<Array>} range Range array. ex: [[-infinity, -1], [-1, 0], [0, 1], [1, Infinity]]
 * @return {Number} The range index or -1.
 */
function getRangeIndex(val, range) {
    for (var i = 0; i < range.length; i++) {
        if (val > range[i][0] && (val <= range[i][1] || range[i][1] === undefined)) {
            return i;
        }
    }

    return -1;
}

/**
 * Returns the value of a given value into a values array.
 * @param {Number} val Value to find index into range array.
 * @param {Array<Array>} range Range array. ex: [[-infinity, -1], [-1, 0], [0, 1], [1, Infinity]]
 * @param {Array} values Values to return
 * @return {Object} The value that matches range index or `undefined`.
 */
function getRangeValue(val, range, values) {
    var index = getRangeIndex(val, range);
    if (index !== -1) return values[index];
}

/**
 * Returns the calculated padding between bars
 * @param {Array} num the number of bars
 * @param {Number} dim the height or width of the canvas
 * @param {String} orient whether horizontal or vertical bar chart
 * @return {String} type whether standard or grouped bars
 */
function getBarPadding(num, dim, orient) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "standard";


    var padding = 9;
    var ratio = dim / num;

    if (orient === "horizontal" || orient === "vertical" && type === "standard") {

        if (ratio > 21) {
            return padding;
        } else if (ratio <= 21 && ratio > 14) {
            padding = 6;
        } else if (ratio <= 14 && ratio > 7) {
            padding = 3;
        } else {
            padding = 1;
        }
    } else if (orient === "vertical" && type === "grouped") {

        if (ratio > 16.5) {
            return padding;
        } else if (ratio <= 16.5 && ratio > 11) {
            padding = 6;
        } else if (ratio <= 11 && ratio > 5.5) {
            padding = 3;
        } else {
            padding = 1;
        }
    }

    return padding;
}

module.exports = {
    getTickValues: getTickValues,
    getDomain: getDomain,
    getRangeIndex: getRangeIndex,
    getRangeValue: getRangeValue,
    getBarPadding: getBarPadding
};

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mds_constants = __webpack_require__(7).constants;
var mds_chart_color = mds_constants["chart-color"];

/**
 * deprecating `var colors` in v3.0.0
 */
var colors = {
    "blue": mds_chart_color["1"],
    "maroon": mds_chart_color["2"],
    "teal": mds_chart_color["8"],
    "orange": mds_chart_color["7"],
    "green": mds_chart_color["9"],
    "violet": mds_chart_color["6"],
    "yellow": mds_chart_color["3"],
    "cyan": mds_chart_color["5"],
    "dark-green": mds_chart_color["4"],
    "red": mds_constants["color"]["red"]["50"],
    "light-red": mds_chart_color["10"],
    "dark-violet": mds_chart_color["11"],
    "dark-yellow": mds_chart_color["12"],
    "aqua": mds_chart_color["13"],
    "bright-orange": mds_chart_color["14"],
    "light-green": mds_chart_color["15"],
    "white": mds_constants["color"].white,
    "grey1": mds_constants["color"]["neutral"]["90"],
    "grey2": mds_constants["background-color"].light,
    "grey3": mds_constants["color"]["neutral"]["80"],
    "grey4": mds_constants["color"]["neutral"]["80"],
    "grey5": mds_constants["color"]["neutral"]["50"],
    "grey6": mds_constants["color"]["neutral"]["37"],
    "grey7": mds_constants["color"]["neutral"]["12"],
    "black": mds_constants["color"].black
};

var primary = [mds_chart_color["1"], mds_chart_color["2"], mds_chart_color["3"], mds_chart_color["4"], mds_chart_color["5"], mds_chart_color["6"], mds_chart_color["7"], mds_chart_color["8"], mds_chart_color["9"]];

var secondary = [mds_chart_color["10"], mds_chart_color["11"], mds_chart_color["12"], mds_chart_color["13"], mds_chart_color["14"], mds_chart_color["15"]];

var palettes = [primary, secondary];

var combined = palettes.reduce(function (a, b) {
    return a.concat(b);
}, []);

module.exports = {
    colors: colors,
    primary: primary,
    secondary: secondary,
    combined: combined,
    mds_constants: mds_constants,
    mds_chart_color: mds_chart_color
};

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var names = ["Asia/Pacific Long-Short Equity", "Bear-Market Equity", "China Long-Short Equity", "Convertible Arbitrage", "Currency", "Debt Arbitage", "Distressed Securities", "Diversified Arbitage", "Emrg-Mkta Long-Short Equity", "Equity Market Neutral", "Europe Long-Short Equity", "Event Driven", "Global Long-Short Equity", "Global Macro", "Long-Short Debt", "Merger Arbitage", "Multistrategy", "Systematic Futures", "U.S. Long-Short Equity", "U.S. Sm-Cap Lg-Short Equity", "Volatility"];

function getDummyArray(n) {
    var i = 0;
    var arr = [];
    var sign;
    for (; i < n; i++) {
        sign = Math.random() < 0.5 ? -1 : 1;
        arr.push(Math.random() * sign);
    }

    return arr;
}

function getRandomName() {
    return names[Math.floor(names.length * Math.random())];
}

function getDummyRows(num) {
    var length = num || 3 + Math.floor(Math.random() * 47);
    var i = 0;
    var rows = [];
    var name;

    for (; i < length; i++) {
        name = getRandomName();
        rows.push(name);
    }

    return rows;
}

function getDummyMatrix(num) {
    var i;
    var j;
    var matrix = [];
    var length = num || 3 + Math.floor(Math.random() * 47);
    var sign, value;

    // for (i = 0; i < num; i++) {
    //     matrix[i] = [];
    // }

    for (i = 0; i < length; i++) {
        for (j = 0; j < length; j++) {
            if (!matrix[i]) matrix[i] = [];
            if (!matrix[j]) matrix[j] = [];

            sign = Math.random() < 0.5 ? -1 : 1;
            value = Math.random() * sign;
            if (j < i) {
                matrix[i][j] = value;
                matrix[j][i] = value;
            } else if (i === j) {
                matrix[i][j] = 1;
                break;
            }
        }
    }

    return matrix;
}

function grow(matrix) {
    var arr = getDummyArray(matrix.length);
    arr.forEach(function (val, i) {
        matrix[i].push(val);
    });

    arr.push(1);
    matrix.push(arr);
    return matrix;
}

function dataset(num) {
    var length = num || 3 + Math.floor(Math.random() * 47);
    var dummyRows = getDummyRows(length);
    var dummyMatrix = getDummyMatrix(length);

    return {
        rows: dummyRows,
        matrix: dummyMatrix
    };
}

module.exports = {
    matrix: getDummyMatrix,
    rows: getDummyRows,
    array: getDummyArray,
    dataset: dataset,
    grow: grow,
    name: getRandomName
};

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crmatrix = __webpack_require__(43);
/**
 * @fileOverview Generates "Lorem ipsum" style text.
 * @author rviscomi@gmail.com Rick Viscomi,
 * 		tinsley@tinsology.net Mathew Tinsley
 * @version 1.0
 */

/**
 *	Copyright (c) 2009, Mathew Tinsley (tinsley@tinsology.net)
 *	All rights reserved.
 *
 *	Redistribution and use in source and binary forms, with or without
 *	modification, are permitted provided that the following conditions are met:
 *		* Redistributions of source code must retain the above copyright
 *		  notice, this list of conditions and the following disclaimer.
 *		* Redistributions in binary form must reproduce the above copyright
 *		  notice, this list of conditions and the following disclaimer in the
 *		  documentation and/or other materials provided with the distribution.
 *		* Neither the name of the organization nor the
 *		  names of its contributors may be used to endorse or promote products
 *		  derived from this software without specific prior written permission.
 *
 *	THIS SOFTWARE IS PROVIDED BY MATHEW TINSLEY ""AS IS"" AND ANY
 *	EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *	WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 *	DISCLAIMED. IN NO EVENT SHALL <copyright holder> BE LIABLE FOR ANY
 *	DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 *	(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 *	LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 *	ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 *	(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 *	SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class Jibborish generator.
 */
var LoremIpsum = function LoremIpsum() {};

/**
 * Average number of words per sentence.
 * @constant {number}
 */
LoremIpsum.WORDS_PER_SENTENCE_AVG = 24.460;

/**
 * Standard deviation of the number of words per sentence.
 * @constant {number}
 */
LoremIpsum.WORDS_PER_SENTENCE_STD = 5.080;

/**
 * List of possible words.
 * @constant {Array.string}
 */
LoremIpsum.WORDS = ["lorem", "ipsum", "dolor", "sit", "amet", "consectetur", "adipiscing", "elit", "curabitur", "vel", "hendrerit", "libero", "eleifend", "blandit", "nunc", "ornare", "odio", "ut", "orci", "gravida", "imperdiet", "nullam", "purus", "lacinia", "a", "pretium", "quis", "congue", "praesent", "sagittis", "laoreet", "auctor", "mauris", "non", "velit", "eros", "dictum", "proin", "accumsan", "sapien", "nec", "massa", "volutpat", "venenatis", "sed", "eu", "molestie", "lacus", "quisque", "porttitor", "ligula", "dui", "mollis", "tempus", "at", "magna", "vestibulum", "turpis", "ac", "diam", "tincidunt", "id", "condimentum", "enim", "sodales", "in", "hac", "habitasse", "platea", "dictumst", "aenean", "neque", "fusce", "augue", "leo", "eget", "semper", "mattis", "tortor", "scelerisque", "nulla", "interdum", "tellus", "malesuada", "rhoncus", "porta", "sem", "aliquet", "et", "nam", "suspendisse", "potenti", "vivamus", "luctus", "fringilla", "erat", "donec", "justo", "vehicula", "ultricies", "varius", "ante", "primis", "faucibus", "ultrices", "posuere", "cubilia", "curae", "etiam", "cursus", "aliquam", "quam", "dapibus", "nisl", "feugiat", "egestas", "class", "aptent", "taciti", "sociosqu", "ad", "litora", "torquent", "per", "conubia", "nostra", "inceptos", "himenaeos", "phasellus", "nibh", "pulvinar", "vitae", "urna", "iaculis", "lobortis", "nisi", "viverra", "arcu", "morbi", "pellentesque", "metus", "commodo", "ut", "facilisis", "felis", "tristique", "ullamcorper", "placerat", "aenean", "convallis", "sollicitudin", "integer", "rutrum", "duis", "est", "etiam", "bibendum", "donec", "pharetra", "vulputate", "maecenas", "mi", "fermentum", "consequat", "suscipit", "aliquam", "habitant", "senectus", "netus", "fames", "quisque", "euismod", "curabitur", "lectus", "elementum", "tempor", "risus", "cras"];

/**
 * Generate "Lorem ipsum" style words.
 * @param numWords {number} Number of words to generate.
 * @return {string} "Lorem ipsum..."
 */
LoremIpsum.prototype.generate = function (numWords, punctuate) {
    var words, ii, position, word, current, sentences, sentenceLength, sentence;

    /**
    * @default 100
    */
    numWords = numWords || 100;

    words = [LoremIpsum.WORDS[0], LoremIpsum.WORDS[1]];
    numWords -= 2;

    for (ii = 0; ii < numWords; ii++) {
        position = Math.floor(Math.random() * LoremIpsum.WORDS.length);
        word = LoremIpsum.WORDS[position];

        if (ii > 0 && words[ii - 1] === word) {
            ii -= 1;
        } else {
            words[ii] = word;
        }
    }

    sentences = [];
    current = 0;

    while (numWords > 0) {
        sentenceLength = this.getRandomSentenceLength();

        if (numWords - sentenceLength < 4) {
            sentenceLength = numWords;
        }

        numWords -= sentenceLength;

        sentence = [];

        for (ii = current; ii < current + sentenceLength; ii++) {
            sentence.push(words[ii]);
        }

        if (punctuate) {
            sentence = this.punctuate(sentence);
        }

        current += sentenceLength;
        sentences.push(sentence.join(" "));
    }

    return sentences.join(" ");
};

/**
 * Insert commas and periods in the given sentence.
 * @param {Array.string} sentence List of words in the sentence.
 * @return {Array.string} Sentence with punctuation added.
 */
LoremIpsum.prototype.punctuate = function (sentence) {
    var wordLength, numCommas, ii, position;

    wordLength = sentence.length;

    /* End the sentence with a period. */
    sentence[wordLength - 1] += ".";

    if (wordLength < 4) {
        return sentence;
    }

    numCommas = this.getRandomCommaCount(wordLength);

    for (ii = 0; ii <= numCommas; ii++) {
        position = Math.round(ii * wordLength / (numCommas + 1));

        if (position < wordLength - 1 && position > 0) {
            /* Add the comma. */
            sentence[position] += ",";
        }
    }

    /* Capitalize the first word in the sentence. */
    sentence[0] = sentence[0].charAt(0).toUpperCase() + sentence[0].slice(1);

    return sentence;
};

/**
 * Produces a random number of commas.
 * @param {number} wordLength Number of words in the sentence.
 * @return {number} Random number of commas
 */
LoremIpsum.prototype.getRandomCommaCount = function (wordLength) {
    var base, average, standardDeviation;

    /* Arbitrary. */
    base = 6;

    average = Math.log(wordLength) / Math.log(base);
    standardDeviation = average / base;

    return Math.round(this.gaussMS(average, standardDeviation));
};

/**
 * Produces a random sentence length based on the average word length
 * of an English sentence.
 * @return {number} Random sentence length
 */
LoremIpsum.prototype.getRandomSentenceLength = function () {
    return Math.round(this.gaussMS(LoremIpsum.WORDS_PER_SENTENCE_AVG, LoremIpsum.WORDS_PER_SENTENCE_STD));
};

/**
 * Produces a random number.
 * @return {number} Random number
 */
LoremIpsum.prototype.gauss = function () {
    return Math.random() * 2 - 1 + (Math.random() * 2 - 1) + (Math.random() * 2 - 1);
};

/**
 * Produces a random number with Gaussian distribution.
 * @param {number} mean
 * @param {number} standardDeviation
 * @return {number} Random number
 */
LoremIpsum.prototype.gaussMS = function (mean, standardDeviation) {
    return Math.round(this.gauss() * standardDeviation + mean);
};

function Tickers() {}

Tickers.TICKERS = ["PIH", "FLWS", "FCCY", "SRCE", "VNET", "TWOU", "JOBS", "CAFD", "EGHT", "AVHI", "SHLM", "AAON", "ABAX", "ABEO", "ABEOW", "ABIL", "ABMD", "AXAS", "ACIU", "ACIA", "ACTG", "ACHC", "ACAD", "ACST", "AXDX", "XLRN", "ANCX", "ARAY", "ACRX", "ACET", "AKAO", "ACHN", "ACIW", "ACRS", "ACNB", "ACOR", "ACTS", "ACPW", "ATVI", "ACTA", "ACUR", "ACXM", "ADMS", "ADMP", "ADAP", "ADUS", "AEY", "IOTS", "ADMA", "ADBE", "ADTN", "ADRO", "AAAP", "ADES", "AEIS", "AMD", "ADXS", "ADXSW", "ADVM", "MAUI", "AEGR", "AEGN", "AGLE", "AEHR", "AMTX", "AEPI", "AERI", "AVAV", "AEZS", "AEMD", "AFMD", "AGEN", "AGRX", "AGYS", "AGIO", "AGNC", "AGNCB", "AGNCP", "AGFS", "AGFSW", "AIMT", "AIRM", "AIRT", "ATSG", "AIRG", "AMCN", "AIXG", "AKAM", "AKTX", "AKBA", "AKER", "AKRX", "ALRM", "ALSK", "AMRI", "ALBO", "ABDC", "ADHD", "ALDR", "ALDX", "ALXN", "ALCO", "ALGN", "ALIM", "ALJJ", "ALKS", "ABTX", "ALGT", "AIQ", "AHGP", "AMMA", "ARLP", "AHPI", "AMOT", "ALQA", "ALLT", "MDRX", "AFAM", "ALNY", "AOSL", "GOOG", "GOOGL", "SMCP", "ATEC", "ASPS", "AIMC", "AMAG", "AMRN", "AMRK", "AYA", "AMZN", "AMBC", "AMBCW", "AMBA", "AMCX", "DOX", "AMDA", "AMED", "UHAL", "ATAX", "AMOV", "AAL", "ACSF", "ACAS", "AETI", "AMNB", "ANAT", "APEI", "ARII", "AMRB", "AMSWA", "AMSC", "AMWD", "CRMT", "ABCB", "AMSF", "ASRV", "ASRVP", "ATLO", "AMGN", "FOLD", "AMKR", "AMPH", "IBUY", "AMSG", "AMSGP", "ASYS", "AFSI", "AMRS", "ADI", "ALOG", "AVXL", "ANCB", "ANDA", "ANDAR", "ANDAU", "ANDAW", "ANGI", "ANGO", "ANIP", "ANIK", "ANSS", "ATRS", "ANTH", "ABAC", "APOG", "APOL", "AINV", "APPF", "AAPL", "ARCI", "APDN", "APDNW", "AGTC", "AMAT", "AMCC", "AAOI", "AREX", "APTI", "APRI", "APVO", "APTO", "AQMS", "AQXP", "ARDM", "ARLZ", "PETX", "ABUS", "ARCW", "ABIO", "RKDA", "ARCB", "ACGL", "ACGLP", "APLP", "ACAT", "ARDX", "ARNA", "ARCC", "AGII", "AGIIL", "ARGS", "ARIS", "ARIA", "ARKR", "ARTX", "ARWA", "ARWAR", "ARWAU", "ARWAW", "ARQL", "ARRY", "ARRS", "DWAT", "AROW", "ARWR", "ARTNA", "ARTW", "ASBB", "ASNA", "ASND", "ASCMA", "APWC", "ASML", "AZPN", "ASMB", "ASFI", "ASTE", "ATRO", "ALOT", "ASTC", "ASUR", "ATAI", "ATRA", "ATHN", "ATHX", "AAPC", "AAME", "ACBI", "ACFC", "ABY", "ATLC", "AAWW", "AFH", "TEAM", "ATNI", "ATOM", "ATOS", "ATRC", "ATRI", "ATTU", "LIFE", "AUBN", "BOLD", "AUDC", "AUPH", "EARS", "ABTL", "ADSK", "ADP", "AVEO", "AVXS", "AVNW", "AVID", "AVGR", "AVIR", "CAR", "AHPAU", "AWRE", "AXAR", "AXARU", "AXARW", "ACLS", "AXGN", "AXSM", "AXTI", "AZRX", "BCOM", "RILY", "RILYL", "BOSC", "BEAV", "BIDU", "BCPC", "BWINA", "BWINB", "BLDP", "BANF", "BANFP", "BCTF", "BKMU", "BOCH", "BMRC", "BKSC", "BOTJ", "OZRK", "BFIN", "BWFG", "BANR", "BZUN", "TAPR", "DLBL", "BHAC", "BHACR", "BHACU", "BHACW", "BBSI", "BSET", "BYBK", "BV", "BCBP", "BECN", "BSF", "BBGI", "BEBE", "BBBY", "BGNE", "BELFA", "BELFB", "BLPH", "BLCM", "BNCL", "BNFT", "BNTC", "BNTCW", "BGCP", "BGFV", "BASI", "ORPN", "BIOC", "BCRX", "BDSI", "BIIB", "BIOL", "BLFS", "BLRX", "BMRN", "BMRA", "BVXV", "BVXVW", "BPTH", "BIOS", "BBC", "BBP", "BSTC", "BSTG", "BSPM", "TECH", "BEAT", "BJRI", "BBOX", "BDE", "BLKB", "BBRY", "HAWK", "BL", "BKCC", "ADRA", "ADRD", "ADRE", "ADRU", "BLMN", "BCOR", "BLBD", "BUFF", "BHBK", "NILE", "BLUE", "BKEP", "BKEPP", "BPMC", "ITEQ", "BMCH", "BNCN", "BOBE", "BOFI", "BOFIL", "WIFI", "BOJA", "BOKF", "BOKFL", "BNSO", "BPFH", "BPFHP", "BPFHW", "EPAY", "BLVD", "BLVDU", "BLVDW", "BCLI", "BBRG", "BDGE", "BLIN          ", "BRID", "BCOV", "AVGO", "BSFT", "BVSN", "BYFC", "BWEN", "BRCD", "BRKL", "BRKS", "BRKR", "BMTC", "BLMT", "BSQR", "BWLD", "BLDR", "BMLA", "BUR", "CFFI", "CHRW", "CA", "CCMP", "CDNS", "CDZI", "CACQ", "CZR", "CSTE", "PRSS", "CLBS", "CLMS", "CHY", "CHI", "CCD", "CHW", "CGO", "CSQ", "CAMP", "CVGW", "CFNB", "CALA", "CALD", "CALM", "CLMT", "ABCD", "CAC", "CAMT", "CSIQ", "CGIX", "CPHC", "CPLA", "CBF", "CCBG", "CPLP", "CSWC", "CPTA", "CLAC", "CLACU", "CLACW", "CFFN", "CAPN", "CAPNW", "CAPR", "CSTR", "CPST", "CARA", "CARB", "CCN", "CCNWW", "CFNL", "CRME", "CSII", "CATM", "CDNA", "CECO", "CTRE", "CKEC", "CLBH", "CARO", "CART", "CRZO", "TAST", "CRTN", "CARV", "CASM", "CACB", "CASC", "CWST", "CASY", "CASI", "CASS", "CATB", "CBIO", "CPRX", "CATY", "CATYW", "CVCO", "CAVM", "CBFV", "CBOE", "CDK", "CDW", "CECE", "CELG", "CELGZ", "CLDX", "APOP", "APOPW", "CLRB", "CLRBW", "CLRBZ", "CLLS", "CBMG", "CLSN", "CYAD", "CEMP", "CETX", "CDEV", "CDEVW", "CSFL", "CETV", "CFBK", "CENT", "CENTA", "CVCY", "CFCB", "CENX", "CNBKA", "CNTY", "CRNT", "CERC", "CERCW", "CERCZ", "CERN", "CERU", "CERS", "KOOL", "CEVA", "CFCO", "CFCOU", "CFCOW", "CSBR", "CYOU", "HOTR", "HOTRW", "CTHR", "GTLS", "CHTR", "CHFN", "CHKP", "CHEK", "CHEKW", "CEMI", "CHFC", "CCXI", "CHMG", "CHKE", "CHMA", "PLCE", "CMRX", "CADC", "CALI", "CAAS", "CBAK", "CBPO", "CCCL", "CCCR", "CCRC", "JRJC", "HGSH", "CNIT", "CJJD", "CLDC", "CLDCW", "HTHT", "CHNR", "CREG", "CNTF", "CXDC", "CCIH", "CNET", "IMOS", "CDXC", "CHSCL", "CHSCM", "CHSCN", "CHSCO", "CHSCP", "CHDN", "CHUY", "CDTX", "CMCT", "CMPR", "CINF", "CIDM", "CTAS", "CPHR", "CRUS", "CSCO", "CTRN", "CZNC", "CZWI", "CZFC", "CIZN", "CTXS", "CHCO", "CIVB", "CIVBP", "CDTI", "CLNE", "CLNT", "CLFD", "CLRO", "CLSD", "CLIR", "CBLI", "CSBK", "CLVS", "CMFN", "CME", "CCNE", "CISG", "CNV", "CWAY", "COBZ", "COKE", "CDXS", "CVLY", "JVA", "CCOI", "CGNT", "COGT", "CGNX", "CTSH", "COHR", "CHRS", "COHU", "CLCT", "COLL", "CIGI", "CBAN", "CLCD", "COLB", "COLM", "CMCO", "CBMX", "CBMXW", "CMCSA", "CBSH", "CBSHP", "CUBN", "CHUBA", "CHUBK", "CVGI", "COMM", "CSAL", "JCS", "ESXB", "CYHHZ", "CTBI", "CWBC", "CVLT", "CGEN", "CPSI", "CTG", "SCOR", "CHCI", "CMTL", "CNAT", "CNCE", "CXRX", "CCUR", "CDOR", "CFMS", "CNFR", "CNMD", "CTWS", "CNOB", "CNXR", "CONN", "CNSL", "CWCO", "CPSS", "CFRX", "CFRXW", "CTRV", "CTRL", "CPAA", "CPAAU", "CPAAW", "CPRT", "COYN", "COYNW", "CRBP", "CORT", "CORE", "CORI", "CSOD", "CRVL", "CRVS", "CSGP", "COST", "CPAH", "ICBK", "COUP", "CVTI", "COVS", "COWN", "COWNL", "PMTS", "CPSH", "CRAI", "CBRL", "BREW", "CRAY", "CACC", "GLDI", "SLVO", "CREE", "CRESY", "CRSP", "CRTO", "CROX", "CCRN", "XRDC", "CRDS", "CRWS", "CYRX", "CYRXW", "CSGS", "CCLP", "CSPI", "CSWI", "CSX", "CTIC", "CTIB", "CTRP", "CUNB", "CUI", "CPIX", "CMLS", "CRIS", "CUTR", "CVBF", "CVV", "CYAN", "CYBR", "CYBE", "CYCC", "CYCCP", "CBAY", "CYNO", "CY", "CYRN", "CONE", "CYTK", "CTMX", "CYTX", "CYTXW", "CTSO", "CYTR", "DJCO", "DAKT", "DRIO", "DRIOW", "DZSI", "DAIO", "DTLK", "DRAM", "DWCH", "PLAY", "DTEA", "DWSN", "DBVT", "DFRG", "TACO", "TACOW", "DCTH", "DMPI", "DGAS", "DELT", "DELTW", "DENN", "XRAY", "DEPO", "DSCI", "DERM", "DEST", "DXLG", "DSWL", "DTRM", "DXCM", "DXTR", "DHXM", "DHIL", "FANG", "DCIX", "DRNA", "DFBG", "DFFN", "DGII", "DMRC", "DRAD", "DGLY", "APPS", "DCOM", "DMTX", "DIOD", "DPRX", "DISCA", "DISCB", "DISCK", "DISH", "DVCR", "SAUC", "DLHC", "BOOM", "DNBF", "DLTR", "DGICA", "DGICB", "DMLP", "DORM", "EAGL", "EAGLU", "EAGLW", "DRWI", "DRYS", "DSKX", "DSPG", "DTSI", "DLTH", "DNKN", "DRRX", "DXPE", "DYSL", "DYNT", "DVAX", "ETFC", "EBMT", "EGBN", "EGLE", "EGRX", "IGLEU", "ELNK", "EWBC", "EACQ", "EACQU", "EACQW", "EML", "EVBS", "EVGBC", "EVSTC", "EVLMC", "EBAY", "EBAYL", "EBIX", "ELON", "ECHO", "SATS", "EEI", "ECAC", "ECACR", "ECACU", "ESES", "EDAP", "EDGE", "EDGW", "EDIT", "EDUC", "EFUT", "EGAN", "EGLT", "EHTH", "EIGR", "EKSO", "LOCO", "EMITF", "ESLT", "ERI", "ESIO", "EA", "EFII", "ELSE", "ELEC", "ELECU", "ELECW", "EBIO", "DWAC", "CAPX", "ESBK", "ELTK", "EMCI", "EMCF", "EMKR", "EMMS", "NYNY", "ERS", "ENTA", "ECPG", "WIRE", "ENDP", "ECYT", "ELGX", "EIGI", "WATT", "EFOI", "ERII", "ENOC", "ENG", "ENPH", "ESGR", "ENFC", "ENTG", "ENTL", "ETRM", "EBTC", "EFSC", "EGT", "ENZY          ", "EPZM", "PLUS", "EQIX", "EQFN", "EQBK", "ERIC", "ERIE", "ESCA", "ESPR", "ESSA", "EPIX", "ESND", "UTES", "ETSY", "CLWT", "EEFT", "ESEA", "EVEP", "EVBG", "EVK", "MRAM", "EVLV", "EVOK", "EVOL", "EXA", "EXAS", "EXAC", "EXEL", "EXFO", "EXLS", "EXPE", "EXPD", "EXPO", "ESRX", "XOG", "EXTR", "EYEG", "EYEGW", "EZPW", "FFIV", "FB", "FRP", "FALC", "DAVE", "FARM", "FFKT", "FMNB", "FARO", "FAST", "FATE", "FBSS", "FBRC", "FDML", "FNHC", "FHCO", "FENX", "GSM", "FCSC", "FGEN", "ONEQ", "LION", "FDUS", "FRGI", "FSAM", "FSC", "FSCFL", "FSFR", "FITB", "FITBI", "FNGN", "FISI", "FNSR", "FNJN", "FEYE", "FBNC", "FNLC", "FRBA", "BUSE", "FBIZ", "FCAP", "FCFS", "FCNCA", "FCBC", "FCCO", "FCFP", "FBNK", "FDEF", "FFBC", "FFBCW", "FFIN", "THFF", "FFNW", "FFWM", "FGBI", "FHB", "INBK", "INBKL", "FIBK", "FRME", "FMBH", "FMBI", "FNBC", "FNWB", "FSFG", "FSLR", "FSBK", "FAAR", "FPA", "BICK", "FBZ", "FCAN", "FTCS", "FCEF", "FCA", "FDT", "FDTS", "FVC", "FV", "IFV", "FEM", "FEMB", "FEMS", "FTSM", "FEP", "FEUZ", "FGM", "FTGC", "FTHI", "HYLS", "FHK", "FTAG", "FTRI", "FPXI", "YDIV", "SKYY", "FJP", "FEX", "FTC", "FTA", "FLN", "FTLB", "LMBS", "FMB", "FMK", "FNX", "FNY", "FNK", "FAD", "FAB", "MDIV", "MCEF", "QABA", "FTXO", "QCLN", "GRID", "CIBR", "FTXG", "CARZ", "FTXN", "FTXH", "FTXD", "RDVY", "FTXL", "FONE", "TDIV", "FTXR", "QQEW", "QQXT", "QTEC", "AIRR", "QINC", "RFAP", "RFDI", "RFEM", "RFEU", "FTSL", "FYX", "FYC", "FYT", "FKO", "FCVT", "FDIV", "FSZ", "FTW", "TUSA", "FKU", "FUNC", "FUSB", "SVVC", "FSV", "FISV", "FIVE", "FPRX", "FVE", "FIVN", "FLML", "FLEX", "FLKS", "FLXN", "SKOR", "LKOR", "MBSD", "ASET", "ESGG", "ESG", "QLC", "FPAY", "FLXS", "FLIR", "FLDM", "FFIC", "FOMX", "FOGO", "FONR", "FH", "FORM", "FORTY", "FORR", "FRTA", "FTNT", "FBIO", "FWRD", "FORD", "FWP", "FOSL", "FMI", "FOXF", "FRAN", "FELE", "FRED", "RAIL", "FEIM", "FRPT", "FTEO", "FTR", "FTRPR", "FRPH", "FSBW", "FSBC", "FTD", "FTEK", "FCEL", "FLGT", "FORK", "FLL", "FULT", "FNCX", "FSNN", "FFHL", "FXCM", "GK", "WILC", "GAIA", "GLPG", "GALT", "GALTU", "GALTW", "GALE", "GLMD", "GLPI", "GPIC", "GRMN", "GARS", "GDS", "GEMP", "GENC", "GNCMA", "GFN", "GFNCP", "GFNSL", "GENE", "GNUS", "GNMK", "GNCA", "GHDX", "GNTX", "THRM", "GNVC", "GTWN", "GEOS", "GABC", "GERN", "GEVO", "ROCK", "GIGM", "GIGA", "GIII", "GILT", "GILD", "GBCI", "GLAD", "GLADO", "GOOD", "GOODM", "GOODO", "GOODP", "GAIN", "GAINM", "GAINN", "GAINO", "LAND", "LANDP", "GLBZ", "GBT", "ENT", "GBLI", "GBLIZ", "GPAC", "GPACU", "GPACW", "SELF", "GSOL", "GWRS", "KRMA", "FINX", "ACTX", "BFIT", "SNSR", "LNGR", "MILN", "EFAS", "QQQC", "BOTZ", "CATH", "SOCL", "ALTY", "SRET", "YLCO", "GLBS", "GLUU", "GLYC", "GOGO", "GLNG", "GMLP", "GDEN", "GOGL", "GBDC", "GTIM", "GPRO", "GMAN", "GOV", "GOVNI", "GPIA", "GPIAU", "GPIAW", "LOPE", "GRVY", "FULLL", "GECC", "GEC", "GLDD", "GSBC", "GNBC", "GRBK", "GPP", "GPRE", "GCBC", "GLRE", "GSUM", "GRIF", "GRFS", "GRPN", "OMAB", "GGAL", "GSIT", "GSVC", "GTXI", "GTYH", "GTYHU", "GTYHW", "GBNK", "GFED", "GUID", "GIFI", "GURE", "GPOR", "GWPH", "GWGH", "GYRO", "HEES", "HLG", "HNRG", "HALL", "HALO", "HBK", "HBHC", "HBHCL", "HNH", "HAFC", "HQCL", "HONE", "HDNG", "HLIT", "HRMN", "HRMNU", "HRMNW", "TINY", "HBIO", "HCAP", "HCAPL", "HAS", "HA", "HCOM", "HWKN", "HWBK", "HAYN", "HDS", "HIIQ", "HCSG", "HQY", "HSTM", "HWAY", "HTLD", "HTLF", "HTBX", "HSII", "HELE", "HMNY", "HMTV", "HNNA", "HCAC", "HCACU", "HCACW", "HSIC", "HTBK", "HFWA", "HEOP", "HCCI", "MLHR", "HRTX", "HSKA", "HIBB", "SNLN", "HPJ", "HIHO", "HIMX", "HIFS", "HSGX", "HMNF", "HMSY", "HOLI", "HOLX", "HBCP", "HOMB", "HFBL", "HMST", "HMTA", "HTBI", "HMU", "CETC", "HOFT", "HOPE", "HFBC", "HBNC", "HZNP", "HRZN", "HDP", "HPT", "HPTRP", "TWNK", "TWNKW", "HMHC", "HWCC", "HOVNP", "HBMD", "HSNI", "HTGM", "HUBG", "HSON", "HDSN", "HUNTU", "HBAN", "HBANN", "HBANO", "HBANP", "HURC", "HURN", "HCM", "HBP", "HDRA", "HDRAR", "HDRAU", "HDRAW", "HYGS", "IDSY", "IAC", "IKGH", "IBKC", "IBKCO", "IBKCP", "ICAD", "IEP", "ICFI", "ICLR", "ICON", "ICUI", "IPWR", "INVE", "IDRA", "IDXX", "IESC", "IROQ", "IRG", "RXDX", "INFO", "IIVI", "KANG", "IKNX", "ILG", "ILMN", "ISNS", "IMMR", "ICCC", "IMDZ", "IMNP          ", "IMGN", "IMMU", "IPXL", "PI", "IMMY", "INCR", "INCY", "INDB", "IBCP", "IBTX", "IDSA", "INFN", "INFI", "IPCC", "III", "IFON", "IMKTA", "INWK", "INNL", "INOD", "IPHS", "IOSP", "ISSC", "INVA", "INGN", "ITEK", "INOV", "INO", "INSG", "NSIT", "ISIG", "INSM", "IIIN", "PODD", "INSY", "NTEC", "IART", "IDTI", "INTC", "IQNT", "NTLA", "IPCI", "IPAR", "IBKR", "ININ", "ICPT", "IDCC", "TILE", "LINK", "IMI", "INAP", "IBOC", "ISCA", "IGLD", "IIJI", "IDXG", "XENT", "INTX", "ISIL", "IVAC", "INTL", "ITCI", "IIN", "INTU", "ISRG", "INVT", "SNAK", "ISTR", "ISBC", "ITIC", "NVIV", "IVTY", "IONS", "IPAS", "DTYS", "DTYL", "DTUS", "DTUL", "DFVS", "DFVL", "FLAT", "DLBS", "STPP", "IPGP", "IRMD", "IRTC", "IRIX", "IRDM", "IRDMB", "IRBT", "IRWD", "IRCP", "PMPT", "SLQD", "TLT", "AIA", "COMT", "IXUS", "FALN", "IFEU", "IFGL", "IGF", "GNMA", "HYXE", "JKI", "ACWX", "ACWI", "AAXJ", "EWZS", "MCHI", "ESGD", "SCZ", "ESGE", "EEMA", "EUFN", "IEUS", "MPCT", "ENZL", "QAT", "UAE", "IBB", "SOXX", "EMIF", "ICLN", "WOOD", "INDY", "ISHG", "IGOV", "ISLE", "ISRL", "ITI", "ITRI", "ITRN", "ITUS", "IVENC", "IVFGC", "IVFVC", "XXIA", "IXYS", "IZEA", "JJSF", "MAYS", "JBHT", "JCOM", "JASO", "JKHY", "JACK", "JXSB", "JAGX", "JAKK", "JMBA", "JRVR", "JSML", "JSMD", "JASN", "JASNW", "JAZZ", "JD", "JSYN", "JSYNR", "JSYNU", "JSYNW", "JBLU", "JTPY", "JCTCF", "JIVE", "WYIG", "WYIGU", "WYIGW", "JBSS", "JOUT", "JNP", "JUNO", "KTWO", "KALU", "KALV", "KMDA", "KNDI", "KPTI", "KBSF", "KCAP", "KRNY", "KELYA", "KELYB", "KMPH", "KFFB", "KERX", "KEQU", "KTEC", "KTCC", "KFRC", "KE", "KBAL", "KIN", "KGJI", "KINS", "KONE", "KNSL", "KIRK", "KITE", "KTOV", "KTOVW", "KLAC", "KLRE", "KLREU", "KLREW", "KLXI", "KONA", "KZ", "KOPN", "KRNT", "KOSS", "KWEB", "KTOS", "KLIC", "KURA", "KVHI", "FSTR", "LJPC", "LSBK", "LSBG", "LBAI", "LKFN", "LAKE", "LRCX", "LAMR", "LANC", "LCA", "LCAHU", "LCAHW", "LNDC", "LARK", "LMRK", "LMRKO", "LMRKP", "LE", "LSTR", "LNTH", "LTRX", "LSCC", "LAWS", "LAYN", "LCNB", "LBIX", "LGCY", "LGCYO", "LGCYP", "LTXB", "DDBI", "EDBI", "LVHD", "UDBI", "LMAT", "TREE", "LXRX", "LGIH", "LHCG", "LLIT", "LBRDA", "LBRDK", "LEXEA", "LEXEB", "LBTYA", "LBTYB", "LBTYK", "LILA", "LILAK", "LVNTA", "LVNTB", "QVCA", "QVCB", "BATRA", "BATRK", "LMCA", "LMCK", "LSXMA", "LSXMB", "LSXMK", "TAX", "LTRPA", "LTRPB", "LPNT", "LCUT", "LFVN", "LWAY", "LGND", "LTBR", "LPTH", "LMB", "LLNW", "LMNR", "LINC", "LECO", "LIND", "LINDW", "LLTC", "LBIO", "LIOX", "LPCN", "LQDT", "LFUS", "LIVN", "LOB", "LIVE", "LPSN", "LKQ", "LMFA", "LMFAW", "LMIA", "LOGI", "LOGM", "EVAR", "CNCR", "LONE", "LTEA", "LORL", "LOXO", "LPTN", "LPLA", "LRAD", "LYTS", "LULU", "LITE", "LMNX", "LMOS", "LUNA", "MBTF", "MACQ", "MACQU", "MACQW", "MIII", "MIIIU", "MIIIW", "MBVX", "MCBC", "MFNC", "MTSI", "MCUR", "MGNX", "MDGL", "MAGS", "MGLN", "MPET", "MGIC", "CALL", "MNGA", "MGYR", "MHLD", "MSFG", "COOL", "MMYT", "MBUU", "MLVF", "MAMS", "TUSK", "MANH", "LOAN", "MNTX", "MTEX", "MNKD", "MANT", "MARA", "MCHX", "MARPS", "MRNS", "MKTX", "MRLN", "MAR", "MBII", "MRTN", "MMLP", "MRVL", "MASI", "MTCH", "MATN", "MTLS", "MTRX", "MAT", "MATR", "MATW", "MXIM", "MXPT", "MXWL", "MZOR", "MBFI", "MBFIP", "MCFT", "MGRC", "MDCA", "MFIN", "MFINL", "MDGN", "MTBC", "MTBCP", "MNOV", "MDSO", "MDGS", "MDWD", "MDVX", "MDVXW", "MEDP", "MEET", "MEIP", "MPEL", "MLNX", "MELR", "MEMP", "MENT", "MTSL", "MELI", "MBWM", "MERC", "MBVT", "MRCY", "EBSB", "VIVO", "MMSI", "MACK", "MSLI", "MRUS", "MLAB", "MESO", "CASH", "MBLX", "MEOH", "MFRI", "MGCD", "MGEE", "MGPI", "MCHP", "MU", "MICT", "MICTW", "MSCC", "MSFT", "MSTR", "MVIS", "MPB", "MTP", "MCEP", "MBRG", "MBCN", "MSEX", "MSBI", "MOFG", "MIME", "MDXG", "MNDO", "MB", "NERV", "MRTX", "MIRN", "MSON", "MIND", "MINDP", "MITK", "MITL", "MKSI", "MMAC", "MINI", "MOBL", "MOCO", "MDSY", "MLNK", "MBRX", "MNTA", "MOMO", "MCRI", "MDLZ", "MGI", "MPWR", "TYPE", "MNRO", "MRCC", "MNST", "MSDI", "MSDIW", "MHGC", "MORN", "MOSY", "MTFB", "MTFBW", "MPAA", "MDM", "MOXC", "MRVC", "MSBF", "MSG", "MTGE", "MTGEP", "MTSC", "LABL", "MFSF", "MYSZ", "MYL", "MYOK", "MYOS", "MYRG", "MYGN", "NBRV", "NAKD", "NNDM", "NANO", "NSTG", "NH", "NK", "NSSC", "NDAQ", "NTRA", "NATH", "NAUH", "NKSH", "FIZZ", "NCMI", "NCOM", "NGHC", "NGHCN", "NGHCO", "NGHCP", "NGHCZ", "NHLD", "NATI", "NRCIA", "NRCIB", "NSEC", "NWLI", "NAII", "NHTC", "NATR", "BABY", "NAVI", "NBTB", "NCIT", "NKTR", "NEOG", "NEO", "NEON", "NEOS", "NEOT", "NVCN", "NEPT", "UEPS", "NETE", "NTAP", "NTES", "NFLX", "NTGR", "NLST", "NTCT", "NTWK", "CUR", "NBIX", "NDRM", "NURO", "NUROW", "NYMT", "NYMTO", "NYMTP", "NLNK", "NWS", "NWSA", "NEWS", "NEWT", "NEWTL", "NEWTZ", "NXEO", "NXEOU", "NXEOW", "NXST", "NVET", "NFEC", "EGOV", "NICE", "NICK", "NCBS", "NIHD", "NVLS", "NMIH", "NNBR", "NDLS", "NDSN", "NSYS", "NBN", "NTIC", "NTRS", "NTRSP", "NFBK", "NRIM", "NWBI", "NWBO", "NWBOW", "NWPX", "NCLH", "NWFL", "NVFY", "NVMI", "NVDQ", "NOVN", "NOVT", "NVAX", "NVCR", "NVGN", "NUAN", "NMRX", "NTNX", "NUTR", "NTRI", "NUVA", "NVTR", "QQQX", "NVEE", "NVEC", "NVDA", "NXPI", "NXTM", "NXTD", "NXTDW", "NYMX", "OIIM", "OVLY", "OASM", "OBLN", "OBCI", "OPTT", "ORIG", "OSHC", "OCFC", "OCRX", "OCLR", "OFED", "OCUL", "OCLS", "OCLSW", "OMEX", "ODP", "OFS", "OHAI", "OVBC", "OHRP", "ODFL", "OLBK", "ONB", "OPOF", "OSBC", "OSBCP", "OLLI", "ZEUS", "OFLX", "OMER", "OMCL", "ON", "OTIV", "ONS", "ONSIW", "ONSIZ", "OGXI", "OMED", "ONTX", "ONTXW", "ONCS", "OHGI", "ONVI", "OTEX", "OPXA", "OPXAW", "OPGN", "OPGNW", "OPHT", "OPK", "OBAS", "OCC", "OPHC", "OPB", "ORMP", "OSUR", "ORBC", "ORBK", "ORLY", "OREX", "ONVO", "SEED", "OACQ", "OACQR", "OACQU", "OACQW", "OESX", "ORIT", "ORRF", "OFIX", "OSIS", "OSIR", "OSN", "OTEL", "OTIC", "OTTW", "OTTR", "OVAS", "OSTK", "OXBR", "OXBRW", "OXFD", "OXLC", "OXLCN", "OXLCO", "PFIN", "PTSI", "PCAR", "PACE", "PACEU", "PACEW", "PACB", "PCBK", "PEIX", "PMBC", "PPBI", "PAAC", "PAACR", "PAACU", "PAACW", "PCRX", "PACW", "PTIE", "PAAS", "PNRA", "PANL", "PZZA", "FRSH", "PBNC", "PRTK", "PRXL", "PCYG", "PSTB", "PKBK", "PRKR", "PKOH", "PARN", "PTNR", "PBHC", "PATK", "PNBK", "PATI", "PEGI", "PDCO", "PTEN", "PAVM", "PAVMW", "PAYX", "PCTY", "PYDS", "PYPL", "PBBI", "CNXN", "PCMI", "PCTI", "PDCE", "PDFS", "PDLI", "PDVW", "SKIS", "PGC", "PEGA", "PCO", "PENN", "PFLT", "PNNT", "PWOD", "PTXP", "PEBO", "PEBK", "PFBX", "PFIS", "PBCT", "PUB", "PRCP", "PPHM", "PPHMP", "PRFT", "PFMT", "PERF", "PERI", "PESI", "PTX", "PERY", "PGLC", "PETS", "PFSW", "PGTI", "PZRX", "PHII", "PHIIK", "PAHC", "PHMD", "PLAB", "PICO", "PIRS", "PPC", "PME", "PNK", "PNFP", "PPSI", "PXLW", "PLPM", "PLXS", "PLUG", "PLBC", "PSTI", "PBSK", "PNTR", "PCOM", "POOL", "POPE", "PLKI", "BPOP", "BPOPM", "BPOPN", "PBIB", "PTLA", "PBPB", "PCH", "POWL", "POWI", "PSIX", "DWLV", "DWIN", "DWTR", "IDLB", "PRFZ", "PAGG", "PSAU", "IPKW", "LDRI", "LALT", "PNQI", "PDBC", "QQQ", "USLB", "PSCD", "PSCC", "PSCE", "PSCF", "PSCH", "PSCI", "PSCT", "PSCM", "PSCU", "VRIG", "PRAA", "PRAH", "PRAN", "PFBC", "PLPC", "PFBI", "PINC", "LENS", "PRGX", "PSMT", "PBMD", "PNRG", "PRMW", "PRIM", "BTEC", "GENY", "PSET", "PY", "PSC", "PRZM", "PVTB", "PVTBP", "PDEX", "IPDN", "PFIE", "PGNX", "PRGS", "DNAI", "PFPT", "PRPH", "PRQR", "BIB", "UBIO", "TQQQ", "ZBIO", "SQQQ", "BIS", "PSEC", "PTGX", "PRTO", "PTI", "PRTA", "PVBC", "PROV", "PBIP", "PSDV", "PMD", "PTC", "PTCT", "PULM", "PLSE", "PCYO", "IMED", "FINQ", "PXS", "QADA", "QADB", "QCRH", "QGEN", "QIWI", "QLTI", "QRVO", "QCOM", "QSII", "QBAK", "QLYS", "QTNA", "QRHC", "QUIK", "QDEL", "QPAC", "QPACU", "QPACW", "QNST", "QUMU", "QUNR", "QTNT", "RRD", "RARX", "RADA", "RDCM", "ROIA", "ROIAK", "RSYS", "RDUS", "RDNT", "RDWR", "RMBS", "RAND", "RLOG", "GOLD", "RNDB", "RPD", "RAVE", "RAVN", "ROLL", "TALL", "RICK", "RCMT", "RDI", "RDIB", "RGSE", "RELY", "RNWK", "RP", "RETA", "DAX", "QYLD", "RCON", "REPH", "RRGB", "RRR", "RDHL", "REGN", "RGNX", "RGLS", "REIS", "RELV", "MARK", "RNST", "REGI", "RNVA", "RNVAZ", "RCII", "RTK", "RGEN", "RPRX", "RBCAA", "FRBK", "REFR", "RESN", "RECN", "ROIC", "SALE", "RTRX", "RVNC", "RVEN", "RVLT", "RWLK", "REXX", "RFIL", "RGCO", "RIBT", "RIBTW", "RELL", "RIGL", "NAME", "RNET", "RTTR", "RVSB", "RLJE", "RMGN", "ROBO", "FUEL", "RMTI", "RCKY", "RMCF", "ROKA", "ROSG", "ROST", "RBPAA", "RGLD", "RPXC", "RTIX", "RBCN", "RUSHA", "RUSHB", "RUTH", "RXII", "RYAAY", "STBA", "SANW", "SCAC", "SCACU", "SCACW", "SBRA", "SBRAP", "SABR", "SAEX", "SAFT", "SAGE", "SAIA", "SAJA", "SALM", "SAL", "SAFM", "SASR", "SGMO", "SANM", "GCVRZ", "SPNS", "SRPT", "SBFG", "SBFGP", "SBAC", "SCSC", "SMIT", "SCHN", "SCHL", "SCLN", "SGMS", "SNI", "SCYX", "SEAC", "SBCF", "STX", "SHIP", "SRSC", "SHLD", "SHLDW", "SHOS", "SPNE", "SGEN", "EYES", "SCWX", "SNFCA", "SEIC", "SLCT", "SCSS", "SIR", "SELB", "SIGI", "LEDS", "SMTC", "SENEA", "SENEB", "SNH", "SNHNI", "SNHNL", "SNMX", "SRTS", "SRTSW", "SQBG", "MCRB", "SREV", "SFBS", "SEV", "SVBI", "SGOC", "SMED", "SHSP", "SHEN", "SHLO", "TYHT", "SHPG", "SCVL", "SHBI", "SHOR", "SFLY", "SIFI", "SIEB", "SIEN", "BSRR", "SWIR", "SIFY", "SIGM", "SGMA", "SGNL", "SBNY", "SBNYW", "SLGN", "SILC", "SLAB", "SIMO", "SPIL", "SSRI", "SAMG", "SFNC", "SLP", "SINA", "SBGI", "SINO", "SVA", "SIRI", "SITO", "SKYS", "SKLN", "SPU", "SKYW", "SWKS", "ISM", "JSM", "OSM", "SLM", "SLMAP", "SLMBP", "SND", "SMBK", "SWHC", "SMSI", "SMTX", "LNCE", "SRAX", "SCKT", "SODA", "SOHU", "SLRC", "SUNS", "SEDG", "SONC", "SOFO", "SONS", "SPHS", "SORL", "SRNE", "SOHO", "SOHOB", "SOHOM", "SFBC", "SSB", "SFST", "SMBC", "SONA", "SBSI", "OKSB", "SP", "SPAN", "SBSA", "SGRP", "SPKE", "ONCE", "SPAR", "SPTN", "DWFI", "SPPI", "ANY", "SPEX", "SPI", "SAVE", "SPLK", "SPOK", "SPWH", "SBPH", "FUND", "SFM", "SPSC", "SSNC", "STAA", "STAF", "STMP", "STLY", "SPLS", "SBLK", "SBLKL", "SBUX", "STRZA", "STRZB", "STFC", "STBZ", "SNC", "STDY", "GASS", "STLD", "SMRT", "STLR", "STLRU", "STLRW", "SBOT", "STEM", "STML", "SRCL", "SRCLP", "STRL", "SHOO", "SSFN", "SYBT", "BANX", "SGBK", "SSKN", "SSYS", "STRT", "STRS", "STRA", "STRM", "SBBP", "STB", "SCMP", "SUMR", "SMMF", "SSBI", "SMMT", "SNBC", "SNHY", "SNDE", "SEMI", "SNSS", "STKL", "SPWR", "RUN", "SBCP", "SSH", "SUNW", "SMCI", "SPCB", "SCON", "SGC", "SUPN", "SPRT", "SGRY", "SCAI", "SRDX", "SBBX", "SIVB", "SIVBO", "SYKE", "SYMC", "SYNC", "SYNL", "SYNA", "SNCR", "SNDX", "SGYP", "SGYPU", "SGYPW", "ELOS", "SNPS", "SYNT", "SYMX", "SYUT", "SYPR", "SYRS", "SYRX", "TROW", "TTOO", "TRHC", "TCMD", "TAIT", "TTWO", "TLND", "TNDM", "TLF", "TNGO", "TANH", "TPIV", "TEDU", "TASR", "TATT", "TAYD", "TCPC", "AMTD", "TEAR", "TECD", "TCCO", "TTGT", "TGLS", "TGEN", "TNAV", "TTEC", "TLGT", "TENX", "GLBL", "TERP", "TRTL", "TRTLU", "TRTLW", "TVIA", "TBNK", "TSRO", "TESO", "TSLA", "TESS", "TSRA", "TTEK", "TTPH", "TCBI", "TCBIL", "TCBIP", "TCBIW", "TXN", "TXRH", "TFSL", "TGTX", "ABCO", "ANDE", "TBBK", "BONT", "CG", "CAKE", "CHEF", "TCFC", "DSGX", "DXYN", "ENSG", "XONE", "FINL", "FBMS", "FLIC", "GT", "HABT", "HCKT", "HAIN", "FITS", "CUBA", "INTG", "JYNT", "KEYW", "KHC", "OLD", "MDCO", "MIK", "MIDD", "NAVG", "SLIM", "STKS", "ORG", "PCLN", "PRSC", "BITE", "RMR", "SPNC", "TTD", "ULTI", "YORW", "NCTY", "TBPH", "TST", "TCRD", "THLD", "TICC", "TTS", "TIL", "TSBK", "TIPT", "TITN", "TTNP", "TIVO", "TMUS", "TMUSP", "TKAI", "TNXP", "TISA", "TOPS", "TORM          ", "TRCH", "TSEM", "TWER", "CLUB", "TOWN", "TPIC", "TCON", "TSCO", "TWMC", "TACT", "TRNS", "TBIO", "TGA", "TA", "TANNI", "TANNL", "TANNZ", "TZOO", "TRVN", "TCBK", "TRIL", "TRS", "TRMB", "TRIB", "TRIP", "TSC", "TBK", "TRNC", "TROV", "TROVU", "TROVW", "TRUE", "THST", "TRUP", "TRST", "TRMK", "TSRI", "TTMI", "TUBE", "TCX", "TUES", "TOUR", "HEAR", "TUTI", "TUTT", "FOX", "FOXA", "TWIN", "TRCB", "USCR", "PRTS", "USEG", "GROW", "UBNT", "UFPT", "ULTA", "UCTT", "RARE", "ULBI", "UTEK", "UMBF", "UMPQ", "UNAM", "UNIS", "UBSH", "UNB", "UNXL", "QURE", "UBCP", "UBOH", "UBSI", "UCBA", "UCBI", "UCFC", "UBNK", "UFCS", "UIHC", "UNFI", "UBFO", "USLM", "UTHR", "UG", "UNTY", "OLED", "UEIC", "UFPI", "ULH", "USAP", "UVSP", "UPLD", "URRE", "URBN", "ECOL", "USAT", "USATP", "USAK", "UTMD", "UTSI", "VALX", "VALU", "VNDA", "BBH", "GNRX", "PPH", "VWOB", "VNQI", "VGIT", "VCIT", "VIGI", "VYMI", "VCLT", "VGLT", "VMBS", "VNR", "VNRAP", "VNRBP", "VNRCP", "VONE", "VONG", "VONV", "VTWO", "VTWG", "VTWV", "VTHR", "VCSH", "VGSH", "VTIP", "BNDX", "VXUS", "VRNS", "VDSI", "VBLT", "VASC", "VBIV", "WOOF", "VECO", "DGLD", "DSLV", "UGLD", "USLV", "TVIZ", "TVIX", "ZIV", "XIV", "VIIZ", "VIIX", "APPY", "VRA", "VCYT", "VSTM", "VCEL", "VRNT", "VRSN", "VRSK", "VBTX", "VRML", "VSAR", "VTNR", "VRTX", "VRTB", "VIA", "VIAB", "VSAT", "VIAV", "VICL", "VICR", "CIZ", "CEZ", "CID", "CIL", "CFO", "CFA", "CSF", "CDC", "CDL", "CSB", "CSA", "VBND", "VUSE", "VIDI", "VDTH", "VRAY", "VKTX", "VKTXW", "VBFC", "VLGEA", "VIP", "VNOM", "VIRC", "VA", "VIRT", "VRTS", "VRTU", "VISN", "VTGN", "VTL", "VIVE", "VVUS", "VOD", "VLTC", "VOXX", "VYGR", "VSEC", "VTVT", "VUZI", "VWR", "WGBS", "WBA", "WAFD", "WAFDW", "WASH", "WFBI", "WSBF", "WVE", "WAYN", "WSTG", "WCFB", "WDFC", "FLAG", "WEB", "WBMD", "WCST", "WB", "WEBK", "WEN", "WERN", "WSBC", "WTBA", "WSTC", "WMAR", "WABC", "WBB", "WSTL", "WDC", "WNEB", "WLB", "WPRT", "WEYS", "WHLR", "WHLRD", "WHLRP", "WHLRW", "WHF", "WHFBL", "WFM", "WILN", "WHLM", "WVVI", "WVVIP", "WLDN", "WLFC", "WLTW", "WIN", "WINT", "WING", "WINA", "WINS", "WTFC", "WTFCM", "WTFCW", "AGND", "AGZD", "HYND", "HYZD", "CXSE", "EMCG", "EMCB", "DGRE", "DXGE", "WETF", "DXJS", "DXKW", "GULF", "CRDT", "DGRW", "DGRS", "DXPS", "UBND", "WIX", "WMIH", "WBKC", "WWD", "WKHS", "WRLD", "JMU", "WPCS", "WPPGY", "WMGI", "WMGIZ", "WSFS", "WSFSL", "WSCI", "WVFC", "WYNN", "XBIT", "XELB", "XCRA", "XNCR", "XBIO", "XBKS", "XENE", "XGTI", "XGTIW", "XLNX", "XOMA", "XPLR", "XTLB", "XNET", "YHOO", "YNDX", "YIN", "YRCW", "YECO", "YY", "ZFGN", "ZAGG", "ZAIS", "ZBRA", "ZLTQ", "Z", "ZG", "ZN", "ZNWAA", "ZION", "ZIONW", "ZIONZ", "ZIOP", "ZIXI", "ZGNX", "ZSAN", "ZUMZ", "ZYNE", "ZNGA"];

Tickers.prototype.ticker = function () {
    var length = Tickers.TICKERS.length;
    var index = Math.floor(Math.random() * length);
    return Tickers.TICKERS[index];
};

var tickers = new Tickers();
var lipsum = new LoremIpsum();

function getLipsum(num) {
    var phrase = lipsum.generate(num + 2);
    return phrase.substring(0, 1).toUpperCase() + phrase.substring(1);
}

function randomNumber(max, signed) {
    var val = Math.random() * max;
    if (signed) val *= Math.random() > 0.5 ? 1 : -1;
    return val;
}

function randomSignedNumber(max, negative) {
    var val = Math.random() * max;
    return val * (negative ? -1 : 1);
}

function randomArray(length, max) {
    var i = 0;
    var arr = [];
    var rnd = Math.random();
    var num, sign;

    if (rnd >= 0.2 && rnd < 0.7) {
        sign = true;
    } else if (rnd >= 0.7) {
        sign = false;
    }

    for (; i < length; i++) {
        if (typeof sign === "undefined") {
            num = randomNumber(max, true);
        } else {
            num = randomSignedNumber(max, !sign);
        }

        arr[i] = num;
    }

    return arr;
}

var scatterplot = {
    item: function item() {
        var ticker = tickers.ticker();
        return {
            totalReturn: randomNumber(20, true),
            standardDeviation: randomNumber(20, true),
            weight: randomNumber(100),
            ticker: ticker
        };
    },

    category: function category() {
        var arr = [];
        var num = Math.ceil(Math.random() * 5);
        var i = 0;
        for (; i < num; i++) {
            arr.push(scatterplot.item());
        }

        return {
            category: getLipsum(2),
            data: arr
        };
    },

    data: function data() {
        var dataset = [];
        var num = Math.ceil(Math.random() * 5) + 1;
        var i = 0;

        for (; i < num; i++) {
            dataset.push(scatterplot.category());
        }

        return {
            benchmark: {
                totalReturn: randomNumber(20, true),
                standardDeviation: randomNumber(20, true)
            },
            data: dataset
        };
    }
};

var barchart = {
    data: function data(howMany, maxValue) {
        var dataset = [];
        var num = Math.ceil(Math.random() * 5) + 1;
        var i = 0;
        howMany = howMany || 7;
        maxValue = maxValue || 100;

        for (; i < num; i++) {
            dataset.push(barchart.series(howMany, maxValue));
        }

        return dataset;
    },

    data2: function data2(howMany, maxValue) {
        var dataset = [];
        var num = Math.ceil(Math.random() * 5) + 1;
        var i = 0;
        howMany = howMany || 7;
        maxValue = maxValue || 100;

        for (; i < num; i++) {
            dataset.push({
                name: "Data " + (i + 1),
                values: randomArray(howMany, maxValue)
            });
        }

        return dataset;
    },

    series: function series(howMany, maxValue) {
        return {
            name: getLipsum(2),
            values: randomArray(howMany, maxValue)
        };
    },

    categories: function categories(prefix, num) {
        var arr = [];
        var i = 0;
        for (; i < num; i++) {
            arr[i] = prefix + " " + (i + 1);
        }

        return arr;
    },

    xlabels: function xlabels(num) {
        var i = 0;
        var arr = [];
        for (; i < num; i++) {
            if (Math.random() > 0.7) {
                arr[i] = getLipsum(1);
            } else {
                arr[i] = null;
            }
        }

        return arr;
    }
};

var getRandomDate = function getRandomDate(start, end) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
};

var generateDates = function generateDates(range, amtOfDates) {
    var dates = [];

    var dateRange = void 0;
    switch (range) {
        case "hours":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2016, 0, 1), new Date(2016, 0, 2));
            };
            break;
        case "days":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2016, 0, 1), new Date(2016, 0, 6));
            };
            break;
        case "weeks":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2016, 0, 1), new Date(2016, 1, 28));
            };
            break;
        case "months":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2016, 0, 1), new Date(2016, 11, 1));
            };
            break;
        case "quarters":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2015, 0, 1), new Date(2016, 12, 31));
            };
            break;
        case "years":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2010, 0, 1), new Date(2016, 11, 0));
            };
            break;
        default:
            console.error("range required to generate dates");
            break;
    }

    for (var i = 0; i < amtOfDates; i++) {
        dates.push(dateRange());
    }

    return dates;
};

function getIncrementalValue(increment) {
    var positive = Math.floor(Math.random() * 2 + 1) === 1 ? false : true;

    if (positive) {
        return Math.floor(Math.random() * increment);
    } else {
        return -Math.floor(Math.random() * increment);
    }
}

//***** line chart *****/

var LineGenerator = function LineGenerator(dateRange) {
    this.leng = 50;
    this.dates = generateDates(dateRange, this.leng);
};

LineGenerator.prototype.generateDataset = function (opts) {
    return {
        y1: this.generateLineData(opts),
        y2: this.generateLineData(opts)
    };
};

LineGenerator.prototype.generateLineData = function (opts) {
    var groupName = Math.floor(Math.random() * 2 + 1) === 1 ? "y2" : "y1";
    var time = new Date();
    var name = time.getMilliseconds() + Math.floor(Math.random() * 999).toString();
    var segments = [];
    var currentValue = Math.floor(Math.random() + opts.minValue);

    for (var i = 0; i < opts.segments; i++) {
        var newValue;
        if (currentValue >= opts.maxValue || currentValue + opts.increment > opts.maxValue) {
            newValue = currentValue - opts.increment;
        } else {
            newValue = currentValue + getIncrementalValue(opts.increment);
        }

        segments.push({
            name: name,
            value: newValue,
            date: this.dates[i],
            groupName: groupName
        });
        currentValue = newValue;
    }
    return segments;
};

/**** end linechart */

module.exports = {
    ticker: tickers.ticker,
    lipsum: getLipsum,
    number: randomNumber,
    array: randomArray,
    scatterplot: scatterplot,
    barchart: barchart,
    getRandomDate: getRandomDate,
    generateDates: generateDates,
    linechart: LineGenerator,
    crmatrix: crmatrix
};

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Calls a function if exists. The first argument should be the function to call followed by the arguments.
 *
 * @return {Object} Undefined if there is no function to call or what the function returns.
 */

var callFn = function callFn() {
    var args = Array.prototype.slice.call(arguments, 2);
    var context = arguments[0];
    var fn = arguments[1];

    if (fn) {
        return fn.apply(context, args);
    }
};

module.exports = {
    call: callFn
};

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    /**
     * Returns how many digits have a number.
     * @param {number} number Number to inspect. Rquired.
     * @param {Number} base Numeric base.
     * @returns {Number}
     */
    digits: function digits(number) {
        var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

        var digits = 0;

        while (number >= 1) {
            number = number / base;
            digits++;
        }

        return digits;
    },
    /**
    * @method isNumber
    * @desc Judge if a value is a valid number or a valid string number
    * @param literals value
    * Return Boolean
    */
    isNumber: function isNumber(value) {
        if (typeof value === "number" && isFinite(value)) {
            return true;
        }
        if (typeof value === "string" && value !== "" && !isNaN(value - 0)) {
            return true;
        }
        return false;
    }

};

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CARDINAL_STR = "$$";

/**
 * It returns either the original value if zero or positive, or, if negative or NaN, the value with an em dash.
 *
 * @param {Number} A single number.
 * @return {Number || String} 10, "—10", "NaN", ...
 */
function convertDashToEnDash(val) {
    var stringed = val.toString();

    if (stringed === "NaN") {
        return "\u2013";
    }

    if (stringed[0] === "-") {
        var sliced = stringed.slice(1);
        sliced = "\u2013" + sliced;
        return sliced;
    }

    return val;
}
/**
 * Generates a Unique ID.
 * @returns {String} New unique ID.
 */
var UID = function UID() {
    return "_" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5));
};

/**
 * Converts a string in dashed format.
 *
 * @param {String} str String to convert.
 * @returns {String}
 */
function dashify(str) {
    str = str.replace(/\s+/g, "-").toLowerCase();
    return str;
}

/**
 * Compiles a string template agains a context and returns a new string.
 * <code>
 * var template =
 * 'My skills:' +
 * '<%if(this.showSkills) {%>' +
 *    '<%for(var index in this.skills) {%>' +
 *    '<a href="#"><%this.skills[index]%></a>' +
 *   '<%}%>' +
 * '<%} else {%>' +
 *    '<p>none</p>' +
 * '<%}%>';
 * console.log(TemplateEngine(template, {
 *    skills: ["js", "html", "css"],
 *    showSkills: true
 * }));
 * </code>
 * @param {String} html Template string.
 * @param {Object} data Context object that contains the data.
 * @returns {String}
 */
var template = function template(html, data) {
    var re = /<%([^%>]+)?%>/g;
    var reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g;
    var code = "var r=[];\n";
    var cursor = 0;
    var match;

    var add = function add(line, js) {
        js ? code += line.match(reExp) ? line + "\n" : "r.push(" + line + ");\n" : code += line !== "" ? "r.push('" + line.replace(/"/g, "\\'") + "');\n" : ""; //jshint ignore:line
        return add;
    };

    match = re.exec(html);
    while (match) {
        add(html.slice(cursor, match.index))(match[1], true);
        cursor = match.index + match[0].length;
        match = re.exec(html);
    }

    add(html.substr(cursor, html.length - cursor));
    code += "return r.join('');";
    return new Function(code.replace(/[\r\t\n]/g, "")).apply(data); // jshint ignore:line
};

/**
 * Adds a prefix based on an index.
 *
 * @param {String} str
 * @param {Number} index
 * @returns {String}
 */
function mask(str, index) {
    return index + CARDINAL_STR + str;
}

/**
 * Remove index based prefix.
 *
 * @param {String} str
 * @returns {String}
 */
function unmask(str) {
    var indx = str.indexOf(CARDINAL_STR);
    return str.substr(indx + CARDINAL_STR.length);
}

/**
 * Get pixel with of string appended to the DOM
 *
 * @param {String} txt
 * @param {String} fontname = font family, e.g., "'UniversBold', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif"
 * @param {Number} fontsize, e.g., 16
 * @returns {String}
 */
function getTextWidth(txt, fontname, fontsize) {
    var e = document.createElement('span');
    e.style.fontSize = fontsize;
    e.style.fontFamily = fontname;
    e.innerHTML = txt;
    document.body.appendChild(e);
    var w = e.getBoundingClientRect().width;
    document.body.removeChild(e);
    return w;
}

/**
 * To get the pixel width of the longest string in the data set
 *
 * @param {String} txt
 * @param {String} fontname = font family, e.g., "'UniversBold', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif"
 * @param {Number} fontsize, e.g., 16
 * @returns {String}
 */
function getLongestTextStringWidth(data, font, size) {

    font = font || "'UniversBold', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif";
    size = size || 16;

    var longest = 0;
    var value;

    data.forEach(function (obj) {
        if (obj.value != null && obj.value.toString().length > longest) {
            longest = obj.value.toString().length;
            value = obj.value;
        }
    });

    var w = getTextWidth(value, font, size);
    return w;
}

module.exports = {
    convertDashToEnDash: convertDashToEnDash,
    dashify: dashify,
    template: template,
    UID: UID,
    mask: mask,
    unmask: unmask,
    getLongestTextStringWidth: getLongestTextStringWidth
};

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var object = __webpack_require__(2);

/**
 * Returns the path for a rounded rectangle.
 * @param {Number} x X position.
 * @param {Number} y Y position.
 * @param {Number} w Width.
 * @param {Number} h Heigth.
 * @param {Number} r Radius.
 * @param {Boolean} tl Top-Left.
 * @param {Boolean} tr Top-Right.
 * @param {Boolean} bl Bottom-Left.
 * @param {Boolean} br Bottom-Right.
 * @returns {String} Rounded Rectangle path.
 */
var roundedRect = function roundedRect(x, y, w, h, r, tl, tr, bl, br) {
    var result;
    result = "M" + (x + r) + "," + y;
    result += "h" + (w - 2 * r);
    if (tr) {
        result += "a" + r + "," + r + " 0 0 1 " + r + "," + r;
    } else {
        result += "h" + r;result += "v" + r;
    }

    result += "v" + (h - 2 * r);
    if (br) {
        result += "a" + r + "," + r + " 0 0 1 " + -r + "," + r;
    } else {
        result += "v" + r;result += "h" + -r;
    }

    result += "h" + (2 * r - w);
    if (bl) {
        result += "a" + r + "," + r + " 0 0 1 " + -r + "," + -r;
    } else {
        result += "h" + -r;result += "v" + -r;
    }

    result += "v" + (2 * r - h);
    if (tl) {
        result += "a" + r + "," + r + " 0 0 1 " + r + "," + -r;
    } else {
        result += "v" + -r;result += "h" + r;
    }

    result += "z";
    return result;
};

/**
 * Get an SVG Text width by adding it, getting the width and removing it.
 * @param {D3.Object} svgContainer Container where the text is gonna be attached.
 * @param {String} text Text to test width.
 * @return {Number} Calculated width.
 */
var getSVGTextWidth = function getSVGTextWidth(svgContainer, text, className) {
    var el = svgContainer.append("text").classed(className, true && className).text(text);
    var width = el.node().getBoundingClientRect().width;
    el.remove();
    return width;
};

/**
 * Get the longest String in pixels from a given array of data.
 * @param {D3.Object} svgContainer Container where the texts are gonna be attached.
 * @param {Array} data Array containig the texts.
 * @param {String|Function}? accessor description
 */
var getGreaterSVGTextWidth = function getGreaterSVGTextWidth(svgContainer, data, accessor) {
    var greatest = 0;
    var text, width;
    data.forEach(function (item, i) {
        text = object.extract(item, accessor, i);
        width = getSVGTextWidth(svgContainer, text);
        greatest = width > greatest ? width : greatest;
    });

    return greatest;
};

/**
 * Get the total width of all Strings in pixels from a given array of data.
 * @param {D3.Object} svgContainer Container where the texts are gonna be attached.
 * @param {Array} data Array containig the texts.
 * @param {String|Function}? accessor description
 */
var getTotalSVGTextWidth = function getTotalSVGTextWidth(svgContainer, data, accessor) {
    var total = 0;
    var text, width;
    data.forEach(function (item, i) {
        var itemStr = " legend-";
        var itemName = String(item.className["baseVal"]).indexOf("legend-item") !== -1 ? String(item.className["baseVal"]).split(itemStr)[0] : String(item.className["baseVal"]); //for IE spacing
        text = item[0] ? item[0].classList[0] : itemName;
        var current = item.classList ? item.classList[0] : text;
        width = getSVGTextWidth(svgContainer, current) + 15;
        if (item instanceof SVGElement) {
            width = item.getBoundingClientRect().width > width ? item.getBoundingClientRect().width : width;
        }
        total += width;
    });
    return total;
};

module.exports = {
    roundedRect: roundedRect,
    getSVGTextWidth: getSVGTextWidth,
    getGreaterSVGTextWidth: getGreaterSVGTextWidth,
    getTotalSVGTextWidth: getTotalSVGTextWidth
};

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * morningstar-base-charts
 *
 * Copyright © 2016 . All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
var mds_constants = __webpack_require__(7).constants;
var mds_chart_color = mds_constants["chart-color"];

module.exports = {
    colors: [mds_chart_color["1"], mds_chart_color["2"], mds_chart_color["3"], mds_chart_color["4"], mds_chart_color["5"], mds_chart_color["6"], mds_chart_color["7"]],
    canvasDefaults: {
        axesSpacing: 5,
        margin: { top: 20, right: 20, bottom: 20, left: 20 }
    }
};

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    // d3 overrides
    //----------------------------------

    d3.selection.prototype.first = function () {
        if (!this[0]) {
            return d3.select();
        }

        return d3.select(this[0][0]);
    };

    d3.selection.prototype.last = function () {
        if (!this[0]) {
            return d3.select();
        }

        var last = this.size() - 1;
        return d3.select(this[0][last]);
    };
    d3.selection.prototype.attrs = function (obj) {
        for (var attr in obj) {
            this.attr(attr, obj[attr]);
        }

        return this;
    };

    //---------------oOo-----------------
};

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



// jscs:disable safeContextKeyword

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Utils = __webpack_require__(3);

/**
 * Base object. Provides a way to Class inheritance and use of mixins.
 *
 * @example {@lang javascript}
 *  // Simple extension.
 *
 *  // Creates a Person class extending from Base.
 *  var Person = Base.extend({
 *      name: "John",
 *      greet: function () { return "Hello, my name is" + this.get("name") + ".";}
 *  });
 *  var person = new Person();
 *  person.greet(); // "Hello, my name is John."
 *
 *  // Extending Person
 *  var Musician = Person.extend({
 *      name: "Wolfgang",
 *      instrument: "Violin",
 *      greet: function () { return this.__super__.greet.call(this) + " I play the " + this.get("instrument"); }
 *  });
 *
 *  var mozart = new Musician();
 *  mozart.greet()  // Hello, my name is Wolfgang. I play the Violin.
 *
 *  mozart.set("instrument", "Piano");
 *  mozart.greet()  // Hello, my name is Wolfgang. I play the Piano.
 * @example
 *  // Extension with mixins
 *
 *  // Mixin definition
 *  function DriverMixin () {}
 *  DriverMixin.prototype.drive = function() { return this.get("name") + "is driving a" + this.get("vehicle"); };
 *
 *  var Driver = Person.extend(DriverMixin, {
 *      vehicle: "Motorcycle"
 *  })
 *
 *  var juanPabloMontoya = new Driver();
 *
 *  juanPabloMontoya.drive(); // "John is driving a motorcycle"  <-- That's incorrect
 *  juanPabloMontoya.set("name", "Juan Pablo");
 *  juanPabloMontoya.set("vehicle", "Formula Car");
 *  juanPabloMontoya.drive(); // "Juan Pablo is driving a Formula Car"  <-- Now That's correct
 * @param {Object} options Class' instance attributes to be setted. Overrides existing ones or create a new attribute if it does not exist.
 * @constructor
 */
var Base = function Base() {};

Base.prototype = {
    __attributes: null,
    __watchers: null,
    /**
     * Sets the <i>value</i> under the passed <i>key</i> into the attributes's store.
     * @param {any} key Name of the attribute to store.
     * @param {any} value Attribute's value.
     * @returns {Base} object's instance to allow chainability.
     */
    set: function set(key, value) {
        this.__attributes[key] = value;
        this._checkWatcher(key, value);
        return this;
    },

    /**
     * Search the attribute's store and returns its value.
     * @param {any} key Attribute's key to retrieve.
     * @returns {Object} Attribute's value.
     */
    get: function get(key) {
        return this.__attributes[key];
    },

    /**
     * Initialize object attributes.
     */
    _initAttrs: function _initAttrs(options) {
        for (var key in options) {
            this.set(key, options[key]);
        }
    },

    /**
     * Set an attribute bound watcher.
     * @param {String} attribute Attribute's name.
     * @param {Function} handler Method to execute when the attribute changes.
     */
    watch: function watch(attribute, handler) {
        var watcher = this.__watchers[attribute];
        var handlers, length, value;

        if (watcher) {
            handlers = watcher.handlers;
            length = handlers.filter(function (fn) {
                return "" + fn === "" + handler;
            }).length;
            if (!length) {
                handlers.push(handler);
            }
        } else {
            value = this.__attributes ? this.__attributes[attribute] : undefined;
            this.__watchers[attribute] = {
                oldValue: value,
                handlers: [handler]
            };
        }
    },

    /**
     * Remove all handlers attached to an attribute key or just the one that contains the specified handler if it is passed as paramter
     * @param {String} attribute Attribute's name.
     * @param {Function} handler Optional. If not passed removes all handlers attached to the attribute.
     */
    unwatch: function unwatch(attribute, handler) {
        var watcher = this.__watchers[attribute];
        var handlers;

        if (watcher) {
            if (!handler) {
                delete this.__watchers[attribute];
            } else {
                handlers = watcher.handlers;
                handlers.splice(handlers.indexOf(handler), 1);
            }
        }
    },

    /**
     * Removes all attributes watchers.
     */
    unwatchAll: function unwatchAll() {
        this.__watchers = {};
    },

    /**
     * Checks if the attribute have been modified and execute the handler function.
     * @param {String} attribute Attribute's name.
     * @param {Object} newValue New attribute's value.
     */
    _checkWatcher: function _checkWatcher(attribute, newValue) {
        var watcher = this.__watchers[attribute];

        if (watcher && newValue !== watcher.oldValue) {
            watcher.handlers.forEach(function (handler) {
                handler(newValue, watcher.oldValue);
                watcher.oldValue = newValue;
            });
        }
    }

};

/**
 * Method that returns a new class extending the class that calls it. If mixins are
 * passed its methods are extended to the resultant class too.
 * @static
 * @returns {Class}
 */
Base.extend = function () {
    var properties = {};
    var mixins = [];
    var i = 0;
    var arg = arguments[i++];
    var parent = this;
    var parentDefaults = parent.prototype.__defaults__ || {};
    var defaults = {};
    var child, key, value;

    Utils.object.copy(defaults, parentDefaults);

    while ((typeof arg === "undefined" ? "undefined" : _typeof(arg)) !== "object") {
        mixins.push(arg);
        arg = arguments[i++];
    }

    properties = arg;

    child = function child(options) {
        parent.apply(this, arguments);

        this.__attributes = this.__attributes || {
            _id: new Date().getTime()
        };
        this.__watchers = {};
        for (key in this.__defaults__) {
            if (!this.__attributes[key]) {
                this.__attributes[key] = this.__defaults__[key];
            }
        }

        // Apply options
        if (options) {
            this._initAttrs(options);
        }

        if (properties.initializer && typeof properties.initializer === "function") {
            properties.initializer.call(this);
        }

        mixins.forEach(function (mixin) {
            if (mixin.prototype.initializer) {
                mixin.prototype.initializer.call(this);
            }
        }.bind(this));
    };

    // Copying statics from old class to new one.
    for (key in parent) {
        if (parent.hasOwnProperty(key)) {
            child[key] = parent[key];
        }
    }

    child.prototype = Object.create(parent.prototype);

    for (key in parent.prototype) {
        value = parent.prototype[key];
        if (typeof value !== "function") {
            if (key !== "attributes" && key !== "__super__" && key !== "__defaults__") {
                defaults[key] = value;
            }
        }
    }

    // Adding/overwriting new properties into child prototype.
    if (properties) {
        for (key in properties) {
            if (properties.hasOwnProperty(key)) {
                value = properties[key];
                if (typeof value === "function") {
                    child.prototype[key] = value;
                } else if (key !== "attributes" && key !== "__super__" && key !== "__defaults__") {
                    defaults[key] = value;
                }
            }
        }
    }

    mixins.forEach(function (mixin) {
        Utils.object.copy(child.prototype, mixin.prototype);
    });

    child.prototype.__defaults__ = Utils.object.clone(defaults);

    child.prototype.__super__ = parent.prototype;
    return child;
};

module.exports = Base;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = {"constants":{"color":{"white":"#ffffff","black":"#000000","neutral":{"12":"#1e1e1e","20":"#333333","37":"#5e5e5e","50":"#808080","67":"#ababab","80":"#cccccc","90":"#e5e5e5","95":"#f2f2f2"},"blue":{"23":"#004376","32":"#005ba1","36":"#006fba","38":"#1f55a5","41":"#0077cf","44":"#008dde"},"green":{"34":"#00af41"},"dark-green":{"34":"#518428"},"teal":{"19":"#005f5f"},"violet":{"46":"#6a4c9e"},"cyan":{"44":"#00a8e1"},"maroon":{"32":"#a50032"},"red":{"50":"#ff0000"},"yellow":{"48":"#f5c400"},"orange":{"54":"#ef7622"},"light-red":{"46":"#e60546"},"dark-violet":{"32":"#7d256f"},"dark-yellow":{"47":"#c19c31"},"aqua":{"37":"#00beaf"},"bright-orange":{"50":"#ff3c00"},"light-green":{"50":"#89bd40"}},"brand":{"blue":"#1f55a5","cyan":"#00a8e1"},"background-color":{"default":"#ffffff","light":"#f2f2f2","dark":"#1e1e1e","black":"#000000","alternative-row":{"default":"#e5e5e5","on-light":"#e5e5e5","on-dark":"#333333"},"feedback":{"error":"#ff0000","warning":"#f5c400"}},"text-color":{"primary":{"default":"#1e1e1e","on-light":"#1e1e1e","on-dark":"#ffffff"},"secondary":{"default":"#5e5e5e","on-light":"#5e5e5e","on-dark":"#ababab"},"link":{"default":"#006fba","on-light":"#006fba","on-dark":"#008dde"},"error":{"default":"#ff0000","on-light":"#ff0000","on-dark":"#ff0000"}},"interactive-color":{"primary":{"default":"#0077cf","hover":"#005ba1","focus":"#005ba1","active":"#004376"},"secondary":{"primary":"transparent","hover":"#5e5e5e","focus":"#5e5e5e","active":{"on-light":"#333333","on-dark":"#e5e5e5"}},"disabled":{"on-light":"#808080","on-dark":"#ababab"}},"visualization-color":{"asset-allocation":{"local-stocks":"#1f55a5","non-local-stocks":"#8faad2","stocks":"#1f55a5","real-estate":"#a50032","other":"#f5c400","cash":"#518428","bonds":"#ef7622","not-classified":"#e5e5e5"},"correlation":{"positive":"#1f55a5","negative":"#ef7622"},"sector":{"cyclical":"#ef7622","sensitive":"#1f55a5","defensive":"#518428"},"sustainability":"#1f55a5","valuation":{"under":"#00a8e1","fair":"#e5efef","over":"#ef7622"},"performance":{"positive":"#00af41","neutral-text":"#5e5e5e","neutral-chart":"#cccccc","negative":"#ff0000"}},"chart-color":{"1":"#1f55a5","2":"#a50032","3":"#f5c400","4":"#518428","5":"#00a8e1","6":"#6a4c9e","7":"#ef7622","8":"#005f5f","9":"#00af41","10":"#e60546","11":"#7d256f","12":"#c19c31","13":"#00beaf","14":"#ff3c00","15":"#89bd40"},"feedback-color":{"info":"#f2f2f2","error":"#ff0000","error-background":"#ffe5e5","warning":"#f5c400","warning-background":"#fef9e5","success":"#00af41","success-background":"#e5f7eb"},"font":{"family":{"sans-serif":"'Univers', HelveticaNeue, 'Helvetica Neue', Helvetica, Arial, sans-serif","monospace":"'Lucida Sans Typewriter', 'Lucida Console', monaco, 'Bitstream Vera Sans Mono', monospace"},"weight":{"thin":200,"light":300,"regular":400,"bold":600},"size":{"xs":"10px","s":"14px","m":"16px","l":"20px","base":"16px","default":"16px","heading-level-1":"45px","heading-level-2":"32px","heading-level-3":"28px","heading-level-4":"23px","heading-level-5":"20px","heading-level-6":"18px","code":"12px"},"line-height":{"headings":1.2,"body":1.375}},"border":{"separator":{"default":"solid 1px #e5e5e5","on-light":"solid 1px #cccccc","on-dark":"solid 1px #333333","on-title":"solid 2px #333333","color-on-light":"#cccccc","color-on-dark":"#333333"},"control":{"default":"solid 1px #808080","color":"#808080"},"container":{"default":"solid 1px #e5e5e5","color-default":"#e5e5e5"},"disabled":"solid 1px #808080","radius":{"panel":"12px","pill":"24px","round":"50%","s":"2px"}},"size":{"icon":{"s":"15px","m":"23px"}},"space":{"xs":"4px","s":"6px","m":"8px","l":"12px","xl":"16px","quarter-x":"2px","half-x":"4px","three-quarter-x":"6px","1-x":"8px","1-and-a-half-x":"12px","2-x":"16px","3-x":"24px","4-x":"32px","8-x":"64px","inset":{"xs":"4px","s":"6px","m":"8px","l":"12px","xl":"16px","quarter-x":"2px","half-x":"4px","three-quarter-x":"6px","1-x":"8px","1-and-a-half-x":"12px","2-x":"16px","3-x":"24px","4-x":"32px","8-x":"64px","stretch":{"s":"6px 12px","m":"8px 16px","l":"12px 24px"}},"inline-left":{"xs":"0 4px 0 0","s":"0 6px 0 0","m":"0 8px 0 0","l":"0 12px 0 0","xl":"0 16px 0 0","half-x":"0 4px 0 0","three-quarter-x":"0 6px 0 0","1-x":"0 8px 0 0","1-and-a-half-x":"0 12px 0 0","2-x":"0 16px 0 0"},"inline-right":{"xs":"0 0 0 4px","s":"0 0 0 6px","m":"0 0 0 8px","l":"0 0 0 12px","xl":"0 0 0 16px","half-x":"0 0 0 4px","three-quarter-x":"0 0 0 6px","1-x":"0 0 0 8px","1-and-a-half-x":"0 0 0 12px","2-x":"0 0 0 16px"},"stack":{"s":"0 0 6px","m":"0 0 8px","l":"0 0 12px","xl":"0 0 16px","quarter-x":"0 0 2px","half-x":"0 0 4px","three-quarter-x":"0 0 6px","1-x":"0 0 8px","1-and-a-half-x":"0 0 12px","2-x":"0 0 16px","3-x":"0 0 24px","4-x":"0 0 32px","8-x":"0 0 64px"}},"transition":{"color":{"link":"color, 300ms"}},"opacity":{"disabled":".4","overlay":".5"},"box-shadow":{"drop":"0 2px 4px 0 rgba(0, 0, 0, .08)","focus":"0 0 4px 2px rgba(#0077cf, .8)"},"z-index":{"low":1,"sticky":100,"modal-overlay":800,"modal-content":810,"top-of-the-world":900},"breakpoint":{"navigation":{"on-canvas-nav":"768px","wide":"1024px"}},"masthead":{"height":"50px","height-tall":"70px"},"site-navigation":{"height":"50px","vertical-width":"230px"}},"shared":[{"utils":true},{"color":true},{"fonts":true},{"accessibility":true},{"animation":true},{"size":true},{"bubbles":true},{"typography":true}],"components":[{"link":true},{"icon":true},{"button":true},{"button_group":true},{"card":true},{"navigation_container":true},{"container":true},{"data_table":true},{"dialog":true},{"form":true},{"combo_box":true},{"list_group":true},{"loader":true},{"modal":true},{"menu":true},{"notification":true},{"pagination":true},{"page_shell":true},{"popover":true},{"range_slider":true},{"search_field":true},{"stepper":true},{"switch":true},{"tag":true},{"tooltip":true},{"masthead":true},{"site_navigation":true},{"alert":true},{"top_hat":true},{"layout_grid":true}],"theme":"mds"}

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BASE = "mbc";
var CHART = BASE + "-chart";

module.exports = {
    AXES: BASE + "-axes",
    AXIS: BASE + "-axis",
    BACK: BASE + "-back-group",
    CANVAS: BASE + "-canvas",
    CHART_GROUP: CHART + "-group",
    CHART: CHART,
    CHARTS_AREA: CHART + "s-area",
    CONTAINER: CHART + "-container",
    DECK: CHART + "-deck",
    FOCUS: CHART + "-focus",
    FRONT: BASE + "-front-group",
    GRID: BASE + "-grid",
    GRID_LINE: BASE + "-grid-line",
    INNER: CHART + "-inner",
    LAYERS: BASE + "-layers",
    LEGEND_ITEM: CHART + "-legend-item",
    LEGEND: CHART + "-legend",
    TITLE: CHART + "-title",
    TOOLTIP: CHART + "-tooltip",
    TOOLTIP_CONTAINER: CHART + "-tooltip-container",
    ZONES: CHART + "-zones",
    ZONE: CHART + "-zone"
};

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates an AxesManager instance. AxesManagers centralize chart's axes
 * in order to access them transversely.<br>
 * @example
 * var axesManager = new AxesManager({"x", d3.svg.axis()})
 * @constructor
 * @param {object} axes <i>Optional</i>. A hashmap with chart's axes.
 */

function AxesManager(axes) {
    this._axes = axes || {};
}
/**
 * Sets or returns an axis. If no axis object is passsed then sets the axis.
 * @param  {String} axisName
 * @param  {D3.axis} axis
 *
 * @return {D3.axis}
 */
AxesManager.prototype.axis = function (axisName, axis) {
    if (!axisName) {
        return;
    }

    if (!axis) {
        return this._axes[axisName];
    }

    this._axes[axisName] = axis;
    return axis;
};

/**
 * Remove an axis from the collection.
 * @param {String} axisName Axis to remove.
 */
AxesManager.prototype.remove = function (axisName) {
    delete this._axes[axisName];
};

/**
 * Return the axes store object.
 *
 * @returns {Object} Hashmap that containing the axes.
 */
AxesManager.prototype.axes = function () {
    return this._axes;
};

module.exports = AxesManager;

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = morningstar;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* jshint browser: true */
/* globals d3 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(8), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, TimeSeriesLineChart, MBCCore) {
    'use strict';

    return {
        getFrequencySeriesData: getFrequencySeriesData,
        getDateRangeSeriesData: getDateRangeSeriesData,
        getLineChartData: getLineChartData,
        initializeLineChart: initializeLineChart,
        drawLineChart: drawLineChart,
        resize: resize
    };

    //Data Service
    //external function
    function getFrequencySeriesData(graphBaseValue, seriesData, monthCount) {
        var earliestCommonSeriesData = getEarliestCommonSeriesData(seriesData);
        var frequencyData = [];
        var handleSeriesData = function handleSeriesData(item) {
            var data = spliceSeriesData(graphBaseValue, item.data, monthCount),
                newFrequencyData = {
                name: item.name,
                data: rebasedSeriesData(graphBaseValue, data)
            },
                useLabel = item.useLabel;

            if (!morningstar.asterix.util.isUndefinedOrNull(useLabel)) {
                newFrequencyData.useLabel = useLabel;
            }

            frequencyData.push(newFrequencyData);
        };

        _.each(earliestCommonSeriesData, handleSeriesData);

        return frequencyData;
    }

    function getDateRangeSeriesData(graphBaseValue, seriesData, startDate, endDate) {
        var earliestCommonSeriesData = getEarliestCommonSeriesData(seriesData);

        var dateRangeData = [];

        var handleSeriesData = function handleSeriesData(item) {
            var data = sliceSeriesData(graphBaseValue, item.data, startDate, endDate),
                newDateRangeData = {
                name: item.name,
                data: rebasedSeriesData(graphBaseValue, data)
            },
                useLabel = item.useLabel;

            if (!morningstar.asterix.util.isUndefinedOrNull(useLabel)) {
                newDateRangeData.useLabel = useLabel;
            }

            dateRangeData.push(newDateRangeData);
        };

        _.each(earliestCommonSeriesData, handleSeriesData);

        return dateRangeData;
    }

    function getLineChartData(seriesData, labels) {
        var lineChartData = [];
        _.each(seriesData, function (item) {
            var obj = [],
                useLabel = morningstar.asterix.util.isUndefinedOrNull(item.useLabel) || item.useLabel,
                name = useLabel ? labels.get(item.name) : item.name;
            _.each(item.data, function (data) {
                obj.push({
                    name: name,
                    value: data.close,
                    date: morningstar.asterix.util.date.utcToStandard(new Date(data.date)),
                    groupName: 'y1'
                });
            });
            lineChartData.push(obj);
        });
        return lineChartData;
    }

    //internal function
    function addGraphBaseValueAsFirstDataToSeriesData(graphBaseValue, date, seriesData) {
        var firstData = {};
        firstData.endDate = translateDateToUTCLocalISOString(date);
        firstData.value = graphBaseValue;

        seriesData.unshift(firstData);

        return seriesData;
    }

    function getEarliestCommonSeriesData(seriesData) {
        if (seriesData.length === 0) {
            return seriesData;
        } else {
            var earliestCommonSeriesData = [];
            var count = _.min(seriesData, function (item) {
                return item.data.length;
            }).data.length;
            morningstar.asterix.util.each(seriesData, function (item) {
                var newEarliestCommonSeriesData = {
                    name: item.name,
                    data: item.data.slice(item.data.length - count)
                },
                    useLabel = item.useLabel;

                if (!morningstar.asterix.util.isUndefinedOrNull(useLabel)) {
                    newEarliestCommonSeriesData.useLabel = useLabel;
                }

                earliestCommonSeriesData.push(newEarliestCommonSeriesData);
            });
            return earliestCommonSeriesData;
        }
    }

    function translateDateToUTCLocalISOString(date) {
        var newDate = morningstar.asterix.util.date.convertToStandard(new Date(date));
        newDate = morningstar.asterix.util.date.addMonths(newDate, -1);
        return morningstar.asterix.util.date.toUTCLocalISOString(newDate);
    }

    function spliceSeriesData(graphBaseValue, seriesData, monthCount) {
        var newSeriesData = [];

        if (seriesData && seriesData.length > 0) {
            newSeriesData = _.extend([], seriesData);
            var spliceIndex = newSeriesData.length - monthCount - 1;
            if (spliceIndex < 0) {
                newSeriesData = addGraphBaseValueAsFirstDataToSeriesData(graphBaseValue, _.first(newSeriesData).endDate, newSeriesData);
            } else {
                newSeriesData = newSeriesData.splice(spliceIndex);
            }
        }

        return newSeriesData;
    }

    function sliceSeriesData(graphBaseValue, seriesData, startDate, endDate) {
        var newSeriesData = [];

        if (seriesData && seriesData.length > 0) {
            newSeriesData = _.extend([], seriesData);
            var lastDate = morningstar.asterix.util.date.convertToStandard(new Date(_.last(newSeriesData).endDate));

            var monthCount = 0;
            if (endDate < lastDate) {
                newSeriesData = newSeriesData.slice(0, newSeriesData.length - morningstar.asterix.util.date.monthDiff(endDate, lastDate));
            }
            monthCount = morningstar.asterix.util.date.monthDiff(startDate, endDate);
            newSeriesData = spliceSeriesData(graphBaseValue, newSeriesData, monthCount);
        }

        return newSeriesData;
    }

    function rebasedSeriesData(graphBaseValue, seriesData) {
        var currentValue = null,
            rebasedData = [];

        _.each(seriesData, function (data, index) {
            var newData = {};

            if (index === 0) {
                newData.close = graphBaseValue;
                currentValue = graphBaseValue;
            } else {
                currentValue = currentValue * (1 + data.value / 100.0);
                newData.close = currentValue;
            }
            newData.date = data.endDate;
            if (!morningstar.asterix.util.isUndefinedOrNull(data.value)) {
                rebasedData.push(newData);
            }
        });

        return rebasedData;
    }

    //Line chart service
    function initializeLineChart(scope) {
        var lineChartSettings = scope.settings.get('lineChartSettings');
        var customSettings = {
            y1Abbreviation: lineChartSettings.showsCurrency ? scope.settings.get('currencyId') : null,
            tooltipTimeFormat: function tooltipTimeFormat(date) {
                return scope.format.date(date, lineChartSettings.tooltipTimeFormatAlias);
            },
            legendValuesFormat: function legendValuesFormat(value) {
                var newValue = value;
                if (scope.settings.get('chartType') === 'growth') {
                    var graphBaseValue = scope.settings.get('graphBaseValue');
                    newValue = (newValue - graphBaseValue) / graphBaseValue * 100.0;
                }
                return scope.format.number(newValue, lineChartSettings.legendValuesFormatAlias);
            },
            xTickFormat: function xTickFormat(date) {
                return scope.format.date(date, lineChartSettings.xTickFormatAlias);
            },
            y1TickFormat: function y1TickFormat(value) {
                return scope.format.number(value, lineChartSettings.y1TickFormatAlias);
            },
            colors: scope.instance.getDefaultColorPalette()
        };

        var TimeSeriesLineChartExtended = TimeSeriesLineChart.extend({
            id: 'mbc-time-series-line-chart',
            setCanvasTemplate: function setCanvasTemplate(width) {
                var template;
                if (this.get('legend')) {
                    if (width > this.get('breakpoint') && this.get('legendPosition') === 'right') {
                        template = '<div class="' + MBCCore.Classes.INNER + ' ' + MBCCore.Classes.INNER + '-right"></div>\n                            <div class="' + MBCCore.Classes.LEGEND + ' ' + MBCCore.Classes.LEGEND + '-right"><div class="' + MBCCore.Classes.LEGEND + '-inner"></div></div>';
                    } else {
                        template = '<div class="' + MBCCore.Classes.LEGEND + ' ' + MBCCore.Classes.LEGEND + '-top"><div class="' + MBCCore.Classes.LEGEND + '-inner"></div></div>\n                        <div class="' + MBCCore.Classes.INNER + ' ' + MBCCore.Classes.INNER + '-top"></div>';
                    }
                }
                this.set('canvasTemplate', template);
            }
        });

        var chart = new TimeSeriesLineChartExtended(morningstar.asterix.extend(true, {}, customSettings, lineChartSettings));
        chart.isDatumInited = false;
        return chart;
    }

    function drawLineChart(scope, chart, timelineLevel, lineChartData) {
        chart.set('timelineLevel', timelineLevel);
        var index = 0;
        _.each(lineChartData, function (data) {
            if (data && data.length > 0) {
                if (index === 0) {
                    if (!chart.isDatumInited) {
                        chart.isDatumInited = true;
                        chart.get('data').clean();
                        d3.select('#' + scope.namespaceId('line-chart')).datum({ y1: data }).call(chart.init());
                    } else {
                        chart.data({ y1: data });
                    }
                } else {
                    chart.add(data[0].name, data, data[0].groupName);
                }
                index++;
            }
        });

        if (chart.get('showDottedLines') || chart.get('dottedLineIndexes').length > 0) {
            setDottedLines(chart);
        }
    }

    function resize(chart) {
        if (chart.isDatumInited) {
            var chartTooltipClass = 'mbc-time-series-line-chart-tooltip';
            var chartTooltip = document.getElementsByClassName(chartTooltipClass);
            if (chartTooltip.length > 0) {
                angular.element(chartTooltip[0]).remove();
            }
            chart.update();
        }
    }

    function setDottedLines(chart) {
        var y1DomainDataset = chart.get('y1DomainDataset');
        var dataManager = chart.get('data');
        var linesData = dataManager.get(y1DomainDataset);
        var dottedLineIndexes = chart.get('dottedLineIndexes'); // set dotted line index, such as [1], priority higher than showDottedLines
        var linesName = [];
        _.each(linesData, function (data) {
            if (dottedLineIndexes.length > 0) {
                if (dottedLineIndexes.indexOf(data.index) > -1) {
                    linesName.push(data.name);
                }
            } else {
                if (linesName.indexOf(data.name) === -1) {
                    linesName.push(data.name);
                }
            }
        });
        chart.set('dottedLines', linesName);
        chart.update();
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10), __webpack_require__(1), __webpack_require__(3), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, helper) {
    'use strict';

    performanceGraph.$inject = ["mstarDimensions"];
    angular.module('ecPerformanceGraph', ['ecContainer', 'ecTabs', 'ecTable', 'ecInput', 'mstarCore']).directive('ecPerformanceGraph', performanceGraph);

    function performanceGraph(mstarDimensions) {
        return {
            restrict: 'E',
            require: 'mstarComponentId',
            scope: {},
            template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main'),
            link: linkFn
        };

        function linkFn(scope, elem, attr, mstarComponent) {
            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            // compiles the main template
            mstarComponent.compileTemplate(scope, '_templates.main');

            // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
            mstarComponent.bindParameters(scope);

            // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
            mstarComponent.bindModelData(scope);
            // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

            var selectedTabIndex = 0;
            var timelineLevelDefinitions = scope.settings.get('timelineLevelDefinitions');
            var chart = helper.initializeLineChart(scope);
            var sectionClass = '.ec-section__content--' + morningstar.asterix.util.string.dashCase(mstarComponent.getOwnComponentId());
            var mstarDimensionsElem = mstarDimensions(scope, elem);
            var tabInstance = scope.instance.findRelative('tabFrequency');
            var isValidSvgElem;

            scope.setActiveTab = function (index, tab) {
                selectedTabIndex = index;
                if (chart.isDatumInited && scope.settings.get('chartType') !== 'price') {
                    drawGraphByFrequency(scope.model.performanceChart, selectedTabIndex);
                }
                tabInstance.setParameter('selectedTabIndex', index);
                if (scope.settings.get('enableCustomDate')) {
                    var monthCount = scope.parameters.displayFrequency[index].value;
                    scope.parameters.endDate = new Date();
                    scope.parameters.startDate = morningstar.asterix.util.date.addMonths(new Date(), -monthCount);
                    scope.parameters.dataType = scope.parameters.displayFrequency[index].dataType;
                }
            };
            mstarDimensionsElem.addListener(function (value) {
                mstarDimensions(scope, elem.find(sectionClass)).addListener(function (value) {
                    // height=0 means the child elements are removed.
                    if (value.height === 0) {
                        chart.isDatumInited = false;
                    } else {
                        if (!chart.isDatumInited) {
                            drawGraph(scope.model.performanceChart);
                        } else if (isValidSvgElem) {
                            helper.resize(chart);
                        }
                    }
                });
                mstarDimensionsElem.destroy();
            });

            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:performanceChart', function (performanceChart) {
                if (performanceChart) {
                    drawGraph(performanceChart);
                }
            }));

            mstarComponent.addUnregisterCallback(mstarComponent.getComponentInstance().on('parameterChanged:startDate', function (startDate) {
                drawGraphByDateRange(scope.model.performanceChart, startDate, scope.parameters.endDate);
            }));

            mstarComponent.addUnregisterCallback(mstarComponent.getComponentInstance().on('parameterChanged:endDate', function (endDate) {
                drawGraphByDateRange(scope.model.performanceChart, scope.parameters.startDate, endDate);
            }));

            function drawGraph(performanceChart) {
                if (morningstar.asterix.util.isDate(scope.parameters.startDate) && morningstar.asterix.util.isDate(scope.parameters.endDate)) {
                    drawGraphByDateRange(performanceChart, scope.parameters.startDate, scope.parameters.endDate);
                } else if (morningstar.asterix.util.isArray(scope.parameters.displayFrequency)) {
                    drawGraphByFrequency(performanceChart, selectedTabIndex);
                }
            }

            function drawGraphByFrequency(performanceChart, index) {
                if (scope.settings.get('chartType') === 'price') {
                    drawPriceLineChart(performanceChart);
                } else {
                    var monthCount = scope.parameters.displayFrequency[index].value;
                    if (monthCount > 0) {
                        var seriesData = validateSeriesData(morningstar.asterix.util.parse('monthly.series')(performanceChart));
                        if (seriesData.length > 0) {
                            var frequencySeriesData = helper.getFrequencySeriesData(scope.settings.get('graphBaseValue'), seriesData, monthCount);
                            drawLineChart(frequencySeriesData);
                        } else {
                            emptyChartElement();
                        }
                        updateTabStatus(seriesData.length > 0);
                    }
                }
            }

            function drawGraphByDateRange(performanceChart, startDate, endDate) {
                if (morningstar.asterix.util.isDate(scope.parameters.startDate) && morningstar.asterix.util.isDate(endDate) && startDate < endDate) {
                    if (scope.settings.get('chartType') === 'price') {
                        drawPriceLineChart(performanceChart);
                    } else {
                        var seriesData = validateSeriesData(morningstar.asterix.util.parse('monthly.series')(performanceChart));
                        if (seriesData.length > 0) {
                            var dateRangeSeriesData = helper.getDateRangeSeriesData(scope.settings.get('graphBaseValue'), seriesData, startDate, endDate);
                            drawLineChart(dateRangeSeriesData);
                        } else {
                            emptyChartElement();
                        }
                    }
                }
            }

            function drawPriceLineChart(performanceChart) {
                var seriesData = validateSeriesData(morningstar.asterix.util.parse('series')(performanceChart));
                if (seriesData.length > 0) {
                    drawLineChart(seriesData);
                } else {
                    emptyChartElement();
                }
            }

            function drawLineChart(seriesData) {
                if (isValidElem()) {
                    var maxDataLength = 0;
                    if (seriesData.length > 0 && scope.settings.get('chartType') === 'price') {
                        _.each(seriesData, function (item) {
                            var firstDate = item.data[0].date;
                            firstDate = morningstar.asterix.util.isDate(firstDate) ? firstDate : new Date(firstDate);
                            var lastDate = item.data[item.data.length - 1].date;
                            lastDate = morningstar.asterix.util.isDate(lastDate) ? lastDate : new Date(lastDate);
                            var dayNum = (lastDate - firstDate) / 1000 / 60 / 60 / 24;
                            if (dayNum > maxDataLength) {
                                maxDataLength = dayNum;
                            }
                        });
                    } else {
                        maxDataLength = seriesData.length > 0 ? seriesData[0].data.length : 0;
                    }

                    var timelineLevel = getTimelineLevel(maxDataLength);
                    var lineChartData = helper.getLineChartData(seriesData, scope.labels);
                    helper.drawLineChart(scope, chart, timelineLevel, lineChartData);
                    isValidSvgElem = true;
                }
            }

            function getTimelineLevel(value) {
                var timelineLevel = null;
                var definitions = morningstar.asterix.util.cloneObject(timelineLevelDefinitions);
                if (definitions[scope.parameters.dataType]) {
                    definitions = definitions[scope.parameters.dataType];
                }
                _.each(definitions, function (data, key) {
                    if (value >= data[0] && value <= data[1]) {
                        timelineLevel = key;
                        return;
                    }
                });
                return timelineLevel;
            }

            function isValidElem() {
                var chartElem = elem.find('#' + scope.namespaceId('line-chart'));
                return chartElem.length > 0 && chartElem[0].offsetWidth > 0 && chartElem[0].offsetHeight > 0;
            }

            function updateTabStatus(status) {
                if (status) {
                    if (tabInstance.getParameter('selectedTabIndex') !== selectedTabIndex) {
                        tabInstance.setParameter('selectedTabIndex', selectedTabIndex);
                    }
                } else {
                    if (tabInstance.isActive) {
                        tabInstance.setParameter('resetTabStatus', true);
                        tabInstance.setParameter('selectedTabIndex', -1);
                    }
                }
            }

            function validateSeriesData(seriesData) {
                var newSeriesData = [];
                _.each(seriesData, function (item) {
                    if (item.data.length > 0) {
                        newSeriesData.push(item);
                    }
                });
                return newSeriesData;
            }

            function emptyChartElement() {
                var chartElem = elem.find('#' + scope.namespaceId('line-chart'));
                if (chartElem.length > 0) {
                    isValidSvgElem = false;
                    chartElem.html('<div class="' + scope.namespaceClass('__data-unavailable') + '">' + scope.labels.get('dataUnavailable') + '</div>');
                }
            }
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = {
	"ecPerformanceGraph": {
		"blueprints": {
			"withTrailingPerformanceTable": {
				"components": {
					"annualPerformanceTable": {
						"components": {
							"paginatorSticky": {
								"settings": {
									"dynamicPrevNext": false
								},
								"type": "ecPaginator"
							}
						},
						"settings": {
							"fields": [
								"name",
								"portfolio",
								"benchmark"
							],
							"orientation": "horizontal",
							"perPage": 6
						},
						"type": "ecTable"
					},
					"graphContainer": {
						"settings": {
							"breakpoints": {
								"defaults": {
									"groups": {
										"main": {
											"cols": 12,
											"sections": [
												"frequency",
												"graph",
												"annualPerformanceTable"
											]
										}
									}
								}
							}
						},
						"type": "ecContainer"
					}
				},
				"lables": {
					"annualPerformancePercentage": {
						"en": "Performance (%)"
					}
				}
			}
		},
		"components": {
			"annualPerformanceTable": {
				"components": {
					"paginator": {
						"type": "ecPaginator"
					},
					"paginatorSticky": {
						"type": "ecPaginator"
					},
					"paginatorTop": {
						"type": "ecPaginator"
					},
					"sortFieldsDropdown": {
						"type": "ecChosen"
					},
					"sortOrderRadio": {
						"type": "ecChosen"
					}
				},
				"settings": {
					"_model": {
						"footNotes": {
							"dataSourceType": "selector",
							"selector": "{{_ model(_).performanceChart.footNotes  _}}"
						},
						"rows": {
							"dataSourceType": "selector",
							"selector": "{{_ model(_).performanceChart.annual  _}}"
						}
					},
					"caption": "annualPerformancePercentage",
					"fieldDefinitions": {
						"benchmark": {
							"fieldName": "benchmark",
							"format": "shortDecimal",
							"headerLabelKey": "benchmark"
						},
						"periodInterval": {
							"fieldName": "endDate",
							"fieldSettings": {
								"itemTemplate": "<div class=\"ec__cell-content\")}}\"><div class=\"ec-table__cell-date  ec-table__cell-date--start\")}}\">{{ field.format( obj.startDate ) }}</div><div class=\"ec-table__cell-date ec-table__cell-date--end \">- {{ field.format(field.getter(obj))}}</div></div>"
							},
							"format": "yy-mmm-dd"
						},
						"portfolio": {
							"fieldName": "portfolio",
							"format": "shortDecimal",
							"headerLabelKey": "portfolio"
						}
					},
					"orientation": "horizontal"
				},
				"type": "ecTable"
			},
			"endDate": {
				"labels": {
					"ariaText": {
						"en": "End date",
						"fr": "Date de fin",
						"it": "Data finale",
						"sv": "Slutdatum"
					},
					"placeholder": {
						"en": "YYYY-MM-DD",
						"it": "GG-MM-AAAA",
						"sv": "YYYY-MM-DD"
					}
				},
				"settings": {
					"inputType": "date"
				},
				"type": "ecInput"
			},
			"graphContainer": {
				"settings": {
					"breakpoints": {
						"defaults": {
							"groups": {
								"main": {
									"cols": 12,
									"defaultSection": {
										"cols": 12
									},
									"sections": [
										"frequency",
										"graph"
									]
								}
							}
						}
					}
				},
				"type": "ecContainer"
			},
			"startDate": {
				"labels": {
					"ariaText": {
						"en": "Start date",
						"fr": "Date de début",
						"it": "Data iniziale",
						"sv": "Startdatum"
					},
					"placeholder": {
						"en": "YYYY-MM-DD",
						"it": "GG-MM-AAAA",
						"sv": "YYYY-MM-DD"
					}
				},
				"settings": {
					"inputType": "date"
				},
				"type": "ecInput"
			},
			"tabFrequency": {
				"settings": {
					"selectedTabIndex": 0
				},
				"type": "ecTabs"
			}
		},
		"labels": {
			"annualPerformancePercentage": {
				"en": "Annual performance (%)",
				"en-GB": null,
				"it": "Performance annuale (%)",
				"sv": "Årlig avkastning (%)",
				"sv-SE": null
			},
			"dataUnavailable": {
				"en": "Data Unavailable",
				"en-GB": null,
				"it": "Dati non disponibili",
				"sv": "Data saknas",
				"sv-SE": null,
				"zh-CN": "没有数据"
			},
			"dateRangeInterval": {
				"en": "-",
				"en-GB": null,
				"sv-SE": null
			},
			"dateRangeTitle": {
				"da-DK": "Datointerval:",
				"en": "Date Range:",
				"en-GB": null,
				"it": "Intervallo di dati:",
				"sv": "Datumintervall",
				"sv-SE": null
			},
			"fiveYears": {
				"da-DK": "5 År",
				"en": "5Y",
				"en-GB": null,
				"fr": "5A",
				"fr-CA": "5a",
				"it": "5 A",
				"sv": "5 år",
				"sv-SE": null,
				"zh-CN": "5年",
				"zh-HK": "5年"
			},
			"fiveYearsAria": {
				"en": "5 Years",
				"en-GB": null,
				"sv-SE": null
			},
			"oneMonth": {
				"en": "1 Month",
				"it": "1 mese",
				"sv": "1 månad"
			},
			"oneYear": {
				"da-DK": "1 År",
				"en": "1Y",
				"en-GB": null,
				"fr": "1A",
				"fr-CA": "1a",
				"it": "1 A",
				"sv": "1 år",
				"sv-SE": null,
				"zh-CN": "1年",
				"zh-HK": "1年"
			},
			"oneYearAria": {
				"en": "1 Years",
				"en-GB": null,
				"sv-SE": null
			},
			"performanceGraph": {
				"da-DK": "Performance Graf",
				"en": "Performance Graph",
				"en-GB": null,
				"fr": "Graphique de performances",
				"fr-CA": "Graphique des rendements",
				"it": "Grafico della performance",
				"sv": "Utvecklingsgraf",
				"sv-SE": null,
				"zh-CN": "表现图表",
				"zh-HK": "表現圖表"
			},
			"sixMonths": {
				"da-DK": "6M",
				"en": "6M",
				"en-GB": null,
				"fr": "6M",
				"fr-CA": "6m",
				"it": "6 M",
				"sv": "6m",
				"sv-SE": null,
				"zh-CN": "6个月",
				"zh-HK": "6個月"
			},
			"tenYears": {
				"da-DK": "10 År",
				"en": "10Y",
				"en-GB": null,
				"fr": "10A",
				"fr-CA": "10a",
				"it": "10 A",
				"sv": "10 år",
				"sv-SE": null,
				"zh-CN": "10年",
				"zh-HK": "10年"
			},
			"tenYearsAria": {
				"en": "10 Years",
				"en-GB": null,
				"sv-SE": null
			},
			"threeMonths": {
				"da-DK": "3M",
				"en": "3M",
				"en-GB": null,
				"fr": "3M",
				"fr-CA": "3m",
				"it": "3 M",
				"sv": "3m",
				"sv-SE": null,
				"zh-CN": "3个月",
				"zh-HK": "3個月"
			},
			"threeYears": {
				"da-DK": "3 År",
				"en": "3Y",
				"en-GB": null,
				"fr": "3A",
				"fr-CA": "3a",
				"it": "3 A",
				"sv": "3 år",
				"sv-SE": null,
				"zh-CN": "3年",
				"zh-HK": "3年"
			},
			"threeYearsAria": {
				"en": "3 Years",
				"en-GB": null,
				"sv-SE": null
			},
			"twoYears": {
				"da-DK": "2 År",
				"en": "2Y",
				"en-GB": null,
				"fr": "2A",
				"fr-CA": "2a",
				"it": "2 A",
				"sv": "2 år",
				"sv-SE": null,
				"zh-CN": "2年",
				"zh-HK": "2年"
			},
			"twoYearsAria": {
				"en": "2 Years",
				"en-GB": null,
				"sv-SE": null
			}
		},
		"settings": {
			"_model": {
				"asOfDate": null,
				"performanceChart": null
			},
			"_parameters": {
				"dataType": {},
				"displayFrequency": {},
				"endDate": {},
				"startDate": {}
			},
			"_templates": {
				"custom": {
					"annualPerformanceTable": "<ec-table template-type=\"light\" mstar-component-id=\"annualPerformanceTable\"></ec-table>"
				},
				"main": "<ec-section title=\"{{::settings.get(showTitle) ? labels.get('performanceGraph') : undefined}}\" sub-title=\"{{ model.asOfDate && model.asOfDate.length !== 0 ? format.date(model.asOfDate) : null }}\">\r\n    <ec-container mstar-component-id=\"graphContainer\">\r\n        <ec-section data-template-type=\"light\" section-id=\"frequency\">\r\n            <div class=\"{{::namespaceClass('__title')}}\">{{::labels.get('performanceGraph')}} </div>\r\n            <div class=\"{{::namespaceClass('__tab-frequency')}}\">\r\n                <ec-tabs mstar-component-id=\"tabFrequency\">\r\n                    <ec-tab-action data-ng-repeat=\"frequency in parameters.displayFrequency track by $index\" name=\"{{labels.get(frequency.labelKey)}}\" aria-label=\"{{labels.get(frequency.labelKey+'Aria')}}\" on-active=\"setActiveTab(index, tab)\">\r\n                    </ec-tab-action>\r\n                </ec-tabs>\r\n            </div>\r\n            <div data-ng-if=\"model.asOfDate && model.asOfDate.length !== 0\" class=\"{{::namespaceClass('__subtitle')}}\">{{ format.date(model.asOfDate) }} </div>\r\n        </ec-section>\r\n        <ec-section data-template-type=\"light\" section-id=\"dateRange\">\r\n            <fieldset class=\"{{::namespaceClass('__date-range')}}\">\r\n                <legend class=\"{{::namespaceClass('__date-range--title')}}\">{{::labels.get('dateRangeTitle')}}</legend>\r\n                <ec-input mstar-component-id=\"startDate\" data-ng-model=\"parameters.startDate\"></ec-input>\r\n                <span class=\"{{::namespaceClass('__date-range--interval')}}\">{{::labels.get('dateRangeInterval')}}</span>\r\n                <ec-input mstar-component-id=\"endDate\" data-ng-model=\"parameters.endDate\"></ec-input>\r\n            </fieldset>\r\n        </ec-section>\r\n        <ec-section data-template-type=\"light\" section-id=\"graph\">\r\n            <div id=\"{{::namespaceId('line-chart')}}\" class=\"{{::namespaceClass('__graph')}}\">\r\n            </div>\r\n        </ec-section>\r\n        <ec-section data-ng-repeat=\"(key,value) in templates.custom track by $index\" section-id=\"{{key}}\" title=\"{{ labels.contains(key) ? labels.get(key) : undefined }}\">\r\n            <div mstar-include=\"value\"></div>\r\n        </ec-section>\r\n    </ec-container>\r\n</ec-section>"
			},
			"chartType": "growth",
			"colorPaletteName": "lineChart",
			"colorPalettes": {
				"lineChart": [
					"#006098",
					"#151515"
				]
			},
			"dataType": null,
			"displayFrequency": [
				{
					"dataType": "m",
					"labelKey": "oneYear",
					"value": 12
				},
				{
					"dataType": "m",
					"labelKey": "twoYears",
					"value": 24
				},
				{
					"dataType": "m",
					"labelKey": "threeYears",
					"value": 36
				},
				{
					"dataType": "m",
					"labelKey": "fiveYears",
					"value": 60
				},
				{
					"dataType": "m",
					"labelKey": "tenYears",
					"value": 120
				}
			],
			"enableCustomDate": false,
			"endDate": null,
			"graphBaseValue": 10000,
			"lineChartSettings": {
				"dottedLineIndexes": [],
				"firstTickDate": true,
				"legendPosition": "right",
				"legendValuesFormatAlias": "shortDecimal",
				"showDottedLines": false,
				"showLegendValues": true,
				"showToolTip": true,
				"showsCurrency": false,
				"timelineLevel": "month",
				"tooltipTimeFormatAlias": "yyyy-mm-dd",
				"useDefaultParsers": false,
				"xAxisOrient": "bottom",
				"xTickFormatAlias": "mm",
				"y1AxisOrient": "left",
				"y1Bubbled": false,
				"y1TickFormatAlias": "thousandsDecimal",
				"y1TickSymbol": null,
				"y2": false
			},
			"namespaceClass": "ec-performance-graph",
			"showTitle": true,
			"startDate": null,
			"timelineLevelDefinitions": {
				"month": [
					0,
					13
				],
				"quarter": [
					14,
					37
				],
				"year": [
					38,
					2000
				]
			}
		},
		"type": "ecPerformanceGraph"
	}
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["mbc-core"], factory);
	else if(typeof exports === 'object')
		exports["mbc-flag"] = factory(require("mbc-core"));
	else
		root["mbc-flag"] = factory(root["mbc-core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 120);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(19);


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(101);

var _flag = __webpack_require__(59);

var _flag2 = _interopRequireDefault(_flag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _flag2.default;

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ToolTipConfig = function ToolTipConfig() {

    this._DEFAULT_CONFIG = {
        template: function template(d) {
            return "<div class='tooltip-inner'>" + d.value + "</div>";
        }
    };

    this._config = this._DEFAULT_CONFIG;
};

ToolTipConfig.prototype.configuration = function (v) {
    if (arguments.length === 0) {
        return this._config;
    }

    // Polyfill for ES6 assign method
    if (typeof Object.assign !== "function") {
        Object.assign = function (target) {
            /*jshint maxcomplexity:6 */
            if (target === null) {
                throw new TypeError("Cannot convert undefined or null to object");
            }

            target = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var source = arguments[index];
                if (source !== null) {
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                        }
                    }
                }
            }

            return target;
        };
    }

    this._config = Object.assign({}, this._DEFAULT_CONFIG, v);
    return this;
};

ToolTipConfig.prototype.template = function (v) {
    if (arguments.length === 0) {
        return this._config.template;
    }

    this._config.template = v;

    return this;
};

var configuration = exports.configuration = new ToolTipConfig();

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getPositionTop(ttClientRect, canvas, mousePosition, position) {
    var tooFarLeft, tooFarRight, tooLow, tooHigh;
    tooFarRight = mousePosition[0] >= canvas.width() - ttClientRect.width / 2;
    tooFarLeft = mousePosition[0] < ttClientRect.width / 2;
    tooHigh = mousePosition[1] < ttClientRect.height;
    tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
    if (tooHigh && !tooFarLeft && tooFarRight) {
        position = "bottom-left";
    } else if (tooHigh && tooFarLeft && !tooFarRight) {
        position = "bottom-right";
    } else if (tooHigh) {
        position = "bottom";
    } else if (!tooFarLeft && tooFarRight) {
        position = "top-left";
    } else if (tooFarLeft && !tooFarRight) {
        position = "top-right";
    }

    return position;
}

function getPositionBottom(ttClientRect, canvas, mousePosition, position) {
    var tooFarLeft, tooFarRight, tooLow, tooHigh;
    tooFarRight = mousePosition[0] >= canvas.width() - ttClientRect.width / 2;
    tooFarLeft = mousePosition[0] < ttClientRect.width / 2;
    tooHigh = mousePosition[1] < ttClientRect.height;
    tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
    if (tooLow && !tooFarLeft && tooFarRight) {
        position = "top-left";
    } else if (tooLow && tooFarLeft && !tooFarRight) {
        position = "top-right";
    } else if (tooLow) {
        position = "top";
    } else if (!tooFarLeft && tooFarRight) {
        position = "bottom-left";
    } else if (tooFarLeft && !tooFarRight) {
        position = "bottom-right";
    }

    return position;
}

function getPositionTopRight(ttClientRect, canvas, mousePosition, position, isLine) {
    var tooFarLeft, tooFarRight, tooLow, tooHigh;
    var width = isLine ? ttClientRect.width * 2 : ttClientRect.width;
    tooFarRight = mousePosition[0] >= canvas.width() - width;
    tooFarLeft = mousePosition[0] < width;
    tooHigh = mousePosition[1] < ttClientRect.height;
    tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
    if (tooHigh && tooLow) {
        tooHigh = false;
    }
    if (tooHigh && !tooLow && !tooFarRight) {
        position = "bottom-right";
    } else if (tooHigh && !tooLow && tooFarRight) {
        position = "bottom-left";
    } else if (!tooHigh && tooFarRight) {
        position = "top-left";
    }

    return position;
}

function getRightTop(ttClientRect, canvas, mousePosition, position, isLine) {
    var tooFarRight, tooLow;
    var width = isLine ? ttClientRect.width * 2 : ttClientRect.width;
    tooFarRight = mousePosition[0] >= canvas.width() - width;
    tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
    if (tooFarRight && tooLow) {
        position = "left-bottom";
    } else if (tooFarRight) {
        position = "left-top";
    } else if (tooLow) {
        position = "right-bottom";
    }

    return position;
}

module.exports = {
    top: getPositionTop,
    bottom: getPositionBottom,
    topRight: getPositionTopRight,
    rightTop: getRightTop
};

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _mbcCore = __webpack_require__(0);

var _mbcCore2 = _interopRequireDefault(_mbcCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configuration = __webpack_require__(57).configuration;
var positioning = __webpack_require__(58);

var Classes = _mbcCore2.default.Classes;
var Utils = _mbcCore2.default.Utils;

/**
 * D3 tooltip plugin
 * Modification of https://github.com/roncr/d3-tooltip-box
 * @class Tooltip
 */
var ToolTip = function ToolTip(options) {

    options = options || {};
    this.__OPTIONS = options;
    this._tooltipMap = {
        top: { top: true },
        "top-left": { top: true, "top-left": true },
        "top-right": { top: true, "top-right": true },
        bottom: { bottom: true },
        "bottom-left": { bottom: true, "bottom-left": true },
        "bottom-right": { bottom: true, "bottom-right": true },
        left: { left: true },
        "left-top": { left: true, "left-top": true },
        "left-bottom": { left: true, "left-bottom": true },
        right: { right: true },
        "right-top": { right: true, "right-top": true },
        "right-bottom": { right: true, "right-bottom": true }
    };

    var defaultOptions = {
        position: "top-right",
        delay: 250,
        transitionDuration: 20,
        opacity: 0.95,
        transition: true
    };

    Utils.object.copy(defaultOptions, options);

    this._options = defaultOptions;

    // Constants
    this._DEFAULT_POSITION_OFFSET = { top: 0, left: 0 };

    // Variables
    this._tooltipClass = Classes.TOOLTIP_CONTAINER;
    this._parent = d3.select("body");
    this._dataAccessor = function (d) {
        return d;
    };

    this._template = configuration.template();
    this._positionOffset = this._DEFAULT_POSITION_OFFSET;
};

/**
 * Initializes the tooltip container, if there is already
 * a container, reuses the same tooltip, otherwise creates
 * a new <div> container
 * @returns {d3.selection} tooltip container
 * @private
 */
ToolTip.prototype._initTooltip = function () {
    var tooltipEl = d3.select("." + this._tooltipClass);
    if (tooltipEl.empty()) {
        tooltipEl = this._createTooltip(this._options);
    }

    return tooltipEl;
};

/**
 * Creates a new <div> as the container of the tooltip
 * @returns {d3.selection} new tooltip container
 * @private
 */
ToolTip.prototype._createTooltip = function (options) {
    var positionClass = this._tooltipMap[options.position];
    var tooltip = this.parent().append("div").attr("class", this._tooltipClass).classed("tooltip", true).classed(positionClass).style('display', 'none').classed("in", true).classed("fade", true);

    if (this._options && this._options.namespace && typeof this._options.namespace === "string") {
        tooltip.classed(this._options.namespace + "-tooltip", true);
    }

    return tooltip;
};

/**
 * Gets the content of the tooltip by either
 * compiling a static template or invoking the
 * function of a dynamic template
 * @param d the associated data
 * @returns {ELEMENT_NODE} content of the tooltip as HTML
 * @private
 */
ToolTip.prototype._getContent = function (d) {
    var template = this._template;

    var compileTemplate = function compileTemplate(template, data) {
        for (var prop in data) {
            var regex = new RegExp("\\@\\{" + prop + "}", "gi");
            template = template.replace(regex, data[prop]);
        }

        return template;
    };

    if (typeof template === "function") {
        return template(d);
    } else {
        var data = this._dataAccessor(d);
        return compileTemplate(template, data);
    }
};

/**
 * Parent getter/setter
 * @param v the parent to set
 * @returns {d3.selection} the current parent (returned only if
 * invoked with no parameters)
 */
ToolTip.prototype.parent = function (v) {

    var isD3Selection = function isD3Selection(obj) {
        return obj instanceof d3.selection;
    };

    if (arguments.length === 0) {
        return this._parent;
    }

    if (!isD3Selection(v)) {
        v = d3.select(v);
    }

    this._parent = v;
    return this;
};

/**
 * Position offset getter/setter, the offset must
 * be in the shape of {left: 0, top: 0}
 * @param v the offset to set
 * @returns {Object} current offset (returned only if invoked with
 * not parameters)
 */
ToolTip.prototype.positionOffset = function (v) {
    if (arguments.length === 0) {
        return this._positionOffset;
    }

    this._positionOffset = {};
    Utils.object.copy(this._positionOffset, this._DEFAULT_POSITION_OFFSET, v);
    return this;
};

/**
 * Data accessor getter/setter
 * @param v the accessor function to set
 * @returns {Function} the current accessor function (returned only if
 * invoked with no parameters)
 */
ToolTip.prototype.data = function (v) {
    if (arguments.length === 0) {
        return this._dataAccessor;
    }

    this._dataAccessor = v;
    return this;
};

/**
 * Template getter/setter
 * @param v the template to set, if string it is considered
 * static template, if function it is considered dynamic template
 * and will be invoked with the associated data as parameter
 * @returns {*} the current template string or factory function
 * (returned only if invoked with no parameters)
 */
ToolTip.prototype.template = function (v) {
    if (arguments.length === 0) {
        return this._template;
    }

    this._template = v;
    return this;
};

/**
 * Makes the tooltip visible
 * @param d the associated data of the selection
 */
ToolTip.prototype.show = function (d, changes) {
    var html, options;
    if (!this._tooltipEl) {

        if (changes) {

            var defaultOptions = { position: "top-right" };
            Utils.object.copy(defaultOptions, changes);
            this._options = defaultOptions;
        }

        this._tooltipEl = this._initTooltip();
    }

    options = this._options;

    if (!this._disabled) {
        html = this._getContent(d);

        if (html !== null && typeof html !== "undefined") {
            html += "<div class='tooltip-arrow'></div>";
            this._tooltipEl.html(html);
            if (options.transition) {
                this._tooltipEl.style({
                    opacity: 0,
                    display: "inline-block"
                }).transition().duration(options.transitionDuration).delay(options.delay).style({
                    opacity: options.opacity
                });
            } else {
                this._tooltipEl.style({
                    opacity: options.opacity,
                    display: "inline-block"
                });
            }
        }
    }
};

ToolTip.prototype.disabled = function (disabled) {
    this._disabled = disabled;
};

// This method calculates the flag positioning inside the chart canvas based on its initial position.
function calcPosition(tooltip, canvas, position, mousePosition, isLine) {
    var ttClientRect = tooltip.node().getBoundingClientRect();

    // TODO: Other automatic positionings.
    switch (position) {
        case "top":
            position = positioning.top(ttClientRect, canvas, mousePosition, position);
            break;

        case "top-left":
            break;

        case "top-right":
            position = positioning.topRight(ttClientRect, canvas, mousePosition, position, isLine);
            break;

        case "bottom":
            position = positioning.bottom(ttClientRect, canvas, mousePosition, position);
            break;

        case "bottom-left":
            break;

        case "bottom-right":
            break;

        case "left":
            break;

        case "left-top":
            break;

        case "left-bottom":
            break;

        case "right":
            break;

        case "right-top":
            position = positioning.rightTop(ttClientRect, canvas, mousePosition, position, isLine);
            break;

        case "right-bottom":
            break;

        default:
            break;
    }

    return position;
}

/**
 * Moves the tooltip to the mouse position
 */
ToolTip.prototype.move = function (d, mousePosition) {

    // If the tooltip is not shown already, show it
    if (!this._tooltipEl) this.show(d);

    var autoposition = this._options.autoposition;
    var _this = this;
    var positionClass;
    var isLine = _this.__OPTIONS.chart === "line";
    var isTimeSeries = _this.__OPTIONS.chart === "time-series";

    var getOffset = function getOffset(ctx) {
        var tooltipEl = ctx._tooltipEl;
        var clientRect = tooltipEl.node().getBoundingClientRect();
        var height = clientRect.height;
        var width = clientRect.width;
        var position = ctx._options.position;
        var top = 0;
        var left = 0;

        if (autoposition) {
            position = calcPosition(tooltipEl, autoposition, position, mousePosition, isLine);
        }

        positionClass = ctx._tooltipMap[position];

        tooltipEl.classed({
            top: false,
            "top-left": false,
            "top-right": false,
            bottom: false,
            "bottom-left": false,
            "bottom-right": false,
            left: false,
            "left-top": false,
            "left-bottom": false,
            right: false,
            "right-top": false,
            "right-bottom": false
        }).classed(positionClass);

        switch (position) {
            case "top":
                top = height;
                left = width / 2;
                break;

            case "top-left":
                top = height;
                left = width;
                break;

            case "top-right":
                top = height;
                break;

            case "bottom":
                left = width / 2;
                top = -10;
                break;

            case "bottom-left":
                left = width;
                top = -10;
                break;

            case "bottom-right":
                top = -10;
                break;

            case "left":
                top = height / 2;
                left = width;
                break;

            case "left-top":
                left = width;
                break;

            case "left-bottom":
                left = width;
                top = height;
                break;

            case "right":
                top = height / 2;
                left = -5;
                break;

            case "right-top":
                left = -5;
                break;

            case "right-bottom":
                left = -5;
                top = height;
                break;

            default:
                break;
        }

        return { top: top, left: left };
    };

    var clientRect = _this._tooltipEl.node().getBoundingClientRect();

    _this._clientRect = clientRect;
    _this._positionOffset = getOffset(_this);

    if (isLine) {
        var select = document.querySelector(".mbc-line-chart-tooltip");
        var mouse = d3.mouse(select);
        var closestLine = _this.getCalculation();
        var zoneWidth = _this.__OPTIONS.flagZoneWidth;
    }

    var formatPx = function formatPx(value) {
        return value + "px";
    };
    var padding = -5;

    if (_this.hasPositionLeft(positionClass)) {
        padding = clientRect.width + 5;
    }

    if (isTimeSeries) {
        var closestLine = _this._options.hoverLeft - _this._positionOffset.left;
        padding = 3;
    }

    _this._tooltipEl.style({
        position: "absolute",
        left: isLine || isTimeSeries ? formatPx(closestLine - padding) : formatPx(d3.event.pageX - _this._positionOffset.left),
        top: formatPx(d3.event.pageY - _this._positionOffset.top)
    });
};

ToolTip.prototype.hasPositionLeft = function (pos) {
    return pos.hasOwnProperty("top-left") || pos.hasOwnProperty("bottom-left") || pos.hasOwnProperty("left-top") || pos.hasOwnProperty("left-bottom");
};

ToolTip.prototype.getCalculation = function () {
    var isTimeSeries = this.__OPTIONS.chart === "time-series";
    var select = document.querySelector("body");
    var lines = Array.prototype.slice.call(document.querySelectorAll(".mouse-line")).map(function (line) {
        return line.getBoundingClientRect().left;
    });

    var position;
    var mouse = d3.mouse(select)[0];

    var zoneWidth = this.__OPTIONS.flagZoneWidth;
    var canvasWidth = this.__OPTIONS.canvasWidth;
    var zones = Math.round(canvasWidth / zoneWidth);
    var findRange = function findRange() {
        var w = Math.floor(zoneWidth / 2);
        lines.forEach(function (line, idx) {
            if (mouse >= line - w && mouse <= line + w) {
                position = line;
                return false;
            }
        });
    };

    findRange();

    return position;
};

/**
 * Hides the tooltip
 */
ToolTip.prototype.hide = function () {
    if (this._tooltipEl) {
        this._tooltipEl.transition();
    }

    var container = d3.select(".mbc-chart-tooltip-container");
    container.remove();
    this._tooltipEl = null;
};

/**
 * Attaches the tooltip event listeners to
 * the current selection
 * @returns {Function} function to be used for the
 * d3.selection.call method
 */
ToolTip.prototype.bind = function () {
    var _this = this;

    return function (selection) {
        selection.each(function () {
            var element = d3.select(this);

            element.on("mousemove.tooltip-container", function (d) {
                return _this.move(d, d3.mouse(this));
            }).on("mousewheel.tooltip-container", function () {
                return _this.hide();
            }).on("mouseout.tooltip-container", function () {
                return _this.hide();
            });
        });
    };
};

/**
 * Tooltip factory, creates new instances of the tooltip
 * @returns {Tooltip} the new tooltip instance
 */
function create(options) {
    var instance = new ToolTip(options);
    return instance;
}

module.exports = create;

/***/ })

/******/ });
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["mbc-core"], factory);
	else if(typeof exports === 'object')
		exports["mbc-legend"] = factory(require("mbc-core"));
	else
		root["mbc-legend"] = factory(root["mbc-core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 123);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTAwIDE1MDAiPjxwYXRoIGQ9Ik02OTguNSA3OTguNWgxMDB2LTEwMGgtMTAwdjEwMHptLTMwMCAwaDEwMHYtMTAwaC0xMDB2MTAwem0zNTAtODAwYy00MTAgMC03NTAgMzQwLTc1MCA3NTBzMzQwIDc1MCA3NTAgNzUwIDc1MC0zNDAgNzUwLTc1MC0zNDAtNzUwLTc1MC03NTB6bTAgMTQwMGMtMzYwIDAtNjUwLTI5MC02NTAtNjUwczI5MC02NTAgNjUwLTY1MCA2NTAgMjkwIDY1MCA2NTAtMjkwIDY1MC02NTAgNjUwem0yNTAtNjAwaDEwMHYtMTAwaC0xMDB2MTAweiIvPjwvc3ZnPjwhLS0gbW9ybmluZ3N0YXItZGVzaWduLXN5c3RlbSB2MS4xNi4xIC0tPg=="

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(22);


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(104);

var _legend = __webpack_require__(69);

var _legend2 = _interopRequireDefault(_legend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _legend2.default;

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var core = __webpack_require__(0);
var Utils = core.Utils;

/**
 * @method addItemsSVG
 * Creates svg items within legend on right side of chart
 * Key and Item name
 */
function addItemsSVG(params) {
    var names = [];
    var items = params.items;
    var firstPass;
    var lineHeight = 17;
    var keyPadding = 5;
    var linePadding = 3;
    var timeSeriesNoValueLinePadding = 8;
    var wrapVars = {
        params: params,
        container: params.container,
        names: names,
        firstPass: firstPass
    };
    var rangeLength = items.length * lineHeight + keyPadding; //line height + padding
    var y = d3.scale.linear().range([0, rangeLength]);
    var isLineChart = function isLineChart() {
        return params.chartType === 'lineChart';
    };
    var isTimeSeries = function isTimeSeries() {
        return params.chartType === 'time-series';
    };
    var isBenchmark = function isBenchmark(d) {
        return d.groupName === "Benchmarks";
    };

    items.selectAll("*").remove();
    items.enter().append("g").attr("class", function (d) {
        return d.name ? Utils.string.dashify(d.name) : Utils.string.dashify(d.displayName);
    }).classed("legend-item", true);
    if (isTimeSeries()) {
        var legendValuesFormat = Utils.string.convertDashToEnDash(params.legendValuesFormat);
        items.append("text").attr("class", function (d, i) {
            return "mbc-time-series_dataKey";
        }).attr("x", 0).text(function (d) {
            return d.displayName;
        }).call(wrap, wrapVars).attr("y", function (d, i) {
            var yValue = y(i) + lineHeight + lineHeight * i;
            yValue = yValue + keyPadding * i;
            if (items[0][i - 1]) {
                var valueLine = params.legendShowValue ? linePadding / 2 * lineHeight : 5.5;
                yValue = getElementY(items[0][i - 1], 0) + getNumTspan(items[0][i - 1], params.chartType) * lineHeight + linePadding + valueLine;
            }
            return yValue;
        });
        if (params.legendShowValue) {
            items.append("text").attr("class", "mbc-time-series_dataValue").attr("x", 0).attr("y", function (d, i) {
                var yValue = y(i) + lineHeight * 2 + lineHeight * i;
                yValue = yValue + keyPadding * i + 3;
                if (items[0][i]) {
                    yValue = getNumTspan(items[0][i], params.chartType) * lineHeight + linePadding + getElementY(items[0][i], 0);
                }
                return yValue;
            }).text(function (d) {
                names.push(legendValuesFormat(d.value));
                return legendValuesFormat(d.value);
            });
        }
        items.append("line").attr("x1", 0).attr("y1", function (d, i) {
            var yValue = y(i) + lineHeight * i;
            yValue = yValue + 5 * i;
            if (items[0][i - 1]) {
                var index = params.legendShowValue ? 1 : 0;
                var numLinesNoValue = params.legendShowValue ? 0 : getNumTspan(items[0][i - 1], params.chartType) * lineHeight - timeSeriesNoValueLinePadding;
                yValue = getElementY(items[0][i - 1], index) + numLinesNoValue + lineHeight / 2 * index;
            }
            return yValue;
        }).attr("x2", function (d) {
            var svg = params.container.append("svg");
            var largestWidth = parseInt(Utils.svg.getGreaterSVGTextWidth(svg, wrapVars.names)) + 21;
            svg.remove();
            var width = largestWidth - params.legendWidth >= 1 ? largestWidth : params.legendWidth - 1;
            return scrollbarPresent(params.container) ? width + 15 : width;
        }).attr("y2", function (d, i) {
            var yValue = y(i) + lineHeight * i;
            yValue = yValue + 5 * i;
            if (items[0][i - 1]) {
                var index = params.legendShowValue ? 1 : 0;
                var numLinesNoValue = params.legendShowValue ? 0 : getNumTspan(items[0][i - 1], params.chartType) * lineHeight - timeSeriesNoValueLinePadding;
                yValue = getElementY(items[0][i - 1], index) + numLinesNoValue + lineHeight / 2 * index;
            }
            return yValue;
        }).attr("stroke", function (d) {
            return d.color || params.colors[d.index % params.colors.length];
        }).attr("stroke-dasharray", function (d) {
            var lineIsDotted = params.dottedLines.indexOf(d.displayName) > -1;
            return lineIsDotted ? "2,2" : "transparent";
        }).attr("stroke-width", "2");
    } else {
        items.append("text").attr("class", function (d, i) {
            return "dataName" + i;
        }).text(function (d) {
            return d.displayName;
        }).attr("x", 15).call(wrap, wrapVars).attr("y", function (d, i) {
            var yValue = y(i) + 10;
            if (items[0][i - 1]) {
                yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) : yValue;
            }
            return yValue;
        });
        items.append("line").attr("x1", 0).attr("y1", function (d, i) {
            var yValue = y(i) + 5;
            if (items[0][i - 1]) {
                yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 5 : yValue;
            }
            return yValue;
        }).attr("x2", 10).attr("y2", function (d, i) {
            var yValue = y(i) + 5;
            if (items[0][i - 1]) {
                yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 5 : yValue;
            }
            return yValue;
        }).attr("stroke", function (d, i) {
            if (isLineChart()) {
                return d.color || params.colors[i % params.colors.length];
            }
            return isBenchmark(d) ? params.benchmarkColor : "transparent";
        }).attr("stroke-dasharray", function (d) {
            if (params.lineStyles[d.displayName]) {
                return "2,2";
            }
            return isBenchmark(d) && params.dottedBenchmark ? "2,2" : "transparent";
        }).attr("stroke-width", "2");

        items.append("rect").attr("x", 0).attr("y", function (d, i) {
            var yValue = y(i);
            if (items[0][i - 1]) {
                yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 10 : yValue;
            }
            return yValue;
        }).attr("width", 10).attr("height", 10).attr("fill", function (d, i) {
            return isBenchmark(d) || isLineChart() ? "transparent" : d.color || params.colors[i % params.colors.length];
        }).attr("fill-opacity", 0.8);
    }
    items.exit().remove();

    adjustSVGHeight(params, items);
    setLegendWidth(wrapVars);
}

/**
 * @method addTopItemsSVG
 * Creates svg items within legend on top of chart
 * Key and Item name
 * Hides elements that scope beyond chart width
 */
function addTopItemsSVG(params) {
    var items = params.items;
    var iconWithPadding = 16;
    var overflowBtnWithSpace = 24;
    var isBenchmark = function isBenchmark(d) {
        return d.groupName === "Benchmarks";
    };
    var isLineChart = function isLineChart() {
        return params.chartType === 'lineChart';
    };
    var isTimeSeries = function isTimeSeries() {
        return params.chartType === 'time-series';
    };
    var isLineTime = function isLineTime() {
        return isLineChart() || isTimeSeries();
    };

    items.enter().append("g").attr("class", function (d) {
        return d.displayName ? Utils.string.dashify(d.displayName) : Utils.string.dashify(d.name);
    }).style("display", function (d, i) {
        var svg = params.container.append("svg");
        var textWidth = Utils.svg.getSVGTextWidth(svg, d.displayName);
        svg.remove();
        var textX = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName') + i * iconWithPadding + (iconWithPadding - 1) + overflowBtnWithSpace; //item spacing + overflow button spacing and width

        return textWidth + textX > params.legendWidth ? "none" : "";
    }).classed("legend-item", true);

    items.append("rect").attr("x", function (d, i) {
        var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
        if (i == 0) {
            return width;
        }
        return width + i * iconWithPadding;
    }).attr("y", function (d, i) {
        return isBenchmark(d) || isLineTime() ? 4 : 0;
    }).attr("width", 10).attr("height", function (d, i) {
        return isBenchmark(d) || isLineTime() ? 1 : 10;
    }).attr("fill", function (d, i) {
        return isBenchmark(d) || isLineTime() ? "transparent" : params.colors[i % params.colors.length];
    }).attr("fill-opacity", 0.8).attr("stroke", function (d, i) {
        if (isLineChart()) {
            return d.color || params.colors[i % params.colors.length];
        }
        if (isTimeSeries()) {
            return d.color || params.colors[d.index % params.colors.length];
        }
        return isBenchmark(d) ? params.benchmarkColor : "transparent";
    }).attr("stroke-dasharray", function (d) {
        if (isTimeSeries()) {
            return params.dottedLines.indexOf(d.displayName) > -1 ? "3,3" : "transparent";
        }
        if (params.lineStyles[d.displayName]) {
            return "3,3";
        }
        return isBenchmark(d) && params.dottedBenchmark ? "3,3" : "transparent";
    }).attr("stroke-width", "1");

    items.append("text").attr("x", function (d, i) {
        var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
        if (i == 0) {
            return width + (iconWithPadding - 1);
        }
        return width + i * iconWithPadding + (iconWithPadding - 1);
    }).attr("y", 10).text(function (d) {
        return d.displayName;
    });

    items.exit().remove();
}

/**
 * @method getLegendWidth
 * Get Legend Width
 * @param container, @param data
 * @return {Number}
 */
function getTotalItemsWidth(container, data, accessor) {
    var svg = container.append("svg");
    var width = Utils.svg.getTotalSVGTextWidth(svg, data, accessor);
    svg.remove();
    return width;
}

/**
 * @method getNumTspan
 * Gets number of lines text element wraps to
 * Line returns next line y-position
 * Time Series returns number of lines for element
 * @param element, @param chartType
 * @return {Number}
 */
function getNumTspan(element, chartType) {
    var numLines = 1;
    var prevY = getElementY(element, 0);

    if (typeof element !== 'undefined') {
        numLines = element.childNodes[0].childNodes.length;
        if (chartType === 'time-series') {
            return numLines > 1 ? numLines : 1;
        }
    }
    return numLines * 17 + prevY + 5;
}

/**
 * @method getElementY
 * Gets y attribute of elements child i
 * @param element, @param i
 * @return {Number}
 */
function getElementY(element, i) {
    return typeof element !== 'undefined' ? parseFloat(d3.select(element.childNodes[i]).attr("y")) : 0;
}

/**
 * @method wrap
 * Wraps text to multiple lines as needed according to legend width
 * @param text, @param container
 */
function wrap(text, wrapVars) {
    var legendMaxWidth = 120;
    var scrollbarWidth = 17;
    var iconWithPadding = 21;
    text.each(function () {
        var text = d3.select(this),
            words = text.text().split(/\s+/).reverse(),
            word,
            line = [],
            lineHeight = 1,
            // ems
        x = text.attr("x"),
            y = text.attr("y"),
            tspan = text.text(null).append("tspan").attr("x", x).attr("y", y);
        if (words.length < 2) wrapVars.names.push(word);
        while (word = words.pop()) {
            line.push(word);
            tspan.text(line.join(" "));
            var scrollbar = scrollbarPresent(wrapVars.container) ? scrollbarWidth : 0;
            wrapVars.firstPass = scrollbarPresent(wrapVars.container);
            if (tspan.node().getComputedTextLength() + iconWithPadding + scrollbar > legendMaxWidth && line.length > 1) {
                line.pop();
                tspan.text(line.join(" "));
                wrapVars.names.push(line.pop());
                line = [word];
                tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", 1 * lineHeight + 0.25 + "em").text(word);
                text.attr("id", "double");
                wrapVars.names.push(word);
            } else {
                wrapVars.names.push(line.join(" "));
            }
        }
    });
}

/**
 * @method adjustSVGHeight
 * Sets legend svg height according to last item in data
 * @param items
 * @return {Number}
 */
function adjustSVGHeight(params, items) {
    var parentID = params.parentID;
    var isTimeSeries = params.chartType === "time-series";
    var lastElement = items[0][items[0].length - 1];
    var lastelemIndex = isTimeSeries && params.legendShowValue ? 1 : 0;
    var lastElementY = parseFloat(d3.select(lastElement.childNodes[lastelemIndex]).attr("y"));
    var lastElementH = lastElement.childNodes[lastelemIndex].getBoundingClientRect().height;
    var newLegendHeight = lastElementH + lastElementY;
    d3.select("#svgcontainer_" + parentID).select("svg").attr("height", newLegendHeight);
}

/**
 * @method scrollbarPresent
 * Get Legend Height compare to chart height
 * @param container
 * @return {Number}
 */
function scrollbarPresent(container) {
    return parseFloat(container[0][0].children[1].style.height) <= container[0][0].children[1].getElementsByClassName("mbc-legend")[0].clientHeight;
}

/**
* @method setLegendWidth
* Get Legend Width
* @param container, @param data
* @return {Number}
*/
function setLegendWidth(wrapVars) {
    var params = wrapVars.params;
    var parentID = params.parentID;
    var legendMaxWidth = 120;
    var scrollbarWidth = 17;
    var iconWithPadding = 21;
    var svg = params.container.append("svg");
    var width = parseInt(Utils.svg.getGreaterSVGTextWidth(svg, wrapVars.names)) + iconWithPadding; // icon and padding
    svg.remove();
    if (scrollbarPresent(wrapVars.params.container)) {
        //Scrollbar space
        width = width > legendMaxWidth - scrollbarWidth ? legendMaxWidth - scrollbarWidth : width;
    }
    d3.select("#svgcontainer_" + parentID).select("svg").attr("width", width);

    if (scrollbarPresent(params.container) !== wrapVars.firstPass) {
        addItemsSVG(params);
    }
}

module.exports = {
    addItemsSVG: addItemsSVG,
    addTopItemsSVG: addTopItemsSVG
};

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mds_constants = __webpack_require__(7).constants;
var mds_space = mds_constants["space"];
var mds_size_icon = mds_constants["size"]["icon"];
var core = __webpack_require__(0);
var Utils = core.Utils;
var Classes = core.Classes;
var mds_constants = Utils.colors.mds_constants;
var drawSVG = __webpack_require__(68);
var icon_mds_ellipsis_circle_s = __webpack_require__(114);

function Legend() {}
/**
 * @class Legend
 * instantiates legend object with necessary variable and constants
 * defaultOptions consistent across charts unless otherwise defined in specific chart
 * @param options Contains any chart specific options declared in chart
 */
Legend.prototype.invokeLegend = function (options) {
    var canvas = this.get("canvas"),
        _this = this;
    options = options || {};
    this.__OPTIONS = options;

    var defaultOptions = {
        container: this.get("selection").select("." + Classes.LEGEND),
        legend: this.get("selection").select("." + Classes.LEGEND).select("." + Classes.LEGEND + "-inner"),
        data: this.get("data"),
        benchmark: this.get("data").get("benchmark"),
        benchmarkColor: mds_constants["color"].black,
        benchmarkStyle: false,
        benchmarkSpan: "benchmark",
        mouseover: true
    };

    Utils.object.copy(defaultOptions, options);
    this._options = defaultOptions;

    // Variables
    this._canvas = canvas;
    var parentClassList = this._options.container[0][0].parentElement.classList;
    var arr = [].slice.call(parentClassList);
    arr.forEach(function (pClass, idx) {
        if (pClass.indexOf('mbc_') >= 0) {
            _this.set('parentID', pClass);
        }
    });
    var parentID = this.get('parentID');
    this._container = this._options.container.attr("id", "svgcontainer_" + parentID);
    this._data = this._options.data;
    this._legend = this._options.legend;
    this._benchmarkColor = this._options.benchmarkColor;
    this._benchmarkStyle = this._options.benchmarkStyle;
    this._benchmarkSpan = this._options.benchmarkSpan;

    this._margin = canvas.get("margin");
    this._legendTitle = this.get("legendTitle");
    this._benchmarkLabel = this.get("benchmarkLabel");
    this._legendMaxWidth = this.get("legendMaxWidth");

    var id = "mbc-mds-popover--" + this.generateID();
    if (this.get('popoverID') == null) {
        _this.set('popoverID', id);
    }
    this._createLegend();
};

/**
 * @method _createLegend
 * Create legend div container
 * Includes the title
 */
Legend.prototype._createLegend = function () {
    this._legend.remove();
    var parentID = this.get('parentID');

    // Adding Title
    if (this._legendTitle) {
        var title = this._legend.append("span").classed("mbc-legend-title", true);
        title.html(this._legendTitle);
    }

    this._setLegendHeightWidth();
    this.getDottedLines();

    if (this._options.chart === "verticalBar" || this._options.chart === "lineChart" || this._options.chart === "time-series") {
        var id = this.get('popoverID');
        var iconBtn = document.getElementsByClassName('mbc-mds-popover__trigger');
        var child = this._container[0][0].parentElement.children;
        var arr = [].slice.call(child);
        arr.forEach(function (div, idx) {
            d3.select(div).attr('popoverID', id);
        });
        this.makeSVGContainer();
        this.drawSVGLegend();
        this.adjustLegendWidth(parseFloat(d3.select("#svgcontainer_" + parentID).select("svg").attr("width")));
        if (iconBtn != null && iconBtn.length > 0) {
            this.setPopoverPosition(id);
        }
    } else {
        this._addLegendItems();
    }

    // removes empty elements from inner chart svg
    // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
    if (d3.select("." + Classes.LEGEND + "-inner").selectAll(".legend-item") !== null) {
        var arr = d3.select("." + Classes.LEGEND + "-inner").selectAll(".legend-item");
        if (typeof arr[0] !== 'undefined') {
            arr[0].forEach(function (gElem) {
                if (gElem.hasOwnProperty('remove') && gElem.childNodes.length === 0) {
                    gElem.remove();
                }
                // for IE remove polyfill
                if (!gElem.hasOwnProperty('remove') && gElem.childNodes.length === 0) {
                    Object.defineProperty(gElem, 'remove', {
                        configurable: true,
                        enumerable: true,
                        writable: true,
                        value: function remove() {
                            if (this.parentNode !== null) this.parentNode.removeChild(this);
                        }
                    });
                }
            });
        }
    }
};

/**
 * @method makeSVGContainer
 * Create svg legend container
 * Includes width and height
 */
Legend.prototype.makeSVGContainer = function () {
    var legendWidth = this.get("legendWidth");
    var parentID = this.get('parentID');
    var textWidth = this._container.classed(Classes.LEGEND + "-right") ? legendWidth : this._container[0][0].offsetWidth - 20; // padding left + icon margin + icon width vertical
    var legendHeight = this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule

    if (legendHeight < this._legend[0][0].scrollHeight) {
        //Scrollbar space
        textWidth += 12;
    }

    this.set("legendWidth", textWidth);
    var svgHeight = legendHeight > this._data.length * 22 + 5 ? legendHeight : this._data.length * 22 + 5;
    var numHeight = this._container.classed(Classes.LEGEND + "-right") ? svgHeight : 20; // 17 line height + 5 padding
    var svg = d3.select("#svgcontainer_" + parentID).append("svg").attr("role", "legend").attr("class", "mbc-legend").attr("height", numHeight);
    this.set("legendSVG", svg);
};

Legend.prototype.getDottedLines = function () {
    var arr = [].slice.call(this._data);
    var dotted = this.get("dottedLineNames");
    var lineStyles = {};
    arr.forEach(function (data, idx) {
        if (dotted) {
            var group = data.groupName;
            var name = data.displayName;
            var dottedLineNames = !(group === "benchmark") ? dotted[group] : null;
            lineStyles[name] = dottedLineNames;
        }
    });
    this.set('lineStyles', lineStyles);
};

/**
 * @method drawSVGLegend
 * Adds legend items to svg container
 * Includes right and top positioning
 */
Legend.prototype.drawSVGLegend = function () {
    var y1Axis = this.get("axes").axis("y1");
    this._clearPopoversOverlays();
    if (y1Axis) {
        var legendSVG = this.get("legendSVG");
        var legendWidth = this.get("legendWidth");
        var isTimeSeries = this._options.chart === "time-series";
        if (legendSVG[0][0].childNodes.length < 1) {
            this.set("legendfrontGroup", legendSVG.append("g").classed(Classes.LEGEND + "-inner", true));
        }
        if (isTimeSeries) {
            this._data = this._sortLegendData();
        }
        var endPadding = legendWidth - 6; // SVG specific '7' - padding + borders
        var innerGroup = this.get("legendfrontGroup");
        var items = innerGroup.selectAll(".legend-item").data(this._data);
        var benchmarkColor = this.get("benchmarksColor");
        var dottedBenchmark = this.get("dottedBenchmarks");
        var dottedLines = this.get('dottedLines');
        var colors = this.get("colors");
        var legendWidth = this.get("legendWidth");
        var legendValuesFormat = this.get("legendValuesFormat");
        var legendShowValue = this.get("showLegendValues");
        var parentID = this.get('parentID');
        var lineStyles = this.get('lineStyles');
        var chartType = this._options.chart;
        var legendContainer = typeof container !== "undefined" ? container : this.get("selection");
        var params = {
            items: items,
            endPadding: endPadding,
            benchmarkColor: benchmarkColor,
            dottedBenchmark: dottedBenchmark,
            dottedLines: dottedLines,
            colors: colors,
            legendWidth: legendWidth,
            legendValuesFormat: legendValuesFormat,
            legendShowValue: legendShowValue,
            container: legendContainer,
            parentID: parentID,
            chartType: chartType,
            lineStyles: lineStyles
        };
        if (this._container.classed(Classes.LEGEND + "-right")) {
            drawSVG.addItemsSVG(params);
            var id = this.get('popoverID');
            if (document.getElementById(id) !== null) {
                document.getElementById(id).parentElement.classList.remove('mbc-mds-popover__wrapper--visible');
                if (document.querySelector('[data-mbc-mds-popover="' + id + '"]') !== null) {
                    document.querySelector('[data-mbc-mds-popover="' + id + '"]').setAttribute('aria-expanded', 'false');
                }
            }
        } else {
            drawSVG.addTopItemsSVG(params);
            this.createLegendPopoverSVG();
        }
    }
};

/**
 * @method _clearPopoverWrapperOverlays
 * Removes existed popover wrappers and overlays
 */
Legend.prototype._clearPopoversOverlays = function () {
    if (document.getElementsByClassName('mbc-mds-popover__overlay').length != 0) {
        var overlays = document.getElementsByClassName('mbc-mds-popover__overlay');
        var arr = [].slice.call(overlays);
        arr.forEach(function (overlay) {
            overlay.parentElement.removeChild(overlay);
        });
    }
    if (document.getElementsByClassName('mbc-mds-popover').length != 0) {
        var popovers = document.getElementsByClassName('mbc-mds-popover');
        var arr = [].slice.call(popovers);
        arr.forEach(function (popover) {
            popover.parentElement.removeChild(popover);
        });
    }
};

/**
 * @method _addLegendItems
 * Add Items to legend container both benchmark and data
 * sets identifier and styles for items
 * maintains current chart specific css
 */
Legend.prototype._addLegendItems = function (container) {
    var _this = this;
    var enter;
    var isTimeSeries = this._options.chart === "time-series";
    var mainDiv = container !== null && typeof container !== 'undefined' ? container : this._legend;

    if (this.get("benchmark") && this._options.benchmark) {
        this._data = this.get("data").get("benchmark").concat(this._data);
    }

    if (isTimeSeries) {
        this._data = this._sortLegendData();
    }

    var isLineBenchmark = function isLineBenchmark(d) {
        return _this._options.chart === "verticalBar" && d.index === -1;
    };

    var isBenchmarkFirst = function isBenchmarkFirst(d) {
        return d.index === -1 && _this.get("_showBenchmark");
    };

    var lineStyle = function lineStyle(d) {
        var dottedLines = _this.get('dottedLines');
        var color = _this._color(d.index);
        var lineIsDotted = dottedLines.indexOf(d.displayName) > -1;
        var style = lineIsDotted ? "2px dotted " + color : "2px solid " + color;
        return style;
    };
    enter = d3.select(mainDiv[0][0]).selectAll("div").data(this._data).enter().append("div").attr("class", function (d) {
        return d.displayName ? Utils.string.dashify(d.displayName) : Utils.string.dashify(d.name);
    }).classed("mbc-chart-legend-item", true);
    if (this._options.mouseover) {
        enter.on("mouseover", function (d) {
            isBenchmarkFirst(d) ? _this.legendBenchmarkMouseover(d) : _this.legendMouseover(d);
        }).on("mouseout", function (d) {
            isBenchmarkFirst(d) ? _this.legendBenchmarkMouseout(d) : _this.legendMouseout(d);
        });
    }
    if (isTimeSeries && this._container.classed(Classes.LEGEND + "-right")) {
        var legendValuesFormat = Utils.string.convertDashToEnDash(this.get("legendValuesFormat"));

        enter.append("p").attr("class", Classes.LEGEND_ITEM + "__label--right").text(function (d) {
            return d.displayName;
        }).style("border-top", function (d) {
            return lineStyle(d);
        }.bind(this));

        if (this.get("showLegendValues")) {
            enter.append("p").attr("class", Classes.LEGEND_ITEM + "__value--right").text(function (d) {
                return legendValuesFormat(d.value);
            });
        }
    } else {

        enter.append("span").classed(this._benchmarkSpan, function (d) {
            return isBenchmarkFirst(d) || isLineBenchmark(d);
        }).classed(this._benchmarkSpan + "--dotted", function (d) {
            return isLineBenchmark(d) && this._benchmarkStyle;
        }).classed(Classes.LEGEND_ITEM + "__key", function (d) {
            return isTimeSeries;
        }).classed("square", function (d) {
            return _this._options.chart === "verticalBar" && !isLineBenchmark(d);
        }).style("background-color", function (d, i) {
            if (isTimeSeries) {
                return 'transparent';
            }
            if (isLineBenchmark(d)) {
                return this._benchmarkStyle ? 'transparent' : this._benchmarkColor;
            }
            if (isBenchmarkFirst(d)) {
                return this._benchmarkColor;
            }
            if (this._isScatterPlot()) {
                return this._color(d.groupIndex);
            }
            return !this._isDottedLine(d.groupName, d.displayName) ? this._color(i) : null;
        }.bind(this)).style("border-top", function (d, i) {
            if (isLineBenchmark(d) && this._benchmarkStyle) {
                return "2px dotted " + this._benchmarkColor;
            }
            return this._isDottedLine(d.groupName, d.displayName) ? "2px dotted " + this._color(i) : null;
        }.bind(this)).style("border-bottom", function (d) {
            if (isTimeSeries) {
                return lineStyle(d);
            }
            return 'transparent';
        }.bind(this)).style("opacity", this.get("opacity"));

        enter.append("p").text(function (d) {
            return isBenchmarkFirst(d) && d.index === -1 ? _this._benchmarkLabel : d.displayName;
        });
    }
};

/**
 * @method generateID
 * Returns 5 digit id for legend popover created
 */
Legend.prototype.generateID = function () {
    return Math.floor(Math.random() * 90000) + 10000;
};

/**
 * @method addPopoverContent
 * Sets title and adds legend items to popover
 * @param id ID of popover generated at instantiation
 */
Legend.prototype.addPopoverContent = function (id) {
    var popOverElem = document.getElementById(id);
    if (popOverElem.getElementsByClassName("mbc-mds-popover__header").length !== 0) {
        var currentHeader = popOverElem.getElementsByClassName("mbc-mds-popover__header");
        currentHeader[0].parentNode.removeChild(currentHeader[0]);
    }
    if (popOverElem.getElementsByClassName("mbc-mds-popover__content").length !== 0) {
        var oldContent = popOverElem.getElementsByClassName("mbc-mds-popover__content");
        oldContent[0].parentNode.removeChild(oldContent[0]);
    }
    var headerElem = d3.select(popOverElem).append('header').attr('class', 'mbc-mds-popover__header');
    var titleElem = headerElem.append('h2').attr('class', 'mbc-mds-popover__title');
    titleElem[0][0].innerHTML = "Legend";

    var contentElem = d3.select(popOverElem).append('div').attr('class', 'mbc-mds-popover__content').style('overflow', 'auto');
    var chartInners = document.getElementsByClassName('mbc-chart-inner');
    var chartTop = document.getElementsByClassName('mbc-chart-inner')[0].getBoundingClientRect().top;
    var arr = [].slice.call(chartInners);
    arr.forEach(function (inner) {
        if (d3.select(inner).attr('popoverID') == id) {
            chartTop = inner.getBoundingClientRect().top;
        }
    });
    var legendMax = window.innerHeight - chartTop - headerElem[0][0].clientHeight;
    var calcMax = legendMax - 120 < 120 ? 120 : legendMax - 120;
    var maxHeight = calcMax > 250 ? 250 : calcMax;
    contentElem[0][0].style.maxHeight = maxHeight + "px"; //minus container bottom padding and title
    this._addLegendItems(contentElem);
};

/**
 * @method createOverlayDismiss
 * Adds popover overlay for dismissal
 * @param parentID ID of popover chart parent to get popover wrapper
 */
Legend.prototype.createOverlayDismiss = function (id) {
    var popoverParentSelector = this.get('legendPopoverParentElement');
    var popoverParent = document.querySelector(popoverParentSelector);
    if (popoverParent === null) {
        console.error("Chart parameter legendPopoverParentElement must be a class or id selector, invalid value is '%s'", popoverParentSelector);
    }
    var overLay = document.createElement('div');
    overLay.setAttribute('class', "mbc-mds-popover__overlay mbc-overlay_" + id);
    overLay.style.width = '100%';
    overLay.style.height = '100%';
    overLay.style.display = 'block';
    overLay.addEventListener('click', function () {
        var popovers = document.querySelectorAll('.mbc-mds-popover');
        for (var m = 0; m < popovers.length; m++) {
            // Close currently opened popovers outside of current selected
            popovers[m].classList.remove('mbc-legend-popover--visible');
            popoverParent.removeChild(popovers[m]);
            var arr = [].slice.call(popovers[m].classList);
            arr.forEach(function (popOverClass) {
                if (popOverClass.indexOf('mbc-mds-legend-popover_') >= 0) {
                    var chartClass = popOverClass.substring(popOverClass.indexOf('_') + 1);
                    if (document.getElementsByClassName(chartClass)[0].children[0].classList.contains(Classes.LEGEND + "-top")) {
                        document.querySelector('[data-mbc-mds-popover="' + popovers[m].id + '"]').setAttribute('aria-expanded', 'false');
                    }
                }
            });
        }
        popoverParent.removeChild(overLay);
    }, false);
    popoverParent.appendChild(overLay);
};

/**
 * @method createLegendPopoverSVG
 * Build MDS popover using MDS icon see docs
 * http://designsystem.morningstar.com/components/popovers.html#css-class-references
 * http://designsystem.morningstar.com/visual-language/iconography.html
 */
Legend.prototype.createLegendPopoverSVG = function () {
    var id = this.get('popoverID');
    var parentID = this.get('parentID');
    var _this = this;
    var popoverParentSelector = this.get('legendPopoverParentElement');
    var popoverParent = document.querySelector(popoverParentSelector);
    this._container.style('overflow', 'visible');
    this._container.style('position', 'relative');

    var buttonDiv = this._container.append('button').attr('class', "mbc-mds-button mbc-mds-button--small mbc-mds-popover__trigger mbc-mds-button--icon-only").attr('type', 'button').attr('data-mbc-mds-popover', id).style('top', '0px').style('right', '6px').style('position', 'absolute').style('visibility', 'hidden').attr('aria-controls', id).attr('aria-haspopup', "true").attr('aria-expanded', 'false');
    var btnImage = buttonDiv.append("svg").attr("class", "mbc-mds-icon--s mbc-mds-button__icon");
    btnImage.attr('viewBox', '0 0 1500 1500').append('path').attr('d', 'M698.5 798.5h100v-100h-100v100zm-300 0h100v-100h-100v100zm350-800c-410 0-750 340-750 750s340 750 750 750 750-340 750-750-340-750-750-750zm0 1400c-360 0-650-290-650-650s290-650 650-650 650 290 650 650-290 650-650 650zm250-600h100v-100h-100v100z'); // draws ellipses icon from morningstar-design-system/dist/src/icons/ellipsis-circle--s.svg

    if (document.querySelector('[data-mbc-mds-popover="' + id + '"]')) {
        document.querySelector('[data-mbc-mds-popover="' + id + '"]').addEventListener('click', function () {
            var popOver = document.getElementById(id);
            if (popOver === null) {
                popOver = document.createElement('div');
                popOver.setAttribute('id', "" + id);
                popOver.setAttribute('class', "mbc-mds-popover mbc-mds-popover--width-200px mbc-mds-legend-popover_" + parentID);
                popOver.setAttribute('role', 'tooltip');
                popoverParent.appendChild(popOver);
            }

            _this.addPopoverContent(id);
            var popOverElem = document.getElementById(id);
            var popovers = document.querySelectorAll('.mbc-mds-popover');
            for (var m = 0; m < popovers.length; m++) {
                // Close currently opened popovers outside of current selected
                if (!popovers[m].isSameNode(popOverElem)) {
                    popovers[m].classList.remove('mbc-legend-popover--visible');
                    document.getElementsByClassName("" + parentID)[0].getElementsByClassName('mbc-mds-button--icon-only')[0].setAttribute('aria-expanded', 'false');
                }
            }
            var setPopover = _this.setPopoverPosition(id);
            setPopover.setPosition(popOverElem);
            popOverElem.classList.add('mbc-legend-popover--visible'); // Open currently selected popover
            document.querySelector('[data-mbc-mds-popover="' + id + '"]').setAttribute('aria-expanded', 'true');
            _this.createOverlayDismiss(id);
        });
    }
    this.showOverflowBtn(id);
};

/**
 * @method showOverflowBtn
 * Sets MDS popover wrapper to visible which shows only button in unselected state
 */
Legend.prototype.showOverflowBtn = function (id) {
    var parentID = this.get('parentID');
    var chartContainerElem = document.getElementsByClassName("" + parentID);
    var currentInner = chartContainerElem[0].getElementsByClassName('mbc-chart-legend-inner');

    if (currentInner[0].lastElementChild.style.display === 'none') {
        document.querySelector('[data-mbc-mds-popover="' + id + '"]').style.visibility = 'visible';
    }
};

/**
 * @method setPopoverPosition
 * Sets position of popovers on window scroll
 * Based on current overflow btn position and chart container position in window
 * @param id ID of popover generated at instantiation
 */
Legend.prototype.setPopoverPosition = function (id) {
    var _this = this;
    var parentID = this.get('parentID');
    var popoverWidth = 200;
    var currentPopover = document.getElementById(id);
    var popovers = document.querySelectorAll('.mbc-mds-popover');
    var chartContainerElem = document.getElementsByClassName("" + parentID);

    var iconBtns = document.querySelectorAll('.mbc-mds-popover__trigger');
    if (iconBtns.length > 0) {
        setPosition(currentPopover);
        window.onscroll = function () {
            var arr = [].slice.call(popovers);
            arr.forEach(function (popOverElem) {
                setPosition(popOverElem);
                if (!(popOverElem.getBoundingClientRect().top >= 0 || popOverElem.getBoundingClientRect().bottom >= 0) || !(popOverElem.getBoundingClientRect().left >= 0 || popOverElem.getBoundingClientRect().right >= 0)) {
                    //if out of viewport then remove popover and overlay
                    var popoverParentSelector = _this.get('legendPopoverParentElement');
                    var popoverParent = document.querySelector(popoverParentSelector);
                    var overLay = document.querySelector(".mbc-overlay_" + popOverElem.id);
                    var popoverBtn = document.querySelector('[data-mbc-mds-popover="' + popOverElem.id + '"]');
                    popOverElem.classList.remove('mbc-legend-popover--visible');
                    popoverBtn.blur();
                    popoverParent.removeChild(popOverElem);
                    popoverParent.removeChild(overLay);
                    popoverBtn.setAttribute('aria-expanded', 'false');
                }
            });
        };
    }

    function setPosition(popOverElem) {
        if (typeof popOverElem !== 'undefined' && popOverElem !== null) {
            var chartElem = chartContainerElem[0];
            var arr = [].slice.call(popOverElem.classList);
            arr.forEach(function (popOverClass) {
                if (popOverClass.indexOf('mbc-mds-legend-popover_') >= 0) {
                    var chartClass = popOverClass.substring(popOverClass.indexOf('_') + 1);
                    chartElem = document.querySelector("." + chartClass);
                }
            });
            if (popOverElem !== null && chartElem.children[0].classList.contains(Classes.LEGEND + "-top")) {
                removePopoverPosition(popOverElem);

                var iconBtn = document.querySelector('[data-mbc-mds-popover="' + popOverElem.id + '"]');
                var bodyRect = document.body.getBoundingClientRect(),
                    btnRect = iconBtn.getBoundingClientRect(),
                    offsetTop = btnRect.top - bodyRect.top,
                    offsetLeft = btnRect.left - bodyRect.left,
                    offsetLegendLeft = iconBtn.parentElement.getBoundingClientRect().left - bodyRect.left;
                var popOverHeight = popOverElem.getBoundingClientRect().height;

                if (window.innerWidth - iconBtn.getBoundingClientRect().right >= popoverWidth) {
                    //room on right of icon
                    popOverElem.style.top = offsetTop + iconBtn.getBoundingClientRect().height / 2 + "px";
                    popOverElem.style.left = offsetLeft + iconBtn.getBoundingClientRect().width + "px";
                    popOverElem.classList.add('mbc-mds-popover--right-bottom');
                    return;
                }

                if (iconBtn.getBoundingClientRect().top >= popOverElem.getBoundingClientRect().height) {
                    //room top of icon
                    popOverElem.style.top = offsetTop - popOverHeight - iconBtn.getBoundingClientRect().height / 2 + "px";
                    popOverElem.style.left = offsetLeft - popoverWidth + iconBtn.getBoundingClientRect().width / 2 + "px";
                    popOverElem.style.bottom = 'auto';
                    popOverElem.classList.add('mbc-mds-popover--top-left');
                    return;
                }

                if (iconBtn.parentElement.getBoundingClientRect().left >= popoverWidth) {
                    //container left is >= the width of popover 200 place left of chart
                    popOverElem.style.top = offsetTop + iconBtn.getBoundingClientRect().height / 2 + "px";
                    popOverElem.style.left = offsetLegendLeft - popoverWidth - 10 + "px";
                    popOverElem.classList.add('mbc-mds-popover--left-bottom');
                    return;
                }

                popOverElem.style.top = offsetTop + iconBtn.getBoundingClientRect().height + "px";
                popOverElem.style.left = offsetLeft - popoverWidth + iconBtn.getBoundingClientRect().width / 2 + "px";
                popOverElem.classList.add('mbc-mds-popover--bottom-left');
            }
        }
    }
    return {
        setPosition: setPosition
    };

    function removePopoverPosition(popOverElem) {
        popOverElem.removeAttribute("style");
        if (popOverElem.classList.contains('mbc-mds-popover--top-left')) {
            popOverElem.classList.remove('mbc-mds-popover--top-left');
        }
        if (popOverElem.classList.contains('mbc-mds-popover--bottom-left')) {
            popOverElem.classList.remove('mbc-mds-popover--bottom-left');
        }
        if (popOverElem.classList.contains('mbc-mds-popover--right-bottom')) {
            popOverElem.classList.remove('mbc-mds-popover--right-bottom');
        }
        if (popOverElem.classList.contains('mbc-mds-popover--left-bottom')) {
            popOverElem.classList.remove('mbc-mds-popover--left-bottom');
        }
    }
};

/**
 * @method getLegendWidth
 * Get Legend Width
 * @param container, @param data
 * @return {Number}
 */
Legend.prototype.getLegendWidth = function (container, data) {
    var svg = container.append("svg");
    var width = Utils.svg.getGreaterSVGTextWidth(svg, data, "displayName");
    svg.remove();
    return width;
};

Legend.prototype.getItemsWidth = function (container, data) {
    var svg = container.append("svg");
    var width = Utils.svg.getTotalSVGTextWidth(svg, data, "displayName");
    svg.remove();
    return width;
};

/**
 * @method _setLegendHeightWidth
 * Set Legend width/height
 * Set Chart Container Width/Height
 * based on 'right' or 'top' attribute of legend container
 */
Legend.prototype._setLegendHeightWidth = function () {
    var chartContainer = this._canvas.get("container");
    var textWidth = this.getLegendWidth(this._container, this._data) + 15 + 6; // padding left + icon margin + icon width
    var legendHeight = this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule
    var marginLeft = 0;

    this.set("legendHeight", legendHeight);
    this.adjustLegendWidth(textWidth);

    if (!this._container.classed(Classes.LEGEND + "-right")) {
        //When legend is placed at top of chart
        legendHeight = this._container[0][0].offsetHeight;
        marginLeft = this.get("yAxisOrient") === "left" ? this.get("yAxesLabelWidth") + this.get("yAxesLabelPadding") : 0;

        this._container.style("margin-left", marginLeft + "px");

        if (!this._isScatterPlot(this._data[0].groupName) && this._data[0].groupName !== "benchmark") {
            this._container.style("margin-left", this.get("yAxesLabelWidth") + "px");
        } else {
            d3.select(chartContainer).style("height", "calc(100% - " + legendHeight + "px)");
        }
    }

    this.set("legendContainer", this._container);
};

/**
 * @method adjustLegendHeight
 * @desc adjusts the legend height after the chart has been rendered
 * used within time-series chart currently
 */
Legend.prototype.adjustLegendHeight = function () {
    var container = this.get("selection").selectAll("." + Classes.LEGEND);
    var canvas = this.get("canvas");

    if (container.classed(Classes.LEGEND + "-right")) {
        container.style({
            height: canvas.height() + "px"
        });
    }
};

/**
 * @method adjustLegendWidth
 * @desc adjusts the legend height after the chart has been rendered
 * used within time-series chart currently
 */
Legend.prototype.adjustLegendWidth = function (textWidth) {
    var canvas = this._canvas;
    var parentID = this.get('parentID');
    var chartContainer = canvas.get("container");
    var isTimeSeries = this._options.chart === "time-series";
    var scrollbarWithPadding = 17;
    var iconWidth = 40;
    var legendHeight = typeof this._container[0][0].children[0] !== 'undefined' ? this._container[0][0].children[0].clientHeight : this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule
    if (this._container.classed(Classes.LEGEND + "-right")) {
        var legendMaxWidth = this._legendMaxWidth;
        if (legendHeight > this._container[0][0].offsetHeight) {
            //Scrollbar space
            textWidth = textWidth + scrollbarWithPadding;
            if (isTimeSeries) {
                d3.select(this._container[0][0].children[0]).attr('width', textWidth - 2 + 'px');
            } //show item line full width of container
        }
        textWidth = textWidth > legendMaxWidth ? legendMaxWidth : textWidth;

        this._legend.style("height", legendHeight + "px");
        this._container.style("width", textWidth + "px");
        var chartWidth = this.get("selection")[0][0].offsetWidth - textWidth - 13;
        d3.select(chartContainer).style("width", chartWidth + "px");
        this.set("legendWidth", textWidth);

        if (!this._isScatterPlot() && this._data[0].groupName !== "benchmark") {
            this._container.style({
                height: canvas.height() - 5 + "px", //SVG Specific
                width: textWidth + "px",
                "margin-top": canvas.get("margin").top + "px" //SVG Specific
            });

            chartContainer = d3.select(canvas.get("container"));
            var chartWidth = chartContainer.node().clientWidth;

            //calc was not working properly on IE 11, set width based on client instead
            chartContainer.style("width", "calc(100% - " + textWidth + "px)");
        }
    } else {
        chartContainer = d3.select(canvas.get("container"));
        var chartWidth = chartContainer.node().clientWidth;
        d3.select("#svgcontainer_" + parentID).select("svg").attr("width", chartWidth - iconWidth - 8); //overflow button - medium space
    }
};

/**
  * @method _color
  * Returns the index *n* color from the *colors* attribute array
  * @param {Number} index Index of color to return
  * scatterplot uses plot colors different array than colors
  * @return {Array}
  */
Legend.prototype._color = function (index) {
    var plotColors;
    var colors = this.get("colors");
    if (this.get("plotColors")) {
        if (this.get("plotColors").length === 0) {
            plotColors = [colors[0], colors[2]];
        }
        plotColors = plotColors.concat(colors.slice(3));
        return plotColors[index % colors.length];
    }
    return colors[index % colors.length];
};

/**
  * @method _isDottedLine
  * Returns whether current key is dotted line
  * @param {String} group Chart group set
  * @param {String} name Current data value name
  * when adding legend item determines whether a {background-color, dotted line, or border} needed
  * @return {Boolean}
  */
Legend.prototype._isDottedLine = function (group, name) {
    if (this.get("dottedLineNames")) {
        var dottedLineNames = !(this._isScatterPlot(group) || group === "benchmark") ? this.get("dottedLineNames")[group] : null;
        if (dottedLineNames instanceof Array) {
            return dottedLineNames.indexOf(name) > -1;
        } else {
            return dottedLineNames;
        }
    }
    return group === "benchmark" && this._benchmarkStyle;
};

/**
  * @method _isScatterPlot
  * Returns whether chart option is scatterplot
  * @return {Boolean}
  */
Legend.prototype._isScatterPlot = function () {
    return this._options.chart === "scatterplot";
};

/**
  * @method _isBenchmark
  * Returns whether current data is in benchmark group
  * @return {Boolean}
  */
Legend.prototype._isBenchmark = function (groupName) {
    return groupName === "benchmark";
};

/**
 * @method sortLegendData
 * @param {Array} groups
 * @desc Takes an array of group names and creates a new data object sorted in descending order by value
 * @return {Array} sortedArray
 */
Legend.prototype._sortLegendData = function () {
    var dataManager = this.get("data");
    var sortedArr = [];

    var _this = this;
    var addLegendSet = function addLegendSet(group) {
        group.forEach(function (dataset) {
            var value = _this.getValidEndValue(dataset.series);
            var displayName = dataset.displayName;
            var index = dataset.index;
            sortedArr.push({ value: value, displayName: displayName, index: index });
        });
    };

    var y1DomainDataset = this.get("y1DomainDataset");
    var groups = [y1DomainDataset];
    if (this.get("y2")) {
        var y2DomainDataset = this.get("y2DomainDataset");
        groups = groups.concat(y2DomainDataset);
    }

    groups.forEach(function (name) {
        addLegendSet(dataManager.get(name));
    });

    // sort legend items by the end value of series line
    sortedArr = this.sortDataByEndValue(sortedArr);

    return sortedArr;
};

/**
 * Mouse Listeners
 */
Legend.prototype.legendFocusIn = function (group) {
    this.get("legendContainer").selectAll("." + Classes.LEGEND_ITEM).filter(function () {
        return !d3.select(this).classed(group);
    }).classed("unfocused", true);
};

Legend.prototype.legendFocusOut = function () {
    this.get("legendContainer").selectAll("." + Classes.LEGEND_ITEM).classed("unfocused", false);
};

Legend.prototype.legendMouseover = function (d) {
    var group = Utils.string.dashify(d.name);
    var canvas = this.get("canvas");
    canvas.layer("chart-layer").selectAll("g.dot").filter(function () {
        return !d3.select(this).classed(group);
    }).classed({
        unfocused: true,
        less: true
    });
    canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
        unfocused: true
    });
    this.legendFocusIn(group);
};

Legend.prototype.legendMouseout = function () {
    var canvas = this.get("canvas");
    canvas.layer("chart-layer").selectAll("g.dot").classed({
        unfocused: false,
        less: false
    });
    canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
        unfocused: false
    });
    this.legendFocusOut();
};

Legend.prototype.getLegendWidth = function (container, data) {
    var svg = container.append("svg");
    var width = Utils.svg.getGreaterSVGTextWidth(svg, data, "displayName");
    svg.remove();
    return width;
};

Legend.prototype.legendBenchmarkMouseover = function (d) {
    var canvas = this.get("canvas");
    canvas.layer("chart-layer").selectAll("g.dot").classed({
        unfocused: true,
        less: true
    });
    canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
        focused: true
    });
    this.legendFocusIn("benchmark");
};

Legend.prototype.legendBenchmarkMouseout = function () {
    var canvas = this.get("canvas");
    canvas.layer("chart-layer").selectAll("g.dot").classed({
        unfocused: false,
        less: false
    });
    canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
        focused: false
    });
    this.legendFocusOut();
};

module.exports = Legend;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = {"constants":{"color":{"white":"#ffffff","black":"#000000","neutral":{"12":"#1e1e1e","20":"#333333","37":"#5e5e5e","50":"#808080","67":"#ababab","80":"#cccccc","90":"#e5e5e5","95":"#f2f2f2"},"blue":{"23":"#004376","32":"#005ba1","36":"#006fba","38":"#1f55a5","41":"#0077cf","44":"#008dde"},"green":{"34":"#00af41"},"dark-green":{"34":"#518428"},"teal":{"19":"#005f5f"},"violet":{"46":"#6a4c9e"},"cyan":{"44":"#00a8e1"},"maroon":{"32":"#a50032"},"red":{"50":"#ff0000"},"yellow":{"48":"#f5c400"},"orange":{"54":"#ef7622"},"light-red":{"46":"#e60546"},"dark-violet":{"32":"#7d256f"},"dark-yellow":{"47":"#c19c31"},"aqua":{"37":"#00beaf"},"bright-orange":{"50":"#ff3c00"},"light-green":{"50":"#89bd40"}},"brand":{"blue":"#1f55a5","cyan":"#00a8e1"},"background-color":{"default":"#ffffff","light":"#f2f2f2","dark":"#1e1e1e","black":"#000000","alternative-row":{"default":"#e5e5e5","on-light":"#e5e5e5","on-dark":"#333333"},"feedback":{"error":"#ff0000","warning":"#f5c400"}},"text-color":{"primary":{"default":"#1e1e1e","on-light":"#1e1e1e","on-dark":"#ffffff"},"secondary":{"default":"#5e5e5e","on-light":"#5e5e5e","on-dark":"#ababab"},"link":{"default":"#006fba","on-light":"#006fba","on-dark":"#008dde"},"error":{"default":"#ff0000","on-light":"#ff0000","on-dark":"#ff0000"}},"interactive-color":{"primary":{"default":"#0077cf","hover":"#005ba1","focus":"#005ba1","active":"#004376"},"secondary":{"primary":"transparent","hover":"#5e5e5e","focus":"#5e5e5e","active":{"on-light":"#333333","on-dark":"#e5e5e5"}},"disabled":{"on-light":"#808080","on-dark":"#ababab"}},"visualization-color":{"asset-allocation":{"local-stocks":"#1f55a5","non-local-stocks":"#8faad2","stocks":"#1f55a5","real-estate":"#a50032","other":"#f5c400","cash":"#518428","bonds":"#ef7622","not-classified":"#e5e5e5"},"correlation":{"positive":"#1f55a5","negative":"#ef7622"},"sector":{"cyclical":"#ef7622","sensitive":"#1f55a5","defensive":"#518428"},"sustainability":"#1f55a5","valuation":{"under":"#00a8e1","fair":"#e5efef","over":"#ef7622"},"performance":{"positive":"#00af41","neutral-text":"#5e5e5e","neutral-chart":"#cccccc","negative":"#ff0000"}},"chart-color":{"1":"#1f55a5","2":"#a50032","3":"#f5c400","4":"#518428","5":"#00a8e1","6":"#6a4c9e","7":"#ef7622","8":"#005f5f","9":"#00af41","10":"#e60546","11":"#7d256f","12":"#c19c31","13":"#00beaf","14":"#ff3c00","15":"#89bd40"},"feedback-color":{"info":"#f2f2f2","error":"#ff0000","error-background":"#ffe5e5","warning":"#f5c400","warning-background":"#fef9e5","success":"#00af41","success-background":"#e5f7eb"},"font":{"family":{"sans-serif":"'Univers', HelveticaNeue, 'Helvetica Neue', Helvetica, Arial, sans-serif","monospace":"'Lucida Sans Typewriter', 'Lucida Console', monaco, 'Bitstream Vera Sans Mono', monospace"},"weight":{"thin":200,"light":300,"regular":400,"bold":600},"size":{"xs":"10px","s":"14px","m":"16px","l":"20px","base":"16px","default":"16px","heading-level-1":"45px","heading-level-2":"32px","heading-level-3":"28px","heading-level-4":"23px","heading-level-5":"20px","heading-level-6":"18px","code":"12px"},"line-height":{"headings":1.2,"body":1.375}},"border":{"separator":{"default":"solid 1px #e5e5e5","on-light":"solid 1px #cccccc","on-dark":"solid 1px #333333","on-title":"solid 2px #333333","color-on-light":"#cccccc","color-on-dark":"#333333"},"control":{"default":"solid 1px #808080","color":"#808080"},"container":{"default":"solid 1px #e5e5e5","color-default":"#e5e5e5"},"disabled":"solid 1px #808080","radius":{"panel":"12px","pill":"24px","round":"50%","s":"2px"}},"size":{"icon":{"s":"15px","m":"23px"}},"space":{"xs":"4px","s":"6px","m":"8px","l":"12px","xl":"16px","quarter-x":"2px","half-x":"4px","three-quarter-x":"6px","1-x":"8px","1-and-a-half-x":"12px","2-x":"16px","3-x":"24px","4-x":"32px","8-x":"64px","inset":{"xs":"4px","s":"6px","m":"8px","l":"12px","xl":"16px","quarter-x":"2px","half-x":"4px","three-quarter-x":"6px","1-x":"8px","1-and-a-half-x":"12px","2-x":"16px","3-x":"24px","4-x":"32px","8-x":"64px","stretch":{"s":"6px 12px","m":"8px 16px","l":"12px 24px"}},"inline-left":{"xs":"0 4px 0 0","s":"0 6px 0 0","m":"0 8px 0 0","l":"0 12px 0 0","xl":"0 16px 0 0","half-x":"0 4px 0 0","three-quarter-x":"0 6px 0 0","1-x":"0 8px 0 0","1-and-a-half-x":"0 12px 0 0","2-x":"0 16px 0 0"},"inline-right":{"xs":"0 0 0 4px","s":"0 0 0 6px","m":"0 0 0 8px","l":"0 0 0 12px","xl":"0 0 0 16px","half-x":"0 0 0 4px","three-quarter-x":"0 0 0 6px","1-x":"0 0 0 8px","1-and-a-half-x":"0 0 0 12px","2-x":"0 0 0 16px"},"stack":{"s":"0 0 6px","m":"0 0 8px","l":"0 0 12px","xl":"0 0 16px","quarter-x":"0 0 2px","half-x":"0 0 4px","three-quarter-x":"0 0 6px","1-x":"0 0 8px","1-and-a-half-x":"0 0 12px","2-x":"0 0 16px","3-x":"0 0 24px","4-x":"0 0 32px","8-x":"0 0 64px"}},"transition":{"color":{"link":"color, 300ms"}},"opacity":{"disabled":".4","overlay":".5"},"box-shadow":{"drop":"0 2px 4px 0 rgba(0, 0, 0, .08)","focus":"0 0 4px 2px rgba(#0077cf, .8)"},"z-index":{"low":1,"sticky":100,"modal-overlay":800,"modal-content":810,"top-of-the-world":900},"breakpoint":{"navigation":{"on-canvas-nav":"768px","wide":"1024px"}},"masthead":{"height":"50px","height-tall":"70px"},"site-navigation":{"height":"50px","vertical-width":"230px"}},"shared":[{"utils":true},{"color":true},{"fonts":true},{"accessibility":true},{"animation":true},{"size":true},{"bubbles":true},{"typography":true}],"components":[{"link":true},{"icon":true},{"button":true},{"button_group":true},{"card":true},{"navigation_container":true},{"container":true},{"data_table":true},{"dialog":true},{"form":true},{"combo_box":true},{"list_group":true},{"loader":true},{"modal":true},{"menu":true},{"notification":true},{"pagination":true},{"page_shell":true},{"popover":true},{"range_slider":true},{"search_field":true},{"stepper":true},{"switch":true},{"tag":true},{"tooltip":true},{"masthead":true},{"site_navigation":true},{"alert":true},{"top_hat":true},{"layout_grid":true}],"theme":"mds"}

/***/ })

/******/ });
});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(6), __webpack_require__(7));
	else if(typeof define === 'function' && define.amd)
		define(["mbc-core", "mbc-flag", "mbc-legend"], factory);
	else if(typeof exports === 'object')
		exports["mbc-time-series-line"] = factory(require("mbc-core"), require("mbc-flag"), require("mbc-legend"));
	else
		root["mbc-time-series-line"] = factory(root["mbc-core"], root["mbc-flag"], root["mbc-legend"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 131);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);


/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



__webpack_require__(112);

var _timeSeriesLine = __webpack_require__(93);

var _timeSeriesLine2 = _interopRequireDefault(_timeSeriesLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _timeSeriesLine2.default;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToolTip = __webpack_require__(1);
var Core = __webpack_require__(0);
var Utils = Core.Utils;
var mds_constants = Utils.colors.mds_constants;

function ToolTipMixin() {}
/**
 * To configure the tooltip template function;
 * The template outer div must be given the "tooltip-inner" class;
 * The template outer div must also be given the "tooltip-flag" class;
 * The toolTipTemplate method must accept "d" as a parameter;
 * The toolTipTemplate method must return a template string
 * @type {Function}
 */

/* private methods */

/**
 * _currentDate
 * @private
 **/
var _currentDate = null;

/**
 * @method _getCurrentDate
 * @private
 * @desc returns the current mouse coordinate date
 * @example
 * var currentDate = _getCurrentDate();
 *
 * @return {Object} Date object
**/
var _getCurrentDate = function _getCurrentDate() {
    return _currentDate;
};

/**
 * @method _setCurrentDate
 * @private
 * @param {Object} - Date object
 * @desc Expects a Date object and sets it as the current date
 * @example
 * _setCurrentDate(new Date())
 *
 * @return undefined
**/
var _setCurrentDate = function _setCurrentDate(date) {
    if (Object.prototype.toString.call(date) !== "[object Date]") {
        console.warn("Can't update date: not a date object!");
        return;
    }

    _currentDate = date;
};

/**
 * @method _generateCells
 * @param {Array} colors - color codes to style each dash per line
 * @desc  Generates the cells of the template for each line on the chart.
 * @example
 * var cells = _generateCells(["#FF0000"]);
 *
 * @return {String} Concatenated template string of the cells
**/

ToolTipMixin.prototype.generateCells = function () {
    var data = this.get("tooltipData");
    var colors = this.get("colors");
    var dottedLines = this.get("dottedLines");
    var maxWidthTextCell = 164 - Utils.string.getLongestTextStringWidth(data); // 200 max width - 10 icon with - 26 in total padding

    return data.map(function (item) {
        var line = item.name;
        var color = colors[item.index] || mds_constants["color"].black;
        var showDots = dottedLines.indexOf(line) !== -1;
        var benchmarkStyle = showDots ? "border-top:2px dotted " + color : "border-top:2px solid " + color;
        return "<div class=\"cell tooltip-row\">\n                        <div class=\"tip-cell-icon tooltip-cell\" style=\"" + benchmarkStyle + "\"> </div>\n                        <div class=\"tip-cell-name tooltip-cell\" style=\"max-width: " + maxWidthTextCell + "px\"> " + line + " </div>\n                        <div class=\"tip-cell-data tooltip-cell\">" + item.value + "</div>\n                    </div>";
    }).join("");
};

/**
 * @method _getLineData
 * @private
 * @desc Retrieve and concatenate the line data for the given context's data manager '
 * @example
 * var lines = _getLineData();
 *
 * @return {Array} Concatenated array of line data for y1 and y2 groups
**/
var _getLineData = function _getLineData() {
    if (!this) {
        throw new Error("Context required to find line data");
    }

    var dataManager = this.get("data");
    var y1DomainDataset = this.get("y1DomainDataset");
    var lines = dataManager.get(y1DomainDataset);
    var hasY2 = this.get("y2");

    if (hasY2) {
        var y2DomainDataset = this.get("y2DomainDataset");
        lines = lines.concat(dataManager.get(y2DomainDataset));
    }

    return lines;
};

/* end private methods */

/**
 * @method updateTooltipData
 * @param {String} name
 * @param {Number} value
 * @param {Number} index
 * @desc Sets or updates data for one of the lines on the chart.
 * @example
 * this.updateTooltipData("602107", -47, 1)
 *
 * @return undefined
**/
ToolTipMixin.prototype.updateTooltipData = function (series, mouseObjects) {
    if (!series.length) {
        console.warn("Can't update data: missing information");
        return;
    }

    // sort tooltip items by the end value of series line
    series = this.sortDataByEndValue(series);

    // format tooltipData value
    var y1FormatFn = this.tickFormat(this.get("y1TickFormat"));
    var y2FormatFn = this.tickFormat(this.get("y2TickFormat"));
    var dataManager = this.get("data");

    var tooltipData = [];
    series.forEach(function (item) {
        var value = null;
        var name = item.name;
        var data = mouseObjects[name];
        if (data) {
            value = data.value;
        }
        var formatter = dataManager.inGroup(name, "y1") ? y1FormatFn : y2FormatFn;
        var formattedValue = Utils.string.convertDashToEnDash(formatter(value));
        var transformedValue = formattedValue == null || formattedValue == "" ? "N/A" : formattedValue;
        tooltipData.push({
            name: name,
            index: item.index,
            value: transformedValue
        });
    });

    this.set("tooltipData", tooltipData);
};

/**
 * @method toolTipTemplate
 * @desc Either uses the custom template added by the user or generates a default one.
 *       Used to draw the tooltip later.
 * @example
 * chart.toolTipTemplate()
 *
 *
 * @return {String} template for tooltip
**/
ToolTipMixin.prototype.toolTipTemplate = function () {
    var customTemplate = this.get("tooltipCustomTemplate");
    if (customTemplate) {
        return customTemplate;
    } else {
        var format, title;
        var cells = this.generateCells.call(this);
        var date = _getCurrentDate();

        if (date) {
            format = this.get("tooltipTimeFormat") || d3.time.format("%x");
            title = this.get("tooltipTitle") || format(date);
        } else {
            title = this.get("tooltipTitle") || "Securities";
        }

        return "<div class=\"tooltip-inner tooltip-flag\">\n                    <div class=\"tooltip-title\">\n                        <p>" + title + "</p>\n                    </div>\n\n                    <div class=\"tooltip-body tooltip-table\">\n                        " + cells + "\n                    </div>\n                </div>";
    }
};

/**
 * @method drawToolTip
 * @desc Binds the tooltip to the tooltip transparent canvas
 * @example
 * chart.drawToolTip()
 *
 *
 * @return undefined
 **/
ToolTipMixin.prototype.drawToolTip = function (options) {

    this.set("showToolTip", true);

    var defaultOpts = {
        transition: false,
        namespace: this.get("id"),
        chart: "time-series"
    };

    Utils.object.copy(defaultOpts, options);

    var t = this.toolTipTemplate.bind(this);
    var tooltip = ToolTip(defaultOpts).template(t);
    var canvas = this.get("canvas");
    var svg = canvas.layer("top-layer", "front").select("rect");

    svg.call(tooltip.bind());

    this.set("tooltipInfo", tooltip);
};

/**
 * @method removeToolTip
 * @desc Removes the tooltip and the tooltip canvas
 * @example
 * chart.removeToolTip()
 *
 *
 * @return undefined
**/
ToolTipMixin.prototype.removeToolTip = function () {

    this.set("showToolTip", false);

    var canvas = this.get("canvas");
    var layer = canvas.layer("front-group");

    layer.remove();
    this.update();
};

/**
 * @method validateTooltipDirection
 * @desc Determines if the tooltip needs to change positions based on where it is on the canvas and update it.
 *
 * @param {Array} mouse - d3 selection
 * @example
 * var mouse = d3.mouse(this)
 * chart.validateTooltipDirection(mouse)
 *
 *
 * @return undefined
 **/
ToolTipMixin.prototype.validateTooltipDirection = function (mouse) {
    var coords = {};
    var canvas = this.get("canvas");
    var tooltipData = this.get("tooltipData");

    coords.tooltip = this.get("tooltipInfo")._clientRect;
    coords.mouse = mouse;
    coords.canvasWidth = canvas.width();
    coords.canvasHeight = canvas.height();
    coords.canvasPositioning = canvas.get("svg").node().getBoundingClientRect();

    this.getHoverLineLeft();
    this.changeToolTipDirection(coords);

    if (this.get("tooltipHidden")) {
        this.get("tooltipInfo").show(tooltipData, {
            position: this.get("direction"),
            namespace: this.get("id"),
            hoverLeft: this.get("hoverLineLeft")
        });
        this.set("tooltipHidden", false);
    }
};

/**
 * @method changeToolTipDirection
 * @desc Uses the coordinate information to decide how the tooltip should be positioned in the canvas. Determines top and bottom boundry when size of flag exceeds size of canvas.
 *
 * @param {Object} coords - mouse and tooltip positional information
 * @example
 * var coords = {};
 * coords.tooltip = this.get("tooltipInfo")._clientRect;
 * coords.mouse = mouse;
 * coords.canvasWidth = canvas.width();
 * coords.canvasHeight = canvas.height();
 * coords.canvasPositioning = canvas.get("svg").node().getBoundingClientRect();
 * chart.changeToolTipDirection(coords)
 *
 * @return undefined
 **/
ToolTipMixin.prototype.changeToolTipDirection = function (coords) {
    var tooltip = this.get("tooltipInfo"); //Reference to tooltip
    var canvasWidth = coords.canvasWidth; // Chart plotted width
    var canvasHeight = coords.canvasHeight; // Chart plotted height

    var hoverLineToLeft = this.get("hoverLineLeft") - coords.canvasPositioning.left; //The distance between hoverLine and left side of canvas
    var tooFarRight = coords.tooltip && coords.mouse[0] >= canvasWidth - coords.tooltip.width && hoverLineToLeft >= coords.tooltip.width; //Boolean for right canvas boundry
    var tooFarLeft = coords.tooltip && (coords.mouse[0] < canvasWidth - coords.tooltip.width ? true : hoverLineToLeft < coords.tooltip.width); //Boolean for left canvas boundry
    var tooHigh = coords.tooltip && coords.mouse[1] <= coords.tooltip.height; //Boolean for top canvas boundry
    var tooLow = coords.tooltip && coords.mouse[1] >= canvasHeight - coords.tooltip.height; //Boolean for bottom canvas boundry

    var windowtHeight = window.innerHeight; // Window/viewport height to use for bottom boundry
    var viewportMousePositionY = d3.event.clientY; // Y mouse position relative to window/viewport
    var exceedsViewportTop = coords.tooltip && coords.tooltip.height - coords.mouse[1] > coords.canvasPositioning.top; //Boolean check if tooltip exceeds beyond viewport top
    var exceedsViewportBottom = coords.tooltip && viewportMousePositionY + coords.tooltip.height > windowtHeight; //Boolean check if tooltip exceeds beyond viewport bottom

    // If flag exceeds top and bottom of canvas, then check collision with viewport viewport
    if (tooHigh && tooLow) {

        // Check collision to viewport, default to display flag down if conditions both fail
        tooHigh = !exceedsViewportTop && exceedsViewportBottom ? false : true;
        tooLow = !exceedsViewportTop && exceedsViewportBottom ? true : false;
    }

    // If flag exceeds neither the top or bottom of canvas default the position
    if (!tooHigh && !tooLow) {
        tooLow = true;
    }

    if (tooFarRight && tooLow) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "left-bottom");
        return;
    }

    if (tooFarLeft && tooLow) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "right-bottom");
        return;
    }

    if (tooFarRight && tooHigh) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "left-top");
        return;
    }

    if (tooFarLeft && tooHigh) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "right-top");
        return;
    }

    return;
};

/**
     * @method getHoverLineLeft
     * @desc Set the left px position of the current selected data line
     * @return undefined
**/
ToolTipMixin.prototype.getHoverLineLeft = function () {
    var canvas = this.get("canvas");
    var mouseRect = canvas.layer('front-group').select(".mouse-rect-line");
    this.set("hoverLineLeft", mouseRect[0][0].getBoundingClientRect().left);
};

/**
     * @method createMouseRect
     * @desc Create the area on the canvas that listens to mouse events for the tooltip
     *
     * @example
     * chart.this.createMouseRect();
     *
     *
     * @return undefined
    **/
ToolTipMixin.prototype.createMouseRect = function () {
    var _this = this;
    var canvas = this.get("canvas");
    var scales = this.get("scales");

    var yPadding = this.get("yPadding");
    var width = canvas.width() - yPadding * 2;
    var height = canvas.height();
    var topLayer = canvas.layer("top-layer", "front");
    var x = scales.scale("x");
    var rectMouse = topLayer.append("rect"); // append a rect to catch mouse movements on canvas

    rectMouse.attr("x", yPadding).attr("width", width).attr("height", height).attr("fill", "none").attr("pointer-events", "all").classed({
        "rect__event-area": true
    }).on("mouseleave", function () {
        // on mouse leave hide line
        canvas.layer('front-group').select(".mouse-rect-line").style("opacity", "0");

        var agileStyle = _this.get("agileStyle");
        if (!agileStyle.bubbleOpacity) {
            var layer = canvas.layer("line-chart-layer");
            layer.selectAll(".line-bubbles").attr("opacity", 0);
        }
    }).on("mouseover", function () {
        // on mouse in show line
        canvas.layer('front-group').select(".mouse-rect-line").style("opacity", "1");
    }).on("mousemove", function () {
        // mouse moving over canvas
        var frontGroup = canvas.layer('front-group');
        var mouse = d3.mouse(this);

        var seriesData = [];
        var series = [];
        // build seriesData at the same time when get translate
        frontGroup.selectAll(".mouse-per-line").attr("transform", function (d) {
            seriesData = seriesData.concat(d.series);
            series.push({
                name: d.displayName,
                index: d.index,
                value: _this.getValidEndValue(d.series)
            });
            return "translate(" + mouse[0] + "," + mouse[1] + ")";
        });

        // sort all seriesData by date
        seriesData.sort(function (a, b) {
            return a.date < b.date ? -1 : a.date > b.date ? 1 : 0;
        });

        var xDate = x.invert(mouse[0]);
        var bisect = d3.bisector(function (d) {
            return d.date;
        }).right;
        var idx = bisect(seriesData, xDate) - 1;
        idx = idx >= seriesData.length ? seriesData.length - 1 : idx;
        idx = idx < 0 ? 0 : idx;
        // find out the date at which mouse place, it will be used in the following
        var mouseDate = seriesData[idx].date;

        // find out items at the mouseDate,
        // Notice: if a series have no data on the day, mouseItems will not catains this series data
        // this is why we need seriesNames to record whole series
        var mouseItems = seriesData.filter(function (item) {
            return item.date.toString() === mouseDate.toString();
        });
        // convert to a object to make data more easy to be found
        var mouseObjects = {};
        mouseItems.forEach(function (item) {
            mouseObjects[item.name] = item;
        });

        /**
         * make sure tooltip use this data
         */
        _this.updateTooltipData(series, mouseObjects);

        /**
         * snap scrubber line to relevant hover data point
         */
        frontGroup.select(".mouse-rect-line").attr("d", function () {
            var d = "M" + x(mouseDate) + "," + height;
            d += " " + x(mouseDate) + "," + 0;
            return d;
        });

        _setCurrentDate(mouseDate);
        _this.validateTooltipDirection(mouse);
        _this.handleAgileStyle(mouseDate);
    }); //end mousemove
};

/**
* @method handleAgileStyle
* @desc Display bubbles which has the same date as mouseDate, hide other bubbles.
* @param {Date} mouseDate: the closest calculated date with mouse position
*/
ToolTipMixin.prototype.handleAgileStyle = function (mouseDate) {
    var agileStyle = this.get("agileStyle");
    if (!agileStyle.bubbleOpacity) {
        var canvas = this.get("canvas");
        var layer = canvas.layer("line-chart-layer");
        layer.selectAll(".line-bubbles").attr("opacity", 0);
        layer.selectAll(".line-bubbles.date" + mouseDate.getTime()).attr("opacity", 1);
    }
};

/**
 * @method renderToolTip
 * @desc Takes all the necessary steps to display the tooltip flag as long as the proper conditions are met
 *
 * @example
 * chart.renderToolTip();
 *
 *
 * @return undefined
 **/
ToolTipMixin.prototype.renderToolTip = function () {
    if (this.get("showToolTip") && !this.get("initialized")) {
        this.set("tooltipData", []);
        this.set("tooltipHidden", true); //initializes the property used to show tooltip
        this.createTooltip();
        this.drawToolTip({
            namespace: this.get("id")
        });
        this.set("direction", "right-top");
        this.set("initialized", true);
    }
};

/**
 * @method createTooltip
 * @desc Takes each line of the chart and calculates necessary tooltip data including timestamp, value, and name
 *       depending on where the mouse is on the canvas.
 *
 * @example
 * chart.renderToolTip();
 *
 *
 * @return undefined
 **/
ToolTipMixin.prototype.createTooltip = function () {
    var canvas = this.get("canvas");
    var lineData = _getLineData.bind(this);

    var layer = canvas.layer("front-group");

    var mouseG = layer.append("g").attr("class", "mouse-over-effects");

    mouseG.append("path") // this is the black vertical line to follow mouse
    .attr("class", "mouse-rect-line").style("stroke", "black").style("stroke-width", "1px").style("stroke-dasharray", "3,3").style("opacity", "0").style("pointer-events", "all");

    var mousePerLine = mouseG.selectAll(".mouse-per-line").data(lineData);

    mousePerLine.attr("class", "mouse-per-line");

    mousePerLine.enter().append("g").attr("class", "mouse-per-line");

    mousePerLine.exit().remove();

    this.createMouseRect();
};

module.exports = ToolTipMixin;

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var YEAR_FORMAT = "%Y";

/**
 * Ticks period configuration. '_sm' suffix stands for small screens (breakpoint).
 */
var TICKS_DEF = {
    year: [d3.time.years, 1],
    year_sm: [d3.time.years, 2],
    quarter: [d3.time.months, 3],
    quarter_sm: [d3.time.months, 6],
    month: [d3.time.months, 1],
    month_sm: [d3.time.months, 2],
    week: [d3.time.weeks, 1],
    week_sm: [d3.time.weeks, 2],
    day: [d3.time.days, 1],
    day_sm: [d3.time.days, 2],
    hour: [d3.time.hours, 4],
    hour_sm: [d3.time.hours, 4]
};

/**
 * Map that holds the timeline sub level for each period.
 */
var LEVEL_MAPPER = {
    year: "year",
    quarter: "quarter",
    month: "month",
    week: "week",
    day: "day",
    hour: "hour"
};

/**
 * Returns the tick period parameters for a given period and screen type.
 * @param {*} period
 * @param {*} smallScreen
 * @returns {Array} Array that holds the tick configuration for the x axis label.
 */
var getTickParameters = function getTickParameters(period, smallScreen) {
    period = period + (smallScreen ? "_sm" : "");
    return TICKS_DEF[period];
};

function Helper() {}

/**
 * Returns an array that contains the years within the domain.
 * @method getYear
 * @param {Array} domain
 * @returns {Array}
 */
var getYear = function getYear(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var yr = Math.floor(date.getFullYear());
    newDate.setYear(++yr);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        newDate.setDate(1);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        yr = Math.floor(newDate.getFullYear());
        newDate.setYear(++yr);
    }
    return dateArr;
};

/**
 * Returns an array that contains the quarters within the domain.
 * @method getQuarter
 * @param {Array} domain
 * @returns {Array}
 */
var getQuarter = function getQuarter(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var qtr = Math.floor(date.getMonth() / 3);
    newDate.setMonth(++qtr * 3);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        newDate.setDate(1);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        qtr = Math.floor(newDate.getMonth() / 3);
        newDate.setMonth(++qtr * 3);
    }
    return dateArr;
};

/**
 * Returns an array that contains the months within the domain.
 * @method getMonth
 * @param {Array} domain
 * @returns {Array}
 */
var getMonth = function getMonth(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var nextMonth = date.getMonth() + 1;
    newDate.setMonth(nextMonth);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        newDate.setDate(1);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        nextMonth = newDate.getMonth() + 1;
        newDate.setMonth(nextMonth);
    }

    return dateArr;
};

/**
 * Returns the next week first day.
 * @param {Date} date
 * @returns {Date}
 */
var getNextWeekStartDate = function getNextWeekStartDate(date) {
    var newDate = new Date(date.toString());
    var day = newDate.getDate();
    var weekDay = newDate.getDay();
    newDate.setDate(day + (7 - weekDay));
    return newDate;
};

/**
 * Returns an array that contains the weeks within the domain.
 * @method getWeek
 * @param {Array} domain
 * @returns {Array}
 */
var getWeek = function getWeek(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = getNextWeekStartDate(date);
    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        dateArr.push(newDate);
        newDate = getNextWeekStartDate(newDate);
    }

    return dateArr;
};

/**
 * Returns an array that contains the days within the domain.
 * @method getDay
 * @param {Array} domain
 * @returns {Array}
 */
var getDay = function getDay(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var nextDay = date.getDate() + 1;
    newDate.setDate(nextDay);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        nextDay = newDate.getDate() + 1;
        newDate.setDate(nextDay);
    }

    return dateArr;
};

/**
 * Returns an array that contains the hours within the domain.
 * @method getHour
 * @param {Array} domain
 * @returns {Array}
 */
var getHour = function getHour(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var nextHour = date.getHours() + 1;
    newDate.setHours(nextHour);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        nextHour = newDate.getHours() + 1;
        newDate.setHours(nextHour);
    }

    return dateArr;
};

/**
 * Gets the first visible tick from the ticks array.
 * @param {D3 Selection} allTicks Must contain a selection of ticks. Required.
 * @returns {D3 Selection}
 */
var getNextVisible = function getNextVisible(allTicks) {
    var next;
    allTicks.each(function () {
        var el = d3.select(this);
        if (!next && el.style("display") !== "none") {
            next = el;
        }
    });

    return next || d3.select();
};

/**
 * Used to make the domain symmetrical bc line chart doesn't use calculateDomain method in Core
 * @method makeSymmetrical
 * @param {Array} domain containing min and max values
 */
Helper.prototype.makeSymmetrical = function (arr) {
    var p0 = arr[0] < 0 ? arr[0] * -1 : arr[0];
    var p1 = arr[1] < 1 ? arr[1] * -1 : arr[1];

    if (p0 > p1) {
        return [p0 * -1, p0];
    } else {
        return [p1 * -1, p1];
    }
},

/**
 * Sets the x axis ticks funtion depending on the timeline level.
 * @method helperSetTicks
 * @param {Boolean} smallScreen
 */
Helper.prototype.helperSetTicks = function (smallScreen) {
    var timelineLevel = this.get("timelineLevel");
    var greyBandLevel = LEVEL_MAPPER[timelineLevel];

    var xTicks = getTickParameters(timelineLevel, smallScreen);

    var subLabelFormat = YEAR_FORMAT;

    this.set("_xTicks", xTicks);
    this.set("subLabelFormat", subLabelFormat);
    this.set("greyBandLevel", greyBandLevel);
};

/**
 * Sets the x axis sub labels array.
 * @method helperSetSublabels
 */
Helper.prototype.helperSetSublabels = function () {
    var axes = this.get("canvas").get("axesGroup");
    var xDomain = this.get("xDomain");
    var subLabelFormat = this.get("subLabelFormat") || "%Y";

    var ticks = [];
    var subLabels = [];
    var previous = d3.time.format(subLabelFormat)(xDomain[0]);

    axes.selectAll(".mbc-axis-x .tick").each(function (d) {
        ticks.push(d);
    });

    ticks.forEach(function (tick) {
        var formatted = d3.time.format(subLabelFormat)(tick);
        if (previous === formatted) {
            subLabels.push(null);
        } else {
            subLabels.push(formatted);
            previous = formatted;
        }
    });

    this.set("xSubLabels", subLabels);
};

/**
 * Adds the first and last date x axes ticks.
 * @method helperAddFirstLabel
 * @param {Canvas} canvas Canvas containing the chart.
 */
Helper.prototype.helperAddFirstLabel = function (canvas) {

    var xDomain = this.get("xDomain");
    var subLabelFormat = d3.time.format(this.get("subLabelFormat") || YEAR_FORMAT);
    var yPadding = this.get("yPadding");
    var xTickFormat = this.get("_xTickFormat");
    var axes = canvas.get("axesGroup").select(".mbc-axis-x");
    var xAxisOrient = this.get("xAxisOrient");
    var xScale = this.get("scales").scale("x");
    var allTicks, firstTick, lastTick, tick, tickLast, firstRect, lastRect, tickRect, x, showLastSublabel, lastSublabel, diff;

    axes.selectAll("g.artificial").remove();
    allTicks = axes.selectAll(".tick").filter(function () {
        return !d3.select(this).classed("artificial");
    }).style("display", "");

    firstTick = getNextVisible(allTicks); //allTicks.first();
    lastTick = allTicks.last();

    // First one
    tick = axes.append("g").classed({
        tick: true,
        artificial: true,
        first: true
    }).attr("transform", "translate(0, 0)");

    tick.append("text").attrs({
        x: yPadding,
        y: xAxisOrient === "bottom" ? 3 : -3,
        "text-anchor": "start",
        dy: xAxisOrient === "bottom" ? ".71em" : "0em"
    }).text(xTickFormat(xDomain[0]));
    tick.append("text").text(subLabelFormat(xDomain[0])).attr("transform", function () {
        var y = xAxisOrient === "bottom" ? 28 : -18;
        return "translate(" + yPadding + ", " + y + ")";
    }).attr("class", "mbc-tick-abbreviation");

    if (!firstTick.empty()) {
        firstRect = firstTick.node().getBoundingClientRect();
        tickRect = tick.node().getBoundingClientRect();

        if (Math.abs(firstRect.left - tickRect.left) < tickRect.width + 10) {
            firstTick.style("display", "none");
        }
    }

    // Last Tick
    if (!lastTick.empty()) {
        lastRect = lastTick.node().getBoundingClientRect();
        x = canvas.width() - yPadding * 2;

        tickLast = axes.append("g").classed({
            tick: true,
            artificial: true,
            last: true
        }).attr("transform", "translate(" + x + ", 0)");

        tickLast.append("text").attrs({
            x: yPadding,
            y: xAxisOrient === "bottom" ? 3 : -3,
            "text-anchor": "end",
            dy: xAxisOrient === "bottom" ? ".71em" : "0em",
            class: "mbc-tick-label"
        }).text(xTickFormat(xDomain[1]));

        lastSublabel = tickLast.append("text").text(subLabelFormat(xDomain[1])).attrs({
            class: "mbc-tick-abbreviation",
            "text-anchor": "end",
            transform: function transform() {
                var y = xAxisOrient === "bottom" ? 28 : -18;
                return "translate(" + yPadding + ", " + y + ")";
            }
        });

        diff = tickLast.select(".mbc-tick-label").node().getBoundingClientRect().width - tickLast.select(".mbc-tick-abbreviation").node().getBoundingClientRect().width - 1;

        lastSublabel.attr("dx", diff * -1 + "px");

        tickRect = tickLast.node().getBoundingClientRect();

        showLastSublabel = lastTick[0][0].__data__.getYear() !== xDomain[1].getYear();
        if (xScale(lastTick[0][0].__data__) + lastRect.width - 2 > canvas.width() - yPadding) {
            lastTick.style("display", "none");
            showLastSublabel = lastTick[0][0].previousSibling && lastTick[0][0].previousSibling.__data__.getYear() !== xDomain[1].getYear();
        }

        if (!showLastSublabel) {
            lastSublabel.style("display", "none");
        } else {
            lastSublabel.style("display", "");
        }

        tickLast.style("display", "none");
    }
};

/**
 *
 * @method helperGetBackgroundArray
 * @param {Array} domain Chart domain.
 * @param {String} period Time period to generate the array for the background.
 * @returns {Array} Array containing the dates for each period within the domain.
 */
Helper.prototype.helperGetBackgroundArray = function (domain) {
    var period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "quarter";

    var datesArray;
    switch (period) {
        case "year":
            datesArray = getYear(domain);
            break;
        case "quarter":
            datesArray = getQuarter(domain);
            break;
        case "month":
            datesArray = getMonth(domain);
            break;
        case "week":
            datesArray = getWeek(domain);
            break;
        case "day":
            datesArray = getDay(domain);
            break;
        case "hour":
            datesArray = getHour(domain);
            break;
        default:
            break;
    }
    return datesArray;
};

/**
 * @method helperXBuffer
 * @desc set buffer for xAxis
 * @param {Date} original - original date to be buffered
 * @param {Object} options - options for how much to buffer
 * @example
 *  this.helperXBuffer(new Date(), {level: 'hour', amount: 5})
 *
 * @return {Date} buffered date object
 */
Helper.prototype.helperXBuffer = function (original, options) {
    var level = LEVEL_MAPPER[options.level];
    var buffered;

    if (typeof d3.time[level] === "function") {
        buffered = d3.time[level].offset(original, options.amount);
    }

    return (typeof buffered === "undefined" ? "undefined" : _typeof(buffered)) === "object" ? buffered : original;
};

/**
 * @method sortDataByEndValue
 * @desc sort data by series end value
 * @example {Array} data
 *  [{name: "name", index: "2", endValue: 1345.002}, ...]
 * @return {Array} data
 */
Helper.prototype.sortDataByEndValue = function (data) {
    // tooltip items' order, legend items' order
    var linesOrder = this.get("linesOrder");
    data.sort(function (a, b) {
        var value = b.value - a.value;
        if (linesOrder === 'asc') {
            return -value;
        } else if (linesOrder === 'desc') {
            return value;
        } else {
            return 0;
        }
    });

    return data;
};

/**
 * @method getValidEndValue
 * @desc get valid end value of lines
 * @param {Array} series
 */
Helper.prototype.getValidEndValue = function (series) {
    var endValue;
    if (!series || !(series instanceof Array && series.length)) {
        return;
    }
    for (var i = series.length - 1; i >= 0; i--) {
        var value = series[i].value;
        if (value != null) {
            endValue = value;
            break;
        }
    }
    return endValue;
};

module.exports = Helper;

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Core = __webpack_require__(0);
var Legend = __webpack_require__(4);
var Tooltip = __webpack_require__(91);
var Helper = __webpack_require__(92);

var Chart = Core.Chart;
var Utils = Core.Utils;
var Classes = Core.Classes;

/**
 * Time Series Line Chart.
 *
 * @example
 * // Extension example:
 * var TimeSeriesLineChart = require("mbc-time-series-line-chart");
 *
 * var newExtendedTimeSeriesLineChart = TimeSeriesLineChart.extend({
 *   ...
 * });
 *
 * @examples
 * // Use example:
 * var TimeSeriesLineChart = require("mbc-time-series-line-chart");
 *
 * var timeSeries = new TimeSeriesLineChart(<options>);
 * d3Container.datum(data).call(timeSeries.init());
 *
 * @class
 * @extends Chart
 */
var TimeSeriesLineChart = Chart.extend(Helper, Legend, Tooltip,
/**
 * @lends TimeSeriesLineChart.prototype
 **/
{
    id: "mbc-time-series-line-chart", // Also used as class for this chart type.
    /** @type {Number} */
    screenMinHeight: 100, // container min-height
    breakpoint: 650,
    smallBreakpoint: 400,
    legend: true,
    legendMaxWidth: 150,
    legendPosition: "right",
    ticksNumber: 4,
    tickValues: null,
    xAxisOrient: "bottom",
    xDomain: null,
    xDomainDataset: "x",
    y1DomainDataset: "y1",
    y2DomainDataset: "y2",
    y1Abbreviation: null,
    y1AxisLabel: false,
    y1AxisOrient: "left",
    y1TickValues: null,
    y1TicksAlign: "right",
    y1TickFormat: ",.2f",
    y1TickSymbol: "$",
    y1Bubbled: false,
    y1Symmetrical: false,
    y2Abbreviation: null,
    y2AxisLabel: false,
    y2AxisOrient: "left",
    y2TickValues: null,
    y2TicksAlign: "right",
    y2TickFormat: ",.2f",
    y2TickSymbol: "$",
    y2Bubbled: false,
    y2Symmetrical: false,
    lineStrokeWidth: 2,
    dottedDashDimensions: "1, 5",
    bubbleRadius: 4,
    bubbleStrokeWidth: 2,
    yAxesLabelWidth: 20,
    yAxesLabelPadding: 6,
    yAxesSpacing: 5,
    yDomain: null,
    yPadding: 12,
    yPaddingBig: 12,
    yPaddingSmall: 6,
    yTickMargin: 6,
    yTickSize: 35,
    xTickFormat: null,
    xTicks: null, // Optional now and exclusive with timelineLevel for legacy
    xTickSize: null,
    showLegendValues: false, // Boolean
    greyBandLevel: null,
    timelineLevel: null, // year, quarter, month, week, day. Exclusive with xTicks
    firstTickDate: true, // true or false
    xAxisBuffer: null, // Optional Object
    xAxisStart: null, //Optional Date Object
    xAxisEnd: null, // Optional Date Object
    legendValueFont: "bold 18px helvetica neue",
    legendLabelFont: "14px helvetica neue",
    linesOrder: null, // asc/desc/null, will be used to sort the items order in legend and tooltip by the end value of series line
    dottedLines: [], //set dotted line key, such as ['line1Key','line2Key']
    /**
     * Prepare the data for the chart.
     * @method setData
     * @param {Object} data
     */
    setData: function setData(data) {
        var dataManager = this.get("data");
        var y1DomainDataset = this.get("y1DomainDataset");
        var y2DomainDataset = this.get("y2DomainDataset");
        var parseFormat = this.get("parseFormat") || null;

        /* set up lines in y1 and y2 groups */
        var y1Lines = d3.nest().key(function (d) {
            return d.name;
        }).entries(data[y1DomainDataset]);

        y1Lines.forEach(function (line) {
            line.values.forEach(function (segment) {
                if (parseFormat && _typeof(segment.date) !== "object") {
                    segment.date = parseFormat(segment.date);
                }
            });

            dataManager.set(line.key, line.values, y1DomainDataset);
        });

        if (this.get("y2")) {
            var y2Lines = d3.nest().key(function (d) {
                return d.name;
            }).entries(data[y2DomainDataset]);

            y2Lines.forEach(function (line) {
                line.values.forEach(function (segment) {
                    if (parseFormat && _typeof(segment.date) !== "object") {
                        segment.date = parseFormat(segment.date);
                    }
                });

                dataManager.set(line.key, line.values, y2DomainDataset);
            });
        }

        this.setParsers();
    },
    /**
     * @method checkForDataIslands
     * @param {Array} data
     * @param {String} yAxis
     * @desc Determine if dataset includes any datapoints surrounded by null or undefined values
     * @return undefined
     */
    checkForDataIslands: function checkForDataIslands(data, yAxis) {
        var hasIslands = false;
        var indexes = [];
        var vals = data[0].series;
        for (var i = 0; i < vals.length; i++) {
            var lastVal = vals[i - 1] ? vals[i - 1].value : null,
                // vals[0-1] === undefined
            nextVal = vals[i + 1] ? vals[i + 1].value : null; // vals[(vals.length-1)+1] === undefined
            if (vals[i].value != null && lastVal == null && nextVal == null) {
                indexes.push(i);
                hasIslands = true;
            }
        }

        if (hasIslands) {
            this.drawIslandBubbles(data, indexes, yAxis);
        }
    },
    /**
     * @method drawIslandBubbles
     * @param {Array} data
     * @param {Array} indexes
     * @param {String} yAxis
     * @desc Render bubble dots for datapoints that are islands, i.e., surrounded by null or undefined values
     * @return undefined
     */
    drawIslandBubbles: function drawIslandBubbles(data, indexes, yAxis) {

        var _this = this;
        var scales = this.get("scales");
        var xScale = scales.scale("x");
        var yScale = scales.scale(yAxis);
        var canvas = this.get("canvas");
        var layer = canvas.layer("line-chart-layer");
        var dottedLines = this.get('dottedLines');
        var agileStyle = this.get("agileStyle");
        var bubbles;

        data.forEach(function (item) {
            bubbles = layer.selectAll("circle").filter("." + item.groupName + "_" + item.groupIndex).data(item.series);
            bubbles.attr("class", item.groupName + "_" + item.groupIndex + " bubble").attr("cx", function (d) {
                return xScale(d.date);
            }).attr("cy", function (d, i) {
                return yScale(d.value) - 1;
            }).attr("r", agileStyle.bubbleRadius).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", function () {
                return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
            }).attr("opacity", function (d, i) {
                if (indexes.indexOf(i) > -1) {
                    return 1;
                } else {
                    return 0;
                }
            });

            bubbles.enter().append('circle').attr("class", item.groupName + "_" + item.groupIndex + " bubble").attr("cx", function (d) {
                return xScale(d.date);
            }).attr("cy", function (d, i) {
                return yScale(d.value) - 1;
            }).attr("r", agileStyle.bubbleRadius).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", function () {
                return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
            }).attr("opacity", function (d, i) {
                if (indexes.indexOf(i) > -1) {
                    return 1;
                } else {
                    return 0;
                }
            });

            bubbles.exit().remove();
        });
    },

    /**
     * @method setParsers
     * @desc Set default or user-specific parsers for datasets
     * @example
     * chart.setParsers()
     *
     *
     * @return undefined
     */
    setParsers: function setParsers() {
        var dataManager = this.get("data");
        var y1DomainDataset = this.get("y1DomainDataset");
        var y2DomainDataset = this.get("y2DomainDataset");
        var parseFormat = this.get("parseFormat") || null;
        var y1Parser = this.get("y1Parser");
        var y2Parser = this.get("y2Parser");
        var useDefaultParsers = this.get("useDefaultParsers");
        var y2 = this.get("y2");

        var defaultParser = function defaultParser(data) {

            var map = data.map(function (line) {
                line.series.forEach(function (segment) {
                    if (parseFormat && _typeof(segment.date) !== "object") {
                        segment.date = parseFormat(segment.date);
                    }
                });

                var sorted = line.series.sort(function (a, b) {
                    return a.date - b.date;
                });

                line.series = sorted;
                return line;
            });

            return map;
        };

        if (useDefaultParsers) {
            dataManager.parser(y1DomainDataset, defaultParser);
            dataManager.parser(y2DomainDataset, defaultParser);
        }

        if (y1Parser && !useDefaultParsers) {
            dataManager.parser(y1DomainDataset, y1Parser.bind(this));
        }

        if (y2 && y2Parser && !useDefaultParsers) {
            dataManager.parser(y2DomainDataset, y2Parser.bind(this));
        }
    },

    /**
     * @override
     * Set the tickSize, axesSpacing, padding, and margin
     */
    beforeDraw: function beforeDraw() {
        this.redoCanvas();
        this.checkBreakpoints();
        var canvas = this.get("canvas");
        var y1LabelText = this.get("y1AxisLabel");
        var y2LabelText = this.get("y2AxisLabel");
        var yAxesLabelWidth = this.get("yAxesLabelWidth");
        var xTicks = this.get("xTicks");
        var xTickFormat = this.get("xTickFormat");
        var smallScreen = canvas.get("outerWidth") <= this.get("breakpoint");

        if (!y1LabelText && !y2LabelText) {
            canvas.set("yAxesLabelWidth", 0);
        } else {
            canvas.set("yAxesLabelWidth", yAxesLabelWidth);
        }

        canvas.set("tickSize", this.get("yTickSize"));
        canvas.set("axesSpacing", this.get("yAxesSpacing"));
        canvas.set("margin", this.getMargins());

        if (!this.get("y2")) {
            this.get("axes").remove("y2");
        }

        if (smallScreen) {
            this.set("yPadding", this.get("yPaddingSmall"));
        } else {
            this.set("yPadding", this.get("yPaddingBig"));
        }

        // xTicks Legacy
        if (xTicks) {
            this.set("_xTicks", xTicks); // Private variable
        } else {
            if (!this.get("timelineLevel")) {
                this.set("timelineLevel", "year");
            }

            this.helperSetTicks(smallScreen);
        }

        if (!xTickFormat && !xTicks) {
            this.set("_xTickFormat", d3.time.format("%Y"));
        }

        if (!xTickFormat && this.get("timelineLevel")) {
            this.set("_xTickFormat", d3.time.format("%b %e"));
        } else {
            this.set("_xTickFormat", xTickFormat);
        }

        if (this.get("legend")) {
            this.invokeLegend({
                chart: "time-series",
                data: this.get('data')._data,
                mouseover: false
            });
        }
    },

    /**
     * @override
     * Visual adjustments after the chart has been rendered
     */
    afterDraw: function afterDraw(options) {
        var canvas = this.get("canvas");
        var axes = canvas.get("axesGroup");
        var noTicksRecalc = options && options.noTicksRecalc;
        var tinyScreen = canvas.get("outerWidth") <= this.get("smallBreakpoint");
        var xSubLabels = this.get("xSubLabels");
        var xOriginalTicks, lastTick;
        var showLegend = this.get("legend");

        this.adjustYLabels();

        var xTicks = axes.selectAll("." + Classes.AXIS + "-x text");

        xTicks.style("text-anchor", "start");

        if (showLegend) {
            canvas.watch("outerWidth", function (newValue, oldValue) {
                this.checkBreakpoints(newValue, oldValue);
            }.bind(this));
        }

        if (!noTicksRecalc) {
            this.updateTickWidths();
        }
        if (this.get("timelineLevel") && this.get("firstTickDate")) {
            this.helperAddFirstLabel(canvas);
        }

        if (Array.isArray(xSubLabels) && xSubLabels.length || this.get("timelineLevel")) {
            this.appendAxisSubLabels();
        }

        lastTick = axes.select("." + Classes.AXIS + "-x g.tick.last");
        if (tinyScreen) {
            xOriginalTicks = axes.selectAll("." + Classes.AXIS + "-x g.tick").filter(function () {
                return !d3.select(this).classed("artificial");
            });

            xOriginalTicks.style("opacity", 0);
            lastTick.style("display", "inline");
        } else {
            lastTick.style("display", "none");
        }

        this.renderToolTip();

        if (this.get("legend")) {
            this.adjustLegendHeight();
        }
    },

    /**
     * @method appendAxisSubLabels
     * @desc Appends axis Sub Labels
     */
    appendAxisSubLabels: function appendAxisSubLabels() {
        var canvas = this.get("canvas");
        var axes = canvas.get("axesGroup");
        var xAxis = axes.selectAll("." + Classes.AXIS + "-x g.tick");
        var xSubLabels = this.get("xSubLabels");
        var xAxisOrient = this.get("xAxisOrient");

        xAxis[0].forEach(function (tick, idx) {
            if (xSubLabels[idx]) {
                d3.select(tick).append("text").text(function () {
                    return xSubLabels[idx];
                }).attr("transform", function () {
                    var y = xAxisOrient === "bottom" ? 28 : -18;
                    return "translate(0, " + y + ")";
                }).attr("class", "mbc-tick-abbreviation");
            }
        });
    },

    /**
     * @method updateTickWidths
     * @desc calculate and update the y axis tick width
     * @example
     *
     * chart.updateTickWidths()
     *
     *
     * @return undefined
     */
    updateTickWidths: function updateTickWidths() {
        var maxWidth = 0;
        var ticks = [];
        var el;

        d3.selectAll(".mbc-axis.mbc-axis-y1 .tick text").each(function () {
            el = d3.select(this);
            ticks.push(el.text());
        });
        maxWidth = Utils.svg.getGreaterSVGTextWidth(this.get("canvas").get("svg"), ticks);
        this.set("yTickSize", maxWidth + this.get("yTickMargin"));
        this.set("ticksUpdated", true);
        this.update({ noTicksRecalc: true });
    },

    /**
     * @override
     * @method draw
     */
    draw: function draw() {
        this.buildScales();
        this.buildAxes();
        this.drawAxes();
        this.drawLines();
        this.drawBubbles();
        this.drawBackgroundBars();
        this.drawGrid();
        this.drawClipPath();

        if (this.get("timelineLevel")) {
            this.helperSetSublabels();
        }
    },

    /**
     * @method drawLines
     * @desc Graph the lines onto the chart for each dataset (y1 and y2 if used)
     * @example
     *
     * chart.drawLines()
     *
     * @return undefined
     */
    drawLines: function drawLines() {
        var _this = this;
        var dataManager = this.get("data");
        var scales = this.get("scales");
        var canvas = this.get("canvas");
        var layer = canvas.layer("line-chart-layer");
        var xScale = scales.scale("x");
        var yScale = scales.scale("y1");
        var y2Scale = scales.scale("y2");
        var isY2 = false;
        var dottedLines = this.get('dottedLines');
        var agileStyle = this.calculateAgileStyle();

        var generateLine = d3.svg.line().defined(function (d) {
            return d.value != null;
        }).x(function (d) {
            return xScale(d.date);
        }).y(function (d) {
            return isY2 === false ? yScale(d.value) - 1 : y2Scale(d.value) - 1; // compensate for line thickness
        }).interpolate("linear");

        var y1DomainDataset = this.get("y1DomainDataset");

        //clear old lines on update
        var y1Lines = layer.selectAll("path").filter(".y1").data(dataManager.get(y1DomainDataset));
        this.checkForDataIslands(dataManager.get(y1DomainDataset), "y1");

        y1Lines.classed({
            line: true,
            y1: true
        }).attr("d", function (d) {
            return generateLine(d.series);
        }).attr("stroke", function (d) {
            return _this.color(d.index);
        }).attr("stroke-dasharray", function (d) {
            return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
        }).attr("stroke-linecap", function (d) {
            return dottedLines.indexOf(d.name) > -1 ? "round" : null;
        }).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

        y1Lines.enter().append("path").classed({
            line: true,
            y1: true
        }).attr("d", function (d) {
            return generateLine(d.series);
        }).attr("stroke", function (d) {
            return _this.color(d.index);
        }).attr("stroke-dasharray", function (d) {
            return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
        }).attr("stroke-linecap", function (d) {
            return dottedLines.indexOf(d.name) > -1 ? "round" : null;
        }).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

        y1Lines.exit().remove();

        if (this.get("y2")) {
            isY2 = true;
            var y2DomainDataset = this.get("y2DomainDataset");
            var y2Lines = layer.selectAll("path").filter(".y2").data(dataManager.get(y2DomainDataset));

            this.checkForDataIslands(dataManager.get(y2DomainDataset), "y2");

            y2Lines.classed({
                line: true,
                y2: true
            }).attr("d", function (d) {
                return generateLine(d.series);
            }).attr("stroke", function (d) {
                return _this.color(d.index);
            }).attr("stroke-dasharray", function (d) {
                return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
            }).attr("stroke-linecap", function (d) {
                return dottedLines.indexOf(d.name) > -1 ? "round" : null;
            }).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

            y2Lines.enter().append("path").classed({
                line: true,
                y2: true
            }).attr("d", function (d) {
                return generateLine(d.series);
            }).attr("stroke", function (d) {
                return _this.color(d.index);
            }).attr("stroke-dasharray", function (d) {
                return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
            }).attr("stroke-linecap", function (d) {
                return dottedLines.indexOf(d.name) > -1 ? "round" : null;
            }).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

            y2Lines.exit().remove();
        }
    },

    /**
    * @method calculateAgileStyle
    * @desc Calculate agile style for chart based on container size
    * @return {Object} the agile style for chart.
    */
    calculateAgileStyle: function calculateAgileStyle() {
        var xScale = this.get("scales").scale("x");
        var xDomain = this.get("xDomain");
        var yPadding = this.get("yPadding");
        var bandLevel = this.get("greyBandLevel");
        var tickArr;
        if (bandLevel) {
            tickArr = this.helperGetBackgroundArray(xDomain, bandLevel);
        } else {
            tickArr = xScale.ticks.apply(this, this.get("xTicks"));
        }

        var bubbleSpacing = (this.get("canvas").get('width') - yPadding) / tickArr.length;

        var bubbleRadius = this.get("bubbleRadius"); // default: 4
        var lineStrokeWidth = this.get("lineStrokeWidth"); // default: 2
        var bubbleStrokeWidth = this.get("bubbleStrokeWidth"); // default: 2
        var dottedDashDimensions = this.get("dottedDashDimensions"); // default: "1, 5"

        var showBigBubbleMinWidth = 2 * (bubbleRadius + 4); // 4px: dot marging
        var showSmallBubbleMinWidth = 2 * (bubbleRadius / 2 + 2); // 2px: dot marging

        var agileStyle;
        if (bubbleSpacing >= showBigBubbleMinWidth) {
            agileStyle = {
                dottedDashDimensions: dottedDashDimensions,
                lineStrokeWidth: lineStrokeWidth,
                bubbleRadius: bubbleRadius,
                bubbleStrokeWidth: bubbleStrokeWidth,
                bubbleHeight: bubbleRadius,
                bubbleOpacity: 1
            };
        } else if (bubbleSpacing >= showSmallBubbleMinWidth) {
            agileStyle = {
                dottedDashDimensions: "1, 3",
                lineStrokeWidth: lineStrokeWidth / 2,
                bubbleRadius: bubbleRadius / 2,
                bubbleStrokeWidth: bubbleStrokeWidth / 2,
                bubbleHeight: bubbleRadius / 2,
                bubbleOpacity: 1
            };
        } else {
            agileStyle = {
                dottedDashDimensions: "1, 3",
                lineStrokeWidth: lineStrokeWidth / 2,
                bubbleRadius: bubbleRadius / 2,
                bubbleStrokeWidth: bubbleStrokeWidth / 2,
                bubbleHeight: bubbleRadius / 2,
                bubbleOpacity: 0
            };
        }
        this.set("agileStyle", agileStyle);
        return agileStyle;
    },

    /**
     * @method drawBubbles
     * @desc Graph the bubbles onto the line for each dataset (y1 and y2 if used)
     * @example
     *
     * chart.drawBubbles()
     *
     * @return undefined
     */
    drawBubbles: function drawBubbles() {
        var dataManager = this.get("data");
        var scales = this.get("scales");
        var y1Bubbled = this.get("y1Bubbled");
        var y2Bubbled = this.get("y2Bubbled");

        if (y1Bubbled) {
            var y1DomainDataset = this.get("y1DomainDataset");
            var y1LinesData = dataManager.get(y1DomainDataset);
            var yScale = scales.scale("y1");
            this.generateBubbles(y1LinesData, yScale);
        }

        if (this.get("y2") && y2Bubbled) {
            var y2DomainDataset = this.get("y2DomainDataset");
            var y2LinesData = dataManager.get(y2DomainDataset);
            var y2Scale = scales.scale("y2");
            this.generateBubbles(y2LinesData, y2Scale);
        }
    },

    /**
     * @method generateBubbles
     * @param   {Object} linesData
     * @param   {Function} yScale
     * @desc Render the bubble dots for each datapoint
     * @return undefined
     */
    generateBubbles: function generateBubbles(linesData, yScale) {
        var _this = this;
        var scales = this.get("scales");
        var xScale = scales.scale("x");
        var canvas = this.get("canvas");
        var layer = canvas.layer("line-chart-layer").attr("clip-path", "url(#mbc-time-series-clip-mask)");
        var dottedLines = this.get('dottedLines');
        var agileStyle = this.get('agileStyle');
        var bubbles;
        linesData.forEach(function (item) {
            bubbles = layer.selectAll("circle").filter("." + item.groupName + "_" + item.groupIndex).data(item.series);
            bubbles.attr("class", function (d) {
                return item.groupName + "_" + item.groupIndex + " bubble line-bubbles date" + d.date.getTime();
            }).attr("cx", function (d) {
                return xScale(d.date);
            }).attr("cy", function (d, i) {
                return yScale(d.value) - 1;
            }).attr("r", function (d) {
                return d.value == null ? 0 : agileStyle.bubbleRadius;
            }).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.bubbleStrokeWidth).attr("fill", function () {
                return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
            }).attr("opacity", function (d) {
                if (d.value == null || !agileStyle.bubbleOpacity) {
                    return 0;
                }
            });

            bubbles.enter().append('circle').attr("class", function (d) {
                return item.groupName + "_" + item.groupIndex + " bubble line-bubbles date" + d.date.getTime();
            }).attr("cx", function (d) {
                return xScale(d.date);
            }).attr("cy", function (d, i) {
                return yScale(d.value) - 1;
            }).attr("r", function (d) {
                return d.value == null ? 0 : agileStyle.bubbleRadius;
            }).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.bubbleStrokeWidth).attr("fill", function () {
                return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
            }).attr("opacity", function (d) {
                if (d.value == null || !agileStyle.bubbleOpacity) {
                    return 0;
                }
            });

            bubbles.exit().remove();
        });
    },

    /**
     * @method drawAxes
     * @desc Call on the canvas to draw the axes and calls to build the labels
     * @example
     *
     * chart.drawAxes()
     *
     * @return undefined
     */
    drawAxes: function drawAxes() {
        var axes = this.get("axes");
        var canvas = this.get("canvas");

        canvas.drawAxes(axes);
        this.drawAxesLabels();
    },

    /**
     * @method drawAxesLabels
     * @desc Invoke the appendLabel method with the label text set in config and the correct axis layer
     *
     * chart.drawAxesLabels()
     *
     * @return undefined
     */
    drawAxesLabels: function drawAxesLabels() {
        var canvas = this.get("canvas");
        var y1LabelText = this.get("y1AxisLabel");
        var y2LabelText = this.get("y2AxisLabel");

        canvas.layer(Classes.AXES + "-labels").remove();

        var layer = canvas.layer(Classes.AXES + "-labels");
        var y1Orient = this.get("y1AxisOrient");
        var y2Orient = this.get("y2AxisOrient");
        var containerTop = d3.select(".mbc-chart-legend.mbc-chart-legend-top");
        var innerContainerRight = d3.select(".mbc-chart-legend-right-inner-div");
        var oneRight = (y1Orient === "right" || y2Orient === "right") && (y1Orient !== "right" || y2Orient !== "right");
        var zeroRight = y1Orient !== "right" && y2Orient !== "right";
        var twoRight = y1Orient === "right" && y2Orient === "right";

        if (y1LabelText) {
            this.appendYLabel(layer, "y1", y1LabelText);
        }

        if (this.get("y2") && y2LabelText) {
            this.appendYLabel(layer, "y2", y2LabelText);
        }

        if (y1LabelText || y2LabelText) {
            if (zeroRight || oneRight) {
                containerTop.style("margin-left", "20px");
            }
        }

        if (oneRight || twoRight) {
            innerContainerRight.style("margin-left", "12px");
        }
    },

    /**
     * @method drawGrid
     * @desc Draw the grid lines with the y axis ticks
     * @example
     *
     * chart.drawGrid()
     *
     * @return undefined
     */
    drawGrid: function drawGrid() {
        var scales = this.get("scales");
        var y1Scale = scales.scale("y1");
        var y1Axis = this.get("axes").axis("y1");
        var yPadding = this.get("yPadding");
        var canvas = this.get("canvas");
        var tickValues = y1Axis.tickValues();
        var backGroup = canvas.get("backGroup");
        var grid = backGroup.selectAll("." + Classes.GRID_LINE).data(tickValues);
        var isSmallHeight = this.get("canvas").height() <= this.get("screenMinHeight");

        var extractor = function extractor(d) {
            return y1Scale(d);
        };

        grid.enter().append("line").attrs({
            x1: yPadding,
            x2: canvas.width() - yPadding,
            y1: extractor,
            y2: extractor,
            class: function _class(d, i) {
                var appendClass = "";
                if (i === 0) {
                    appendClass = "first";
                }
                if (i === tickValues.length - 1) {
                    appendClass = "last";
                }
                return Classes.GRID_LINE + " " + appendClass;
            },
            opacity: function opacity(d, i) {
                // if container's height is small, only show first and last grid line
                return !isSmallHeight || i === 0 || i === tickValues.length - 1 ? 1 : 0;
            }
        });

        grid.attrs({
            x1: yPadding,
            x2: canvas.width() - yPadding,
            y1: extractor,
            y2: extractor,
            opacity: function opacity(d, i) {
                // if container's height is small, only show first and last grid line
                return !isSmallHeight || i === 0 || i === tickValues.length - 1 ? 1 : 0;
            }
        });

        grid.exit().remove();
    },

    /**
     * @method drawClipPath
     * @desc Chart svg includes clipping layer, clips lines and bubbles at edge of chart area
     * @example
     *
     * chart.drawClipPath()
     *
     * @return undefined
     */
    drawClipPath: function drawClipPath() {
        var canvas = this.get("canvas");
        var svg = canvas.get("svg");
        var layer = svg.select("." + Classes.BACK);
        var layerBBox = layer.node().getBBox();

        svg.insert("defs", ":first-child").append("clipPath").attr("id", "mbc-time-series-clip-mask").append("rect").attr({
            x: layerBBox.x,
            y: layerBBox.y,
            width: layerBBox.width,
            height: layerBBox.height
        });
    },

    /**
     * @method drawBackgroundBars
     * @desc Draw the alternating background bars that follow the x-axis ticks on the grid
     * @example
     *
     * chart.drawBackgroundBars()
     *
     * @return undefined
     */
    drawBackgroundBars: function drawBackgroundBars() {
        var scales = this.get("scales");
        var canvas = this.get("canvas");
        var backGroup = canvas.get("backGroup");
        var xScale = scales.scale("x");
        var xDomain = this.get("xDomain");
        var yPadding = this.get("yPadding");
        var bandLevel = this.get("greyBandLevel");
        var tickArr;

        if (bandLevel) {
            tickArr = this.helperGetBackgroundArray(xDomain, bandLevel);
        } else {
            tickArr = xScale.ticks.apply(this, this.get("xTicks"));
        }

        var bars = backGroup.selectAll("rect").data(tickArr);
        var fnWidth = function fnWidth(d, i) {
            if (i + 1 === tickArr.length) {
                return canvas.width() - yPadding - xScale(tickArr[i]);
            } else {
                return xScale(tickArr[i + 1]) - xScale(tickArr[i]);
            }
        };

        // Update Selection
        bars.attrs({
            class: "grid__bars",
            x: xScale,
            y: 0,
            height: canvas.height(),
            width: fnWidth
        }).style("overflow", "hidden");

        // Enter Selection
        bars.enter().append("rect").attrs({
            class: "grid__bars",
            x: xScale,
            y: 0,
            height: canvas.height(),
            width: fnWidth
        }).style("overflow", "hidden");

        // Exit Selection
        bars.exit().remove();
    },

    /**
     * @method buildAxes
     * @desc Build all of the axes
     * @example
     *
     * chart.buildAxes()
     *
     * @return undefined
     */
    buildAxes: function buildAxes() {
        var _this = this;
        var scales = this.get("scales");
        var axes = this.get("axes");
        var calculatedTicksY1 = Utils.getTickValues(this.get("y1Domain"), this.get("ticksNumber"));
        var y1TickValues = this.get("y1TickValues") || this.get("tickValues") || calculatedTicksY1;
        var xScale = scales.scale("x");

        var tickFormat = function tickFormat(symbol, length, formatFn) {
            return function (d, i) {
                var value = _this.tickFormat(formatFn)(d);
                value = Utils.string.convertDashToEnDash(value);
                return symbol && i === length - 1 ? symbol + value : value;
            };
        };

        var xAxis = d3.svg.axis().scale(xScale).orient(this.get("xAxisOrient")).tickSize(this.get("xTickSize")).tickFormat(this.get("_xTickFormat")).ticks.apply(this, this.get("_xTicks"));

        var yAxis = d3.svg.axis().scale(scales.scale("y1")).orient(this.get("y1AxisOrient")).tickSize(this.get("yTickSize")).tickValues(y1TickValues).tickFormat(tickFormat(this.get("y1TickSymbol"), y1TickValues.length, this.get("y1TickFormat")));

        axes.axis("x", xAxis);
        axes.axis("y1", yAxis);

        if (this.get("y2")) {
            var calculatedTicksY2 = Utils.getTickValues(this.get("y2Domain"), this.get("ticksNumber"));
            var y2TickValues = this.get("y2TickValues") || this.get("tickValues") || calculatedTicksY2;

            axes.axis("y2", d3.svg.axis().scale(scales.scale("y2")).orient(this.get("y2AxisOrient")).tickSize(this.get("yTickSize")).tickValues(y2TickValues).tickFormat(tickFormat(this.get("y2TickSymbol"), y2TickValues.length, this.get("y2TickFormat"))));
        }
    },

    /**
     * @method buildScales
     * @desc Invoke the calculateDomain method and build all of the scales
     * @example
     *
     * chart.buildScales()
     *
     * @return undefined
     */
    buildScales: function buildScales() {
        this.calculateDomain();
        var scales = this.get("scales");
        var canvas = this.get("canvas");
        var yPadding = this.get("yPadding");

        var xScale = d3.time.scale().domain(this.get("xDomain")).rangeRound([yPadding, canvas.width() - yPadding - 1]);

        var y1TickValues = this.get("y1TickValues") || this.get("tickValues");
        var y1Domain = y1TickValues ? [d3.min(y1TickValues), d3.max(y1TickValues)] : this.get("y1Domain");
        var yScale = d3.scale.linear().domain(y1Domain).range([canvas.height(), 0]);

        scales.scale("x", xScale);
        scales.scale("y1", yScale);

        if (this.get("y2")) {
            var y2TickValues = this.get("y2TickValues") || this.get("tickValues");
            var y2Domain = y2TickValues ? [d3.min(y2TickValues), d3.max(y2TickValues)] : this.get("y2Domain");
            scales.scale("y2", d3.scale.linear().domain(y2Domain).range([canvas.height(), 0]));
        }
    },

    /**
     * @method calculateDomain
     * @desc Takes the values in the datasets and calculates the domain, setting them as:
     * y1Domain, y2Domain, xDomain
     *
     * @example
     *
     * chart.calculateDomain()
     *
     * @return undefined
     */
    calculateDomain: function calculateDomain() {
        var dataManager = this.get("data");
        var y1DomainDataset = this.get("y1DomainDataset");
        var y1 = dataManager.get(y1DomainDataset);
        var y1Symmetrical = this.get("y1Symmetrical");
        var y1DataSet = [];
        var xDataSet = [];

        y1.forEach(function (dataset) {
            dataset.series.forEach(function (segment) {
                xDataSet.push(segment.date);
                y1DataSet.push(segment.value);
            });
        });

        var adjustedY1Domain = this.adjustYDomain(y1DataSet, y1Symmetrical);
        this.set("y1Domain", adjustedY1Domain);

        if (this.get("y2")) {
            var y2DomainDataset = this.get("y2DomainDataset");
            var y2 = dataManager.get(y2DomainDataset);
            var y2Symmetrical = this.get("y2Symmetrical");
            var y2DataSet = [];

            y2.forEach(function (dataset) {
                dataset.series.forEach(function (segment) {
                    xDataSet.push(segment.date);
                    y2DataSet.push(segment.value);
                });
            });

            var adjustedY2Domain = this.adjustYDomain(y2DataSet, y2Symmetrical);
            this.set("y2Domain", adjustedY2Domain);
        }

        var adjustedXDomain = this.adjustXDomain(xDataSet);

        this.set("xDomain", adjustedXDomain);
    },

    /**
     * @method  adjustXDomain
     * @desc    Calculate and return a buffer for the x domain
     *
     * @example
     *      var adjustedY1Domain = this.adjustXDomain(dataset)
     * @param   {Object} dataset
     *
     * @return  {Array} extent
     */
    adjustXDomain: function adjustXDomain(dataset) {
        // add buffer spacing between datapoints and axix
        var xAxisStart = this.get("xAxisStart");
        var xAxisBuffer = this.get("xAxisBuffer");
        var xAxisEnd = this.get("xAxisEnd");

        var extent = d3.extent(dataset);

        if (this.get("xAxisStart")) {
            extent[0] = xAxisStart;
        }

        if (this.get("xAxisEnd")) {
            extent[1] = xAxisEnd;
        }

        if (!xAxisBuffer) {
            return extent;
        }

        if (xAxisBuffer.start) {
            extent[0] = this.helperXBuffer(extent[0], xAxisBuffer.start);
        }

        if (xAxisBuffer.end) {
            extent[1] = this.helperXBuffer(extent[1], xAxisBuffer.end);
        }

        return extent;
    },

    /**
     * @method  adjustYDomain
     * @desc    Calculate and return a buffer for the y domain
     *
     * @example
     *      var adjustedY1Domain = this.adjustYDomain(dataset)
     * @param   {Object} dataset
     *
     * @return  {Array} extent
     */
    adjustYDomain: function adjustYDomain(dataset, symmetrical) {
        // add buffer spacing between datapoints and axix
        var extent = d3.extent(dataset);
        var range = extent[1] - extent[0];
        var adjusted = [Math.floor(extent[0] - range * 0.05), Math.ceil(extent[1] + range * 0.05)];
        if (symmetrical) {
            return this.makeSymmetrical(adjusted);
        }

        return adjusted;
    },

    /**
     * @method getMargins
     * @desc Calculate and return the margins for the chart
     *
     * @example
     *
     * var margins = chart.getMargins();
     * var leftMargin = margins.left;
     * @return {Object}
     */
    getMargins: function getMargins() {
        var y1AxisOrient = this.get("y1AxisOrient");
        var y2AxisOrient = this.get("y2AxisOrient");
        var yTickSize = this.get("yTickSize");
        var canvas = this.get("canvas");
        var yAxesLabelWidth = canvas.get("yAxesLabelWidth");
        var yAxesSpacing = this.get("yAxesSpacing");
        var margin = {
            top: 5,
            right: 0,
            bottom: 25,
            left: yTickSize + yAxesLabelWidth
        };

        if (this.get("y2")) {
            if (y1AxisOrient === "left" && y2AxisOrient === "left") {
                margin.left = (yTickSize + yAxesLabelWidth) * 2 + yAxesSpacing;
            } else if (y1AxisOrient === "right" && y2AxisOrient === "right") {
                margin.right = (yTickSize + yAxesLabelWidth) * 2 + yAxesSpacing;
                margin.left = 0;
            } else {
                margin.right = yTickSize + yAxesLabelWidth;
            }
        } else if (y1AxisOrient === "right") {
            margin.right = yTickSize + yAxesLabelWidth;
            margin.left = 0;
        }

        if (this.get("xAxisOrient") === "top") {
            margin.top = 30;
            margin.bottom = 0;
        } else {
            margin.top = 5;
            margin.bottom = this.get("xLabels") ? 45 : 35;
        }

        return margin;
    },

    /**
     * @method checkBreakpoints
     * @desc Checks if a set breakpoint has been met with the grid and invokes the
     * redoCanvas method if so
     * @param {Number} newValue
     * @param {Number} oldValue
     *
     * @example
     *  canvas.watch("outerWidth", function (newValue, oldValue) {
            this.checkBreakpoints(newValue, oldValue);
        }.bind(this));
      * @return undefined
     */
    checkBreakpoints: function checkBreakpoints(newValue, oldValue) {
        var dw = newValue > oldValue;
        var breakpoint = this.get("breakpoint");
        if (dw && oldValue <= breakpoint && newValue > breakpoint || !dw && oldValue > breakpoint && newValue <= breakpoint) {
            this.redoCanvas();
        }
    },

    /**
     * @method setCanvasTemplate
     * @desc set the canvas template which is used in beforeCanvas from grid core
     * @param {Number} width
     *
     * @example
     *
     *  this.setCanvasTemplate(selection[0][0].offsetWidth);
     * @return undefined
     */
    setCanvasTemplate: function setCanvasTemplate(width) {
        var template;
        if (this.get("legend")) {
            if (width > this.get("breakpoint")) {
                template = "<div class=\"" + Classes.INNER + " " + Classes.INNER + "-right\"></div>\n                    <div class=\"" + Classes.LEGEND + " " + Classes.LEGEND + "-right\"><div class=\"" + Classes.LEGEND + "-inner\"></div></div>";
            } else {
                template = "<div class=\"" + Classes.LEGEND + " " + Classes.LEGEND + "-top\"><div class=\"" + Classes.LEGEND + "-inner\"></div></div>\n                <div class=\"" + Classes.INNER + " " + Classes.INNER + "-top\"></div>";
            }
        }

        this.set("canvasTemplate", template);
    },

    // @IMPLEMENTED
    // Do something before canvas render.
    beforeCanvas: function beforeCanvas(selection) {
        this.setCanvasTemplate(selection[0][0].offsetWidth);
    },

    /**
     * @method redoCanvas
     * @desc Removes the canvas, resets the template, and then re-renders the canvas
     *
     * @example
     *
     *  chart.redoCanvas
     * @return undefined
     */
    redoCanvas: function redoCanvas() {
        var canvas = this.get("canvas");
        canvas.remove();
        this.set("initialized", false);

        this.setCanvasTemplate();
        this._createCanvas();
    },

    /**
     * Reloads all the chart's data.
     * @param {Object} dataset Initial dataset object.
     */
    data: function data(dataset) {
        this.get("data").clean();
        this.setData(dataset);
        this.redoCanvas();
        this.update();
        return this;
    },

    /**
     * @method add
     * @description Add a series to the chart
      * @param {Object} series Object {name: <name of the series>, values: <Array of values for the series>}
     * @param {String} groupName - name of the dataset group
     * @example
     * chart.add({
     *      name: "Apple Inc.",
     *      values: [{}, {}]
     * })
     * @return {this}
     */
    add: function add(name, series, groupName) {
        this.get("data").set(name, series, groupName);
        this.redoCanvas();
        this.update();

        return this;
    },

    /**
     * @method remove
     * @description Removes a series from the chart.
     * @param {String} seriesName Name of the series to remove from the chart.
     * @return {this}
     */
    remove: function remove(seriesName) {
        this.get("data").remove(seriesName);
        this.redoCanvas();
        this.update();
        return this;
    }

});

module.exports = TimeSeriesLineChart;

/***/ })

/******/ });
});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecPerformanceGraph', __webpack_require__(5).ecPerformanceGraph);
    __webpack_require__(4);
    __webpack_require__(2);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ })
/******/ ]);
//# sourceMappingURL=ec-performance-graph.js.map


// WEBPACK FOOTER //
// ./components/performance-graph/build/ec-performance-graph.js